var is = Object.defineProperty;
var os = (e, r, t) => r in e ? is(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var Pa = (e, r, t) => (os(e, typeof r != "symbol" ? r + "" : r, t), t);
import We, { createContext as Ut, useContext as Ze, useDebugValue as Dn, useLayoutEffect as lo, useEffect as Ae, useMemo as be, useCallback as Le, useState as Ir, useRef as vr, Component as us } from "react";
import { unstable_batchedUpdates as po } from "react-dom";
var ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ea(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Mn = { exports: {} }, Tr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var cn, Ta;
function vo() {
  if (Ta)
    return cn;
  Ta = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var c = {}, o = 0; o < 10; o++)
        c["_" + String.fromCharCode(o)] = o;
      var u = Object.getOwnPropertyNames(c).map(function(l) {
        return c[l];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var s = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        s[l] = l;
      }), Object.keys(Object.assign({}, s)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return cn = a() ? Object.assign : function(i, c) {
    for (var o, u = n(i), s, l = 1; l < arguments.length; l++) {
      o = Object(arguments[l]);
      for (var d in o)
        r.call(o, d) && (u[d] = o[d]);
      if (e) {
        s = e(o);
        for (var f = 0; f < s.length; f++)
          t.call(o, s[f]) && (u[s[f]] = o[s[f]]);
      }
    }
    return u;
  }, cn;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wa;
function ss() {
  if (wa)
    return Tr;
  wa = 1, vo();
  var e = We, r = 60103;
  if (Tr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var t = Symbol.for;
    r = t("react.element"), Tr.Fragment = t("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(o, u, s) {
    var l, d = {}, f = null, p = null;
    s !== void 0 && (f = "" + s), u.key !== void 0 && (f = "" + u.key), u.ref !== void 0 && (p = u.ref);
    for (l in u)
      a.call(u, l) && !i.hasOwnProperty(l) && (d[l] = u[l]);
    if (o && o.defaultProps)
      for (l in u = o.defaultProps, u)
        d[l] === void 0 && (d[l] = u[l]);
    return { $$typeof: r, type: o, key: f, ref: p, props: d, _owner: n.current };
  }
  return Tr.jsx = c, Tr.jsxs = c, Tr;
}
var fn = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ra;
function cs() {
  return Ra || (Ra = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var r = We, t = vo(), n = 60103, a = 60106;
      e.Fragment = 60107;
      var i = 60108, c = 60114, o = 60109, u = 60110, s = 60112, l = 60113, d = 60120, f = 60115, p = 60116, y = 60121, v = 60122, g = 60117, E = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var m = Symbol.for;
        n = m("react.element"), a = m("react.portal"), e.Fragment = m("react.fragment"), i = m("react.strict_mode"), c = m("react.profiler"), o = m("react.provider"), u = m("react.context"), s = m("react.forward_ref"), l = m("react.suspense"), d = m("react.suspense_list"), f = m("react.memo"), p = m("react.lazy"), y = m("react.block"), v = m("react.server.block"), g = m("react.fundamental"), m("react.scope"), m("react.opaque.id"), E = m("react.debug_trace_mode"), m("react.offscreen"), P = m("react.legacy_hidden");
      }
      var b = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
      function _(S) {
        if (S === null || typeof S != "object")
          return null;
        var $ = b && S[b] || S[h];
        return typeof $ == "function" ? $ : null;
      }
      var T = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function O(S) {
        {
          for (var $ = arguments.length, M = new Array($ > 1 ? $ - 1 : 0), Q = 1; Q < $; Q++)
            M[Q - 1] = arguments[Q];
          w("error", S, M);
        }
      }
      function w(S, $, M) {
        {
          var Q = T.ReactDebugCurrentFrame, ie = Q.getStackAddendum();
          ie !== "" && ($ += "%s", M = M.concat([ie]));
          var oe = M.map(function(X) {
            return "" + X;
          });
          oe.unshift("Warning: " + $), Function.prototype.apply.call(console[S], console, oe);
        }
      }
      var R = !1;
      function C(S) {
        return !!(typeof S == "string" || typeof S == "function" || S === e.Fragment || S === c || S === E || S === i || S === l || S === d || S === P || R || typeof S == "object" && S !== null && (S.$$typeof === p || S.$$typeof === f || S.$$typeof === o || S.$$typeof === u || S.$$typeof === s || S.$$typeof === g || S.$$typeof === y || S[0] === v));
      }
      function A(S, $, M) {
        var Q = $.displayName || $.name || "";
        return S.displayName || (Q !== "" ? M + "(" + Q + ")" : M);
      }
      function I(S) {
        return S.displayName || "Context";
      }
      function x(S) {
        if (S == null)
          return null;
        if (typeof S.tag == "number" && O("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof S == "function")
          return S.displayName || S.name || null;
        if (typeof S == "string")
          return S;
        switch (S) {
          case e.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case c:
            return "Profiler";
          case i:
            return "StrictMode";
          case l:
            return "Suspense";
          case d:
            return "SuspenseList";
        }
        if (typeof S == "object")
          switch (S.$$typeof) {
            case u:
              var $ = S;
              return I($) + ".Consumer";
            case o:
              var M = S;
              return I(M._context) + ".Provider";
            case s:
              return A(S, S.render, "ForwardRef");
            case f:
              return x(S.type);
            case y:
              return x(S._render);
            case p: {
              var Q = S, ie = Q._payload, oe = Q._init;
              try {
                return x(oe(ie));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var D = 0, q, k, U, L, H, z, Y;
      function F() {
      }
      F.__reactDisabledLog = !0;
      function K() {
        {
          if (D === 0) {
            q = console.log, k = console.info, U = console.warn, L = console.error, H = console.group, z = console.groupCollapsed, Y = console.groupEnd;
            var S = {
              configurable: !0,
              enumerable: !0,
              value: F,
              writable: !0
            };
            Object.defineProperties(console, {
              info: S,
              log: S,
              warn: S,
              error: S,
              group: S,
              groupCollapsed: S,
              groupEnd: S
            });
          }
          D++;
        }
      }
      function J() {
        {
          if (D--, D === 0) {
            var S = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: t({}, S, {
                value: q
              }),
              info: t({}, S, {
                value: k
              }),
              warn: t({}, S, {
                value: U
              }),
              error: t({}, S, {
                value: L
              }),
              group: t({}, S, {
                value: H
              }),
              groupCollapsed: t({}, S, {
                value: z
              }),
              groupEnd: t({}, S, {
                value: Y
              })
            });
          }
          D < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var W = T.ReactCurrentDispatcher, ae;
      function me(S, $, M) {
        {
          if (ae === void 0)
            try {
              throw Error();
            } catch (ie) {
              var Q = ie.stack.trim().match(/\n( *(at )?)/);
              ae = Q && Q[1] || "";
            }
          return `
` + ae + S;
        }
      }
      var Se = !1, Ee;
      {
        var he = typeof WeakMap == "function" ? WeakMap : Map;
        Ee = new he();
      }
      function N(S, $) {
        if (!S || Se)
          return "";
        {
          var M = Ee.get(S);
          if (M !== void 0)
            return M;
        }
        var Q;
        Se = !0;
        var ie = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var oe;
        oe = W.current, W.current = null, K();
        try {
          if ($) {
            var X = function() {
              throw Error();
            };
            if (Object.defineProperty(X.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(X, []);
              } catch (He) {
                Q = He;
              }
              Reflect.construct(S, [], X);
            } else {
              try {
                X.call();
              } catch (He) {
                Q = He;
              }
              S.call(X.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (He) {
              Q = He;
            }
            S();
          }
        } catch (He) {
          if (He && Q && typeof He.stack == "string") {
            for (var B = He.stack.split(`
`), Ce = Q.stack.split(`
`), pe = B.length - 1, ye = Ce.length - 1; pe >= 1 && ye >= 0 && B[pe] !== Ce[ye]; )
              ye--;
            for (; pe >= 1 && ye >= 0; pe--, ye--)
              if (B[pe] !== Ce[ye]) {
                if (pe !== 1 || ye !== 1)
                  do
                    if (pe--, ye--, ye < 0 || B[pe] !== Ce[ye]) {
                      var Ge = `
` + B[pe].replace(" at new ", " at ");
                      return typeof S == "function" && Ee.set(S, Ge), Ge;
                    }
                  while (pe >= 1 && ye >= 0);
                break;
              }
          }
        } finally {
          Se = !1, W.current = oe, J(), Error.prepareStackTrace = ie;
        }
        var Pr = S ? S.displayName || S.name : "", Oa = Pr ? me(Pr) : "";
        return typeof S == "function" && Ee.set(S, Oa), Oa;
      }
      function le(S, $, M) {
        return N(S, !1);
      }
      function j(S) {
        var $ = S.prototype;
        return !!($ && $.isReactComponent);
      }
      function Re(S, $, M) {
        if (S == null)
          return "";
        if (typeof S == "function")
          return N(S, j(S));
        if (typeof S == "string")
          return me(S);
        switch (S) {
          case l:
            return me("Suspense");
          case d:
            return me("SuspenseList");
        }
        if (typeof S == "object")
          switch (S.$$typeof) {
            case s:
              return le(S.render);
            case f:
              return Re(S.type, $, M);
            case y:
              return le(S._render);
            case p: {
              var Q = S, ie = Q._payload, oe = Q._init;
              try {
                return Re(oe(ie), $, M);
              } catch {
              }
            }
          }
        return "";
      }
      var De = {}, Ke = T.ReactDebugCurrentFrame;
      function tr(S) {
        if (S) {
          var $ = S._owner, M = Re(S.type, S._source, $ ? $.type : null);
          Ke.setExtraStackFrame(M);
        } else
          Ke.setExtraStackFrame(null);
      }
      function ct(S, $, M, Q, ie) {
        {
          var oe = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var X in S)
            if (oe(S, X)) {
              var B = void 0;
              try {
                if (typeof S[X] != "function") {
                  var Ce = Error((Q || "React class") + ": " + M + " type `" + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof S[X] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Ce.name = "Invariant Violation", Ce;
                }
                B = S[X]($, X, Q, M, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (pe) {
                B = pe;
              }
              B && !(B instanceof Error) && (tr(ie), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Q || "React class", M, X, typeof B), tr(null)), B instanceof Error && !(B.message in De) && (De[B.message] = !0, tr(ie), O("Failed %s type: %s", M, B.message), tr(null));
            }
        }
      }
      var Pe = T.ReactCurrentOwner, Ie = Object.prototype.hasOwnProperty, Vu = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, ha, ya, an;
      an = {};
      function zu(S) {
        if (Ie.call(S, "ref")) {
          var $ = Object.getOwnPropertyDescriptor(S, "ref").get;
          if ($ && $.isReactWarning)
            return !1;
        }
        return S.ref !== void 0;
      }
      function Ku(S) {
        if (Ie.call(S, "key")) {
          var $ = Object.getOwnPropertyDescriptor(S, "key").get;
          if ($ && $.isReactWarning)
            return !1;
        }
        return S.key !== void 0;
      }
      function Gu(S, $) {
        if (typeof S.ref == "string" && Pe.current && $ && Pe.current.stateNode !== $) {
          var M = x(Pe.current.type);
          an[M] || (O('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', x(Pe.current.type), S.ref), an[M] = !0);
        }
      }
      function Hu(S, $) {
        {
          var M = function() {
            ha || (ha = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $));
          };
          M.isReactWarning = !0, Object.defineProperty(S, "key", {
            get: M,
            configurable: !0
          });
        }
      }
      function Yu(S, $) {
        {
          var M = function() {
            ya || (ya = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $));
          };
          M.isReactWarning = !0, Object.defineProperty(S, "ref", {
            get: M,
            configurable: !0
          });
        }
      }
      var Wu = function(S, $, M, Q, ie, oe, X) {
        var B = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: S,
          key: $,
          ref: M,
          props: X,
          // Record the component responsible for creating this element.
          _owner: oe
        };
        return B._store = {}, Object.defineProperty(B._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(B, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Q
        }), Object.defineProperty(B, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ie
        }), Object.freeze && (Object.freeze(B.props), Object.freeze(B)), B;
      };
      function Bu(S, $, M, Q, ie) {
        {
          var oe, X = {}, B = null, Ce = null;
          M !== void 0 && (B = "" + M), Ku($) && (B = "" + $.key), zu($) && (Ce = $.ref, Gu($, ie));
          for (oe in $)
            Ie.call($, oe) && !Vu.hasOwnProperty(oe) && (X[oe] = $[oe]);
          if (S && S.defaultProps) {
            var pe = S.defaultProps;
            for (oe in pe)
              X[oe] === void 0 && (X[oe] = pe[oe]);
          }
          if (B || Ce) {
            var ye = typeof S == "function" ? S.displayName || S.name || "Unknown" : S;
            B && Hu(X, ye), Ce && Yu(X, ye);
          }
          return Wu(S, B, Ce, ie, Q, Pe.current, X);
        }
      }
      var on = T.ReactCurrentOwner, ga = T.ReactDebugCurrentFrame;
      function Or(S) {
        if (S) {
          var $ = S._owner, M = Re(S.type, S._source, $ ? $.type : null);
          ga.setExtraStackFrame(M);
        } else
          ga.setExtraStackFrame(null);
      }
      var un;
      un = !1;
      function sn(S) {
        return typeof S == "object" && S !== null && S.$$typeof === n;
      }
      function ma() {
        {
          if (on.current) {
            var S = x(on.current.type);
            if (S)
              return `

Check the render method of \`` + S + "`.";
          }
          return "";
        }
      }
      function Ju(S) {
        {
          if (S !== void 0) {
            var $ = S.fileName.replace(/^.*[\\\/]/, ""), M = S.lineNumber;
            return `

Check your code at ` + $ + ":" + M + ".";
          }
          return "";
        }
      }
      var ba = {};
      function Xu(S) {
        {
          var $ = ma();
          if (!$) {
            var M = typeof S == "string" ? S : S.displayName || S.name;
            M && ($ = `

Check the top-level render call using <` + M + ">.");
          }
          return $;
        }
      }
      function _a(S, $) {
        {
          if (!S._store || S._store.validated || S.key != null)
            return;
          S._store.validated = !0;
          var M = Xu($);
          if (ba[M])
            return;
          ba[M] = !0;
          var Q = "";
          S && S._owner && S._owner !== on.current && (Q = " It was passed a child from " + x(S._owner.type) + "."), Or(S), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', M, Q), Or(null);
        }
      }
      function Sa(S, $) {
        {
          if (typeof S != "object")
            return;
          if (Array.isArray(S))
            for (var M = 0; M < S.length; M++) {
              var Q = S[M];
              sn(Q) && _a(Q, $);
            }
          else if (sn(S))
            S._store && (S._store.validated = !0);
          else if (S) {
            var ie = _(S);
            if (typeof ie == "function" && ie !== S.entries)
              for (var oe = ie.call(S), X; !(X = oe.next()).done; )
                sn(X.value) && _a(X.value, $);
          }
        }
      }
      function Zu(S) {
        {
          var $ = S.type;
          if ($ == null || typeof $ == "string")
            return;
          var M;
          if (typeof $ == "function")
            M = $.propTypes;
          else if (typeof $ == "object" && ($.$$typeof === s || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          $.$$typeof === f))
            M = $.propTypes;
          else
            return;
          if (M) {
            var Q = x($);
            ct(M, S.props, "prop", Q, S);
          } else if ($.PropTypes !== void 0 && !un) {
            un = !0;
            var ie = x($);
            O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ie || "Unknown");
          }
          typeof $.getDefaultProps == "function" && !$.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function es(S) {
        {
          for (var $ = Object.keys(S.props), M = 0; M < $.length; M++) {
            var Q = $[M];
            if (Q !== "children" && Q !== "key") {
              Or(S), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Q), Or(null);
              break;
            }
          }
          S.ref !== null && (Or(S), O("Invalid attribute `ref` supplied to `React.Fragment`."), Or(null));
        }
      }
      function Ea(S, $, M, Q, ie, oe) {
        {
          var X = C(S);
          if (!X) {
            var B = "";
            (S === void 0 || typeof S == "object" && S !== null && Object.keys(S).length === 0) && (B += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Ce = Ju(ie);
            Ce ? B += Ce : B += ma();
            var pe;
            S === null ? pe = "null" : Array.isArray(S) ? pe = "array" : S !== void 0 && S.$$typeof === n ? (pe = "<" + (x(S.type) || "Unknown") + " />", B = " Did you accidentally export a JSX literal instead of a component?") : pe = typeof S, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", pe, B);
          }
          var ye = Bu(S, $, M, ie, oe);
          if (ye == null)
            return ye;
          if (X) {
            var Ge = $.children;
            if (Ge !== void 0)
              if (Q)
                if (Array.isArray(Ge)) {
                  for (var Pr = 0; Pr < Ge.length; Pr++)
                    Sa(Ge[Pr], S);
                  Object.freeze && Object.freeze(Ge);
                } else
                  O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Sa(Ge, S);
          }
          return S === e.Fragment ? es(ye) : Zu(ye), ye;
        }
      }
      function rs(S, $, M) {
        return Ea(S, $, M, !0);
      }
      function ts(S, $, M) {
        return Ea(S, $, M, !1);
      }
      var ns = ts, as = rs;
      e.jsx = ns, e.jsxs = as;
    }();
  }(fn)), fn;
}
process.env.NODE_ENV === "production" ? Mn.exports = ss() : Mn.exports = cs();
var Ue = Mn.exports, V = { exports: {} }, G = V.exports;
Object.defineProperty(G, "__esModule", { value: !0 });
G.SYNC_STRATEGIES = G.ProjectSerializedOut = G.ProjectSerializedIn = G.FOREIGN_TYPES = G.TAX_EXEMPTION_STATUSES = G.SHIPPING_TYPES = G.SAMPLE_TYPES = G.INFO_SOURCES = G.FULFILLMENT_METHODS = G.ProjectConfigurationSerialized = G.ProjectConfiguration = G.ProjectItem = G.Product = G.Design = G.SizeQuantity = G.CoreOrderData = G.ItemFulfillment = G.TURN_TIMES = G.DistributedOrderData = G.Project = G.ProjectKey = void 0;
class ho {
  constructor() {
    this.id = "", this.version = 0;
  }
}
G.ProjectKey = ho;
class fs extends ho {
}
G.Project = fs;
class ls {
}
G.DistributedOrderData = ls;
G.TURN_TIMES = {
  STANDARD: "STANDARD",
  QUICKER: "QUICKER",
  RUSH: "RUSH",
  SUPERRUSH: "SUPERRUSH"
  // Typically 3 days with surcharge
};
class ds {
}
G.ItemFulfillment = ds;
class ps {
}
G.CoreOrderData = ps;
class vs {
}
G.SizeQuantity = vs;
class hs {
}
G.Design = hs;
class ys {
}
G.Product = ys;
class gs {
}
G.ProjectItem = gs;
class ms {
}
G.ProjectConfiguration = ms;
class bs {
}
G.ProjectConfigurationSerialized = bs;
G.FULFILLMENT_METHODS = {
  BULK: "BULK",
  BSS: "BSS",
  FUNDRAISER: "FUNDRAISER",
  GROUPS: "GROUPS",
  STORES: "STORES"
  // Online store handled by stores
};
G.INFO_SOURCES = {
  COMMUNITY: "COMMUNITY",
  ORGANIZER: "ORGANIZER"
  // All info will be provided directly by the organizer
};
G.SAMPLE_TYPES = {
  PLA_BLANKS_SAMPLE: "pla_blanks_sample",
  PLA_PRINTED_SAMPLE: "pla_printed_sample"
};
G.SHIPPING_TYPES = {
  BULK: "BULK",
  INDIVIDUAL: "INDIVIDUAL"
  // Order will be split into multiple shipments
};
G.TAX_EXEMPTION_STATUSES = {
  NON_EXEMPT: "NON_EXEMPT",
  CLAIMED: "CLAIMED",
  EXEMPT: "EXEMPT"
  // The user has been verified as tax exempt.
};
G.FOREIGN_TYPES = {
  CORE_ORDER: "CORE_ORDER",
  GROUP_ORDER: "GROUP_ORDER"
};
class yo {
}
G.ProjectSerializedIn = yo;
class _s extends yo {
}
G.ProjectSerializedOut = _s;
G.SYNC_STRATEGIES = {
  DESIGN: "DESIGN",
  CORE_ORDER: "CORE_ORDER"
};
const go = (V.exports == null ? {} : V.exports).default || V.exports, Ss = (V.exports == null ? {} : V.exports).ProjectKey, Es = (V.exports == null ? {} : V.exports).Project, Os = (V.exports == null ? {} : V.exports).DistributedOrderData, Ps = (V.exports == null ? {} : V.exports).TURN_TIMES, Ts = (V.exports == null ? {} : V.exports).ItemFulfillment, ws = (V.exports == null ? {} : V.exports).CoreOrderData, Rs = (V.exports == null ? {} : V.exports).SizeQuantity, Cs = (V.exports == null ? {} : V.exports).Design, As = (V.exports == null ? {} : V.exports).Product, Is = (V.exports == null ? {} : V.exports).ProjectItem, xs = (V.exports == null ? {} : V.exports).ProjectConfiguration, $s = (V.exports == null ? {} : V.exports).ProjectConfigurationSerialized, Ns = (V.exports == null ? {} : V.exports).FULFILLMENT_METHODS, Ds = (V.exports == null ? {} : V.exports).INFO_SOURCES, Ms = (V.exports == null ? {} : V.exports).SAMPLE_TYPES, js = (V.exports == null ? {} : V.exports).SHIPPING_TYPES, qs = (V.exports == null ? {} : V.exports).TAX_EXEMPTION_STATUSES, ks = (V.exports == null ? {} : V.exports).FOREIGN_TYPES, Us = (V.exports == null ? {} : V.exports).ProjectSerializedIn, Ls = (V.exports == null ? {} : V.exports).ProjectSerializedOut, Fs = (V.exports == null ? {} : V.exports).SYNC_STRATEGIES, Qs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CoreOrderData: ws,
  Design: Cs,
  DistributedOrderData: Os,
  FOREIGN_TYPES: ks,
  FULFILLMENT_METHODS: Ns,
  INFO_SOURCES: Ds,
  ItemFulfillment: Ts,
  Product: As,
  Project: Es,
  ProjectConfiguration: xs,
  ProjectConfigurationSerialized: $s,
  ProjectItem: Is,
  ProjectKey: Ss,
  ProjectSerializedIn: Us,
  ProjectSerializedOut: Ls,
  SAMPLE_TYPES: Ms,
  SHIPPING_TYPES: js,
  SYNC_STRATEGIES: Fs,
  SizeQuantity: Rs,
  TAX_EXEMPTION_STATUSES: qs,
  TURN_TIMES: Ps,
  default: go
}, Symbol.toStringTag, { value: "Module" }));
var or = { exports: {} }, Br = or.exports;
Object.defineProperty(Br, "__esModule", { value: !0 });
Br.DESIGN_SERVICE_API_VERSION = Br.CURRENT_PROJECT_VERSION = void 0;
Br.CURRENT_PROJECT_VERSION = 12;
Br.DESIGN_SERVICE_API_VERSION = 5;
const mo = (or.exports == null ? {} : or.exports).default || or.exports, Vs = (or.exports == null ? {} : or.exports).CURRENT_PROJECT_VERSION, zs = (or.exports == null ? {} : or.exports).DESIGN_SERVICE_API_VERSION, Ks = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CURRENT_PROJECT_VERSION: Vs,
  DESIGN_SERVICE_API_VERSION: zs,
  default: mo
}, Symbol.toStringTag, { value: "Module" }));
var de = { exports: {} }, ge = de.exports;
Object.defineProperty(ge, "__esModule", { value: !0 });
ge.DESIGN_SERVICE_API_VERSION = ge.CURRENT_PROJECT_VERSION = ge.TURN_TIMES = ge.TAX_EXEMPTION_STATUSES = ge.SYNC_STRATEGIES = ge.SHIPPING_TYPES = ge.INFO_SOURCES = ge.FULFILLMENT_METHODS = ge.FOREIGN_TYPES = void 0;
var br = go || Qs;
Object.defineProperty(ge, "FOREIGN_TYPES", { enumerable: !0, get: function() {
  return br.FOREIGN_TYPES;
} });
Object.defineProperty(ge, "FULFILLMENT_METHODS", { enumerable: !0, get: function() {
  return br.FULFILLMENT_METHODS;
} });
Object.defineProperty(ge, "INFO_SOURCES", { enumerable: !0, get: function() {
  return br.INFO_SOURCES;
} });
Object.defineProperty(ge, "SHIPPING_TYPES", { enumerable: !0, get: function() {
  return br.SHIPPING_TYPES;
} });
Object.defineProperty(ge, "SYNC_STRATEGIES", { enumerable: !0, get: function() {
  return br.SYNC_STRATEGIES;
} });
Object.defineProperty(ge, "TAX_EXEMPTION_STATUSES", { enumerable: !0, get: function() {
  return br.TAX_EXEMPTION_STATUSES;
} });
Object.defineProperty(ge, "TURN_TIMES", { enumerable: !0, get: function() {
  return br.TURN_TIMES;
} });
var bo = mo || Ks;
Object.defineProperty(ge, "CURRENT_PROJECT_VERSION", { enumerable: !0, get: function() {
  return bo.CURRENT_PROJECT_VERSION;
} });
Object.defineProperty(ge, "DESIGN_SERVICE_API_VERSION", { enumerable: !0, get: function() {
  return bo.DESIGN_SERVICE_API_VERSION;
} });
(de.exports == null ? {} : de.exports).default || de.exports;
(de.exports == null ? {} : de.exports).FOREIGN_TYPES;
(de.exports == null ? {} : de.exports).FULFILLMENT_METHODS;
(de.exports == null ? {} : de.exports).INFO_SOURCES;
const wE = (de.exports == null ? {} : de.exports).SHIPPING_TYPES;
(de.exports == null ? {} : de.exports).SYNC_STRATEGIES;
(de.exports == null ? {} : de.exports).TAX_EXEMPTION_STATUSES;
const RE = (de.exports == null ? {} : de.exports).TURN_TIMES;
(de.exports == null ? {} : de.exports).CURRENT_PROJECT_VERSION;
const Ca = (de.exports == null ? {} : de.exports).DESIGN_SERVICE_API_VERSION;
function fe(e) {
  for (var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var a = Zs[e], i = a ? typeof a == "function" ? a.apply(null, t) : a : "unknown error nr: " + e;
    throw Error("[Immer] " + i);
  }
  throw Error("[Immer] minified error nr: " + e + (t.length ? " " + t.map(function(c) {
    return "'" + c + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Be(e) {
  return !!e && !!e[se];
}
function qe(e) {
  var r;
  return !!e && (function(t) {
    if (!t || typeof t != "object")
      return !1;
    var n = Object.getPrototypeOf(t);
    if (n === null)
      return !0;
    var a = Object.hasOwnProperty.call(n, "constructor") && n.constructor;
    return a === Object || typeof a == "function" && Function.toString.call(a) === ec;
  }(e) || Array.isArray(e) || !!e[Hr] || !!(!((r = e.constructor) === null || r === void 0) && r[Hr]) || Lt(e) || Ft(e));
}
function cr(e, r, t) {
  t === void 0 && (t = !1), fr(e) === 0 ? (t ? Object.keys : Ar)(e).forEach(function(n) {
    t && typeof n == "symbol" || r(n, e[n], e);
  }) : e.forEach(function(n, a) {
    return r(a, n, e);
  });
}
function fr(e) {
  var r = e[se];
  return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(e) ? 1 : Lt(e) ? 2 : Ft(e) ? 3 : 0;
}
function ur(e, r) {
  return fr(e) === 2 ? e.has(r) : Object.prototype.hasOwnProperty.call(e, r);
}
function mt(e, r) {
  return fr(e) === 2 ? e.get(r) : e[r];
}
function _o(e, r, t) {
  var n = fr(e);
  n === 2 ? e.set(r, t) : n === 3 ? e.add(t) : e[r] = t;
}
function So(e, r) {
  return e === r ? e !== 0 || 1 / e == 1 / r : e != e && r != r;
}
function Lt(e) {
  return Js && e instanceof Map;
}
function Ft(e) {
  return Xs && e instanceof Set;
}
function ar(e) {
  return e.o || e.t;
}
function ra(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var r = Oo(e);
  delete r[se];
  for (var t = Ar(r), n = 0; n < t.length; n++) {
    var a = t[n], i = r[a];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (r[a] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: e[a] });
  }
  return Object.create(Object.getPrototypeOf(e), r);
}
function ta(e, r) {
  return r === void 0 && (r = !1), na(e) || Be(e) || !qe(e) || (fr(e) > 1 && (e.set = e.add = e.clear = e.delete = Gs), Object.freeze(e), r && cr(e, function(t, n) {
    return ta(n, !0);
  }, !0)), e;
}
function Gs() {
  fe(2);
}
function na(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function Qe(e) {
  var r = Un[e];
  return r || fe(18, e), r;
}
function Eo(e, r) {
  Un[e] || (Un[e] = r);
}
function jn() {
  return process.env.NODE_ENV === "production" || xr || fe(0), xr;
}
function ln(e, r) {
  r && (Qe("Patches"), e.u = [], e.s = [], e.v = r);
}
function _t(e) {
  qn(e), e.p.forEach(Hs), e.p = null;
}
function qn(e) {
  e === xr && (xr = e.l);
}
function Aa(e) {
  return xr = { p: [], l: xr, h: e, m: !0, _: 0 };
}
function Hs(e) {
  var r = e[se];
  r.i === 0 || r.i === 1 ? r.j() : r.g = !0;
}
function dn(e, r) {
  r._ = r.p.length;
  var t = r.p[0], n = e !== void 0 && e !== t;
  return r.h.O || Qe("ES5").S(r, e, n), n ? (t[se].P && (_t(r), fe(4)), qe(e) && (e = St(r, e), r.l || Et(r, e)), r.u && Qe("Patches").M(t[se].t, e, r.u, r.s)) : e = St(r, t, []), _t(r), r.u && r.v(r.u, r.s), e !== ia ? e : void 0;
}
function St(e, r, t) {
  if (na(r))
    return r;
  var n = r[se];
  if (!n)
    return cr(r, function(o, u) {
      return Ia(e, n, r, o, u, t);
    }, !0), r;
  if (n.A !== e)
    return r;
  if (!n.P)
    return Et(e, n.t, !0), n.t;
  if (!n.I) {
    n.I = !0, n.A._--;
    var a = n.i === 4 || n.i === 5 ? n.o = ra(n.k) : n.o, i = a, c = !1;
    n.i === 3 && (i = new Set(a), a.clear(), c = !0), cr(i, function(o, u) {
      return Ia(e, n, a, o, u, t, c);
    }), Et(e, a, !1), t && e.u && Qe("Patches").N(n, t, e.u, e.s);
  }
  return n.o;
}
function Ia(e, r, t, n, a, i, c) {
  if (process.env.NODE_ENV !== "production" && a === t && fe(5), Be(a)) {
    var o = St(e, a, i && r && r.i !== 3 && !ur(r.R, n) ? i.concat(n) : void 0);
    if (_o(t, n, o), !Be(o))
      return;
    e.m = !1;
  } else
    c && t.add(a);
  if (qe(a) && !na(a)) {
    if (!e.h.D && e._ < 1)
      return;
    St(e, a), r && r.A.l || Et(e, a);
  }
}
function Et(e, r, t) {
  t === void 0 && (t = !1), !e.l && e.h.D && e.m && ta(r, t);
}
function pn(e, r) {
  var t = e[se];
  return (t ? ar(t) : e)[r];
}
function xa(e, r) {
  if (r in e)
    for (var t = Object.getPrototypeOf(e); t; ) {
      var n = Object.getOwnPropertyDescriptor(t, r);
      if (n)
        return n;
      t = Object.getPrototypeOf(t);
    }
}
function ir(e) {
  e.P || (e.P = !0, e.l && ir(e.l));
}
function vn(e) {
  e.o || (e.o = ra(e.t));
}
function kn(e, r, t) {
  var n = Lt(r) ? Qe("MapSet").F(r, t) : Ft(r) ? Qe("MapSet").T(r, t) : e.O ? function(a, i) {
    var c = Array.isArray(a), o = { i: c ? 1 : 0, A: i ? i.A : jn(), P: !1, I: !1, R: {}, l: i, t: a, k: null, o: null, j: null, C: !1 }, u = o, s = Jr;
    c && (u = [o], s = zr);
    var l = Proxy.revocable(u, s), d = l.revoke, f = l.proxy;
    return o.k = f, o.j = d, f;
  }(r, t) : Qe("ES5").J(r, t);
  return (t ? t.A : jn()).p.push(n), n;
}
function Ys(e) {
  return Be(e) || fe(22, e), function r(t) {
    if (!qe(t))
      return t;
    var n, a = t[se], i = fr(t);
    if (a) {
      if (!a.P && (a.i < 4 || !Qe("ES5").K(a)))
        return a.t;
      a.I = !0, n = $a(t, i), a.I = !1;
    } else
      n = $a(t, i);
    return cr(n, function(c, o) {
      a && mt(a.t, c) === o || _o(n, c, r(o));
    }), i === 3 ? new Set(n) : n;
  }(e);
}
function $a(e, r) {
  switch (r) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return ra(e);
}
function Ws() {
  function e(c, o) {
    var u = i[c];
    return u ? u.enumerable = o : i[c] = u = { configurable: !0, enumerable: o, get: function() {
      var s = this[se];
      return process.env.NODE_ENV !== "production" && a(s), Jr.get(s, c);
    }, set: function(s) {
      var l = this[se];
      process.env.NODE_ENV !== "production" && a(l), Jr.set(l, c, s);
    } }, u;
  }
  function r(c) {
    for (var o = c.length - 1; o >= 0; o--) {
      var u = c[o][se];
      if (!u.P)
        switch (u.i) {
          case 5:
            n(u) && ir(u);
            break;
          case 4:
            t(u) && ir(u);
        }
    }
  }
  function t(c) {
    for (var o = c.t, u = c.k, s = Ar(u), l = s.length - 1; l >= 0; l--) {
      var d = s[l];
      if (d !== se) {
        var f = o[d];
        if (f === void 0 && !ur(o, d))
          return !0;
        var p = u[d], y = p && p[se];
        if (y ? y.t !== f : !So(p, f))
          return !0;
      }
    }
    var v = !!o[se];
    return s.length !== Ar(o).length + (v ? 0 : 1);
  }
  function n(c) {
    var o = c.k;
    if (o.length !== c.t.length)
      return !0;
    var u = Object.getOwnPropertyDescriptor(o, o.length - 1);
    if (u && !u.get)
      return !0;
    for (var s = 0; s < o.length; s++)
      if (!o.hasOwnProperty(s))
        return !0;
    return !1;
  }
  function a(c) {
    c.g && fe(3, JSON.stringify(ar(c)));
  }
  var i = {};
  Eo("ES5", { J: function(c, o) {
    var u = Array.isArray(c), s = function(d, f) {
      if (d) {
        for (var p = Array(f.length), y = 0; y < f.length; y++)
          Object.defineProperty(p, "" + y, e(y, !0));
        return p;
      }
      var v = Oo(f);
      delete v[se];
      for (var g = Ar(v), E = 0; E < g.length; E++) {
        var P = g[E];
        v[P] = e(P, d || !!v[P].enumerable);
      }
      return Object.create(Object.getPrototypeOf(f), v);
    }(u, c), l = { i: u ? 5 : 4, A: o ? o.A : jn(), P: !1, I: !1, R: {}, l: o, t: c, k: s, o: null, g: !1, C: !1 };
    return Object.defineProperty(s, se, { value: l, writable: !0 }), s;
  }, S: function(c, o, u) {
    u ? Be(o) && o[se].A === c && r(c.p) : (c.u && function s(l) {
      if (l && typeof l == "object") {
        var d = l[se];
        if (d) {
          var f = d.t, p = d.k, y = d.R, v = d.i;
          if (v === 4)
            cr(p, function(b) {
              b !== se && (f[b] !== void 0 || ur(f, b) ? y[b] || s(p[b]) : (y[b] = !0, ir(d)));
            }), cr(f, function(b) {
              p[b] !== void 0 || ur(p, b) || (y[b] = !1, ir(d));
            });
          else if (v === 5) {
            if (n(d) && (ir(d), y.length = !0), p.length < f.length)
              for (var g = p.length; g < f.length; g++)
                y[g] = !1;
            else
              for (var E = f.length; E < p.length; E++)
                y[E] = !0;
            for (var P = Math.min(p.length, f.length), m = 0; m < P; m++)
              p.hasOwnProperty(m) || (y[m] = !0), y[m] === void 0 && s(p[m]);
          }
        }
      }
    }(c.p[0]), r(c.p));
  }, K: function(c) {
    return c.i === 4 ? t(c) : n(c);
  } });
}
function Bs() {
  function e(n) {
    if (!qe(n))
      return n;
    if (Array.isArray(n))
      return n.map(e);
    if (Lt(n))
      return new Map(Array.from(n.entries()).map(function(c) {
        return [c[0], e(c[1])];
      }));
    if (Ft(n))
      return new Set(Array.from(n).map(e));
    var a = Object.create(Object.getPrototypeOf(n));
    for (var i in n)
      a[i] = e(n[i]);
    return ur(n, Hr) && (a[Hr] = n[Hr]), a;
  }
  function r(n) {
    return Be(n) ? e(n) : n;
  }
  var t = "add";
  Eo("Patches", { $: function(n, a) {
    return a.forEach(function(i) {
      for (var c = i.path, o = i.op, u = n, s = 0; s < c.length - 1; s++) {
        var l = fr(u), d = c[s];
        typeof d != "string" && typeof d != "number" && (d = "" + d), l !== 0 && l !== 1 || d !== "__proto__" && d !== "constructor" || fe(24), typeof u == "function" && d === "prototype" && fe(24), typeof (u = mt(u, d)) != "object" && fe(15, c.join("/"));
      }
      var f = fr(u), p = e(i.value), y = c[c.length - 1];
      switch (o) {
        case "replace":
          switch (f) {
            case 2:
              return u.set(y, p);
            case 3:
              fe(16);
            default:
              return u[y] = p;
          }
        case t:
          switch (f) {
            case 1:
              return y === "-" ? u.push(p) : u.splice(y, 0, p);
            case 2:
              return u.set(y, p);
            case 3:
              return u.add(p);
            default:
              return u[y] = p;
          }
        case "remove":
          switch (f) {
            case 1:
              return u.splice(y, 1);
            case 2:
              return u.delete(y);
            case 3:
              return u.delete(i.value);
            default:
              return delete u[y];
          }
        default:
          fe(17, o);
      }
    }), n;
  }, N: function(n, a, i, c) {
    switch (n.i) {
      case 0:
      case 4:
      case 2:
        return function(o, u, s, l) {
          var d = o.t, f = o.o;
          cr(o.R, function(p, y) {
            var v = mt(d, p), g = mt(f, p), E = y ? ur(d, p) ? "replace" : t : "remove";
            if (v !== g || E !== "replace") {
              var P = u.concat(p);
              s.push(E === "remove" ? { op: E, path: P } : { op: E, path: P, value: g }), l.push(E === t ? { op: "remove", path: P } : E === "remove" ? { op: t, path: P, value: r(v) } : { op: "replace", path: P, value: r(v) });
            }
          });
        }(n, a, i, c);
      case 5:
      case 1:
        return function(o, u, s, l) {
          var d = o.t, f = o.R, p = o.o;
          if (p.length < d.length) {
            var y = [p, d];
            d = y[0], p = y[1];
            var v = [l, s];
            s = v[0], l = v[1];
          }
          for (var g = 0; g < d.length; g++)
            if (f[g] && p[g] !== d[g]) {
              var E = u.concat([g]);
              s.push({ op: "replace", path: E, value: r(p[g]) }), l.push({ op: "replace", path: E, value: r(d[g]) });
            }
          for (var P = d.length; P < p.length; P++) {
            var m = u.concat([P]);
            s.push({ op: t, path: m, value: r(p[P]) });
          }
          d.length < p.length && l.push({ op: "replace", path: u.concat(["length"]), value: d.length });
        }(n, a, i, c);
      case 3:
        return function(o, u, s, l) {
          var d = o.t, f = o.o, p = 0;
          d.forEach(function(y) {
            if (!f.has(y)) {
              var v = u.concat([p]);
              s.push({ op: "remove", path: v, value: y }), l.unshift({ op: t, path: v, value: y });
            }
            p++;
          }), p = 0, f.forEach(function(y) {
            if (!d.has(y)) {
              var v = u.concat([p]);
              s.push({ op: t, path: v, value: y }), l.unshift({ op: "remove", path: v, value: y });
            }
            p++;
          });
        }(n, a, i, c);
    }
  }, M: function(n, a, i, c) {
    i.push({ op: "replace", path: [], value: a === ia ? void 0 : a }), c.push({ op: "replace", path: [], value: n });
  } });
}
var Na, xr, aa = typeof Symbol < "u" && typeof Symbol("x") == "symbol", Js = typeof Map < "u", Xs = typeof Set < "u", Da = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", ia = aa ? Symbol.for("immer-nothing") : ((Na = {})["immer-nothing"] = !0, Na), Hr = aa ? Symbol.for("immer-draftable") : "__$immer_draftable", se = aa ? Symbol.for("immer-state") : "__$immer_state", Zs = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, ec = "" + Object.prototype.constructor, Ar = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, Oo = Object.getOwnPropertyDescriptors || function(e) {
  var r = {};
  return Ar(e).forEach(function(t) {
    r[t] = Object.getOwnPropertyDescriptor(e, t);
  }), r;
}, Un = {}, Jr = { get: function(e, r) {
  if (r === se)
    return e;
  var t = ar(e);
  if (!ur(t, r))
    return function(a, i, c) {
      var o, u = xa(i, c);
      return u ? "value" in u ? u.value : (o = u.get) === null || o === void 0 ? void 0 : o.call(a.k) : void 0;
    }(e, t, r);
  var n = t[r];
  return e.I || !qe(n) ? n : n === pn(e.t, r) ? (vn(e), e.o[r] = kn(e.A.h, n, e)) : n;
}, has: function(e, r) {
  return r in ar(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(ar(e));
}, set: function(e, r, t) {
  var n = xa(ar(e), r);
  if (n != null && n.set)
    return n.set.call(e.k, t), !0;
  if (!e.P) {
    var a = pn(ar(e), r), i = a == null ? void 0 : a[se];
    if (i && i.t === t)
      return e.o[r] = t, e.R[r] = !1, !0;
    if (So(t, a) && (t !== void 0 || ur(e.t, r)))
      return !0;
    vn(e), ir(e);
  }
  return e.o[r] === t && (t !== void 0 || r in e.o) || Number.isNaN(t) && Number.isNaN(e.o[r]) || (e.o[r] = t, e.R[r] = !0), !0;
}, deleteProperty: function(e, r) {
  return pn(e.t, r) !== void 0 || r in e.t ? (e.R[r] = !1, vn(e), ir(e)) : delete e.R[r], e.o && delete e.o[r], !0;
}, getOwnPropertyDescriptor: function(e, r) {
  var t = ar(e), n = Reflect.getOwnPropertyDescriptor(t, r);
  return n && { writable: !0, configurable: e.i !== 1 || r !== "length", enumerable: n.enumerable, value: t[r] };
}, defineProperty: function() {
  fe(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  fe(12);
} }, zr = {};
cr(Jr, function(e, r) {
  zr[e] = function() {
    return arguments[0] = arguments[0][0], r.apply(this, arguments);
  };
}), zr.deleteProperty = function(e, r) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(r)) && fe(13), zr.set.call(this, e, r, void 0);
}, zr.set = function(e, r, t) {
  return process.env.NODE_ENV !== "production" && r !== "length" && isNaN(parseInt(r)) && fe(14), Jr.set.call(this, e[0], r, t, e[0]);
};
var rc = function() {
  function e(t) {
    var n = this;
    this.O = Da, this.D = !0, this.produce = function(a, i, c) {
      if (typeof a == "function" && typeof i != "function") {
        var o = i;
        i = a;
        var u = n;
        return function(v) {
          var g = this;
          v === void 0 && (v = o);
          for (var E = arguments.length, P = Array(E > 1 ? E - 1 : 0), m = 1; m < E; m++)
            P[m - 1] = arguments[m];
          return u.produce(v, function(b) {
            var h;
            return (h = i).call.apply(h, [g, b].concat(P));
          });
        };
      }
      var s;
      if (typeof i != "function" && fe(6), c !== void 0 && typeof c != "function" && fe(7), qe(a)) {
        var l = Aa(n), d = kn(n, a, void 0), f = !0;
        try {
          s = i(d), f = !1;
        } finally {
          f ? _t(l) : qn(l);
        }
        return typeof Promise < "u" && s instanceof Promise ? s.then(function(v) {
          return ln(l, c), dn(v, l);
        }, function(v) {
          throw _t(l), v;
        }) : (ln(l, c), dn(s, l));
      }
      if (!a || typeof a != "object") {
        if ((s = i(a)) === void 0 && (s = a), s === ia && (s = void 0), n.D && ta(s, !0), c) {
          var p = [], y = [];
          Qe("Patches").M(a, s, p, y), c(p, y);
        }
        return s;
      }
      fe(21, a);
    }, this.produceWithPatches = function(a, i) {
      if (typeof a == "function")
        return function(s) {
          for (var l = arguments.length, d = Array(l > 1 ? l - 1 : 0), f = 1; f < l; f++)
            d[f - 1] = arguments[f];
          return n.produceWithPatches(s, function(p) {
            return a.apply(void 0, [p].concat(d));
          });
        };
      var c, o, u = n.produce(a, i, function(s, l) {
        c = s, o = l;
      });
      return typeof Promise < "u" && u instanceof Promise ? u.then(function(s) {
        return [s, c, o];
      }) : [u, c, o];
    }, typeof (t == null ? void 0 : t.useProxies) == "boolean" && this.setUseProxies(t.useProxies), typeof (t == null ? void 0 : t.autoFreeze) == "boolean" && this.setAutoFreeze(t.autoFreeze);
  }
  var r = e.prototype;
  return r.createDraft = function(t) {
    qe(t) || fe(8), Be(t) && (t = Ys(t));
    var n = Aa(this), a = kn(this, t, void 0);
    return a[se].C = !0, qn(n), a;
  }, r.finishDraft = function(t, n) {
    var a = t && t[se];
    process.env.NODE_ENV !== "production" && (a && a.C || fe(9), a.I && fe(10));
    var i = a.A;
    return ln(i, n), dn(void 0, i);
  }, r.setAutoFreeze = function(t) {
    this.D = t;
  }, r.setUseProxies = function(t) {
    t && !Da && fe(20), this.O = t;
  }, r.applyPatches = function(t, n) {
    var a;
    for (a = n.length - 1; a >= 0; a--) {
      var i = n[a];
      if (i.path.length === 0 && i.op === "replace") {
        t = i.value;
        break;
      }
    }
    a > -1 && (n = n.slice(a + 1));
    var c = Qe("Patches").$;
    return Be(t) ? c(t, n) : this.produce(t, function(o) {
      return c(o, n);
    });
  }, e;
}(), Ne = new rc(), it = Ne.produce, Po = Ne.produceWithPatches.bind(Ne);
Ne.setAutoFreeze.bind(Ne);
Ne.setUseProxies.bind(Ne);
var Ma = Ne.applyPatches.bind(Ne);
Ne.createDraft.bind(Ne);
Ne.finishDraft.bind(Ne);
function Xr(e) {
  "@babel/helpers - typeof";
  return Xr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Xr(e);
}
function tc(e, r) {
  if (Xr(e) !== "object" || e === null)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r || "default");
    if (Xr(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function nc(e) {
  var r = tc(e, "string");
  return Xr(r) === "symbol" ? r : String(r);
}
function ac(e, r, t) {
  return r = nc(r), r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ja(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function qa(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ja(Object(t), !0).forEach(function(n) {
      ac(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ja(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Te(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var ka = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), hn = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, yr = {
  INIT: "@@redux/INIT" + hn(),
  REPLACE: "@@redux/REPLACE" + hn(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + hn();
  }
};
function To(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var r = e; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return Object.getPrototypeOf(e) === r;
}
function ic(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var r = typeof e;
  switch (r) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return r;
  }
  if (Array.isArray(e))
    return "array";
  if (sc(e))
    return "date";
  if (uc(e))
    return "error";
  var t = oc(e);
  switch (t) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return t;
  }
  return r.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function oc(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function uc(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function sc(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function dr(e) {
  var r = typeof e;
  return process.env.NODE_ENV !== "production" && (r = ic(e)), r;
}
function wo(e, r, t) {
  var n;
  if (typeof r == "function" && typeof t == "function" || typeof t == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? Te(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof r == "function" && typeof t > "u" && (t = r, r = void 0), typeof t < "u") {
    if (typeof t != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Te(1) : "Expected the enhancer to be a function. Instead, received: '" + dr(t) + "'");
    return t(wo)(e, r);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Te(2) : "Expected the root reducer to be a function. Instead, received: '" + dr(e) + "'");
  var a = e, i = r, c = [], o = c, u = !1;
  function s() {
    o === c && (o = c.slice());
  }
  function l() {
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Te(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function d(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Te(4) : "Expected the listener to be a function. Instead, received: '" + dr(v) + "'");
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Te(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var g = !0;
    return s(), o.push(v), function() {
      if (g) {
        if (u)
          throw new Error(process.env.NODE_ENV === "production" ? Te(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        g = !1, s();
        var P = o.indexOf(v);
        o.splice(P, 1), c = null;
      }
    };
  }
  function f(v) {
    if (!To(v))
      throw new Error(process.env.NODE_ENV === "production" ? Te(7) : "Actions must be plain objects. Instead, the actual type was: '" + dr(v) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof v.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Te(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Te(9) : "Reducers may not dispatch actions.");
    try {
      u = !0, i = a(i, v);
    } finally {
      u = !1;
    }
    for (var g = c = o, E = 0; E < g.length; E++) {
      var P = g[E];
      P();
    }
    return v;
  }
  function p(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Te(10) : "Expected the nextReducer to be a function. Instead, received: '" + dr(v));
    a = v, f({
      type: yr.REPLACE
    });
  }
  function y() {
    var v, g = d;
    return v = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(P) {
        if (typeof P != "object" || P === null)
          throw new Error(process.env.NODE_ENV === "production" ? Te(11) : "Expected the observer to be an object. Instead, received: '" + dr(P) + "'");
        function m() {
          P.next && P.next(l());
        }
        m();
        var b = g(m);
        return {
          unsubscribe: b
        };
      }
    }, v[ka] = function() {
      return this;
    }, v;
  }
  return f({
    type: yr.INIT
  }), n = {
    dispatch: f,
    subscribe: d,
    getState: l,
    replaceReducer: p
  }, n[ka] = y, n;
}
function Ua(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function cc(e, r, t, n) {
  var a = Object.keys(r), i = t && t.type === yr.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (a.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!To(e))
    return "The " + i + ' has unexpected type of "' + dr(e) + '". Expected argument to be an object with the following ' + ('keys: "' + a.join('", "') + '"');
  var c = Object.keys(e).filter(function(o) {
    return !r.hasOwnProperty(o) && !n[o];
  });
  if (c.forEach(function(o) {
    n[o] = !0;
  }), !(t && t.type === yr.REPLACE) && c.length > 0)
    return "Unexpected " + (c.length > 1 ? "keys" : "key") + " " + ('"' + c.join('", "') + '" found in ' + i + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + a.join('", "') + '". Unexpected keys will be ignored.');
}
function fc(e) {
  Object.keys(e).forEach(function(r) {
    var t = e[r], n = t(void 0, {
      type: yr.INIT
    });
    if (typeof n > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Te(12) : 'The slice reducer for key "' + r + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof t(void 0, {
      type: yr.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Te(13) : 'The slice reducer for key "' + r + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + yr.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function Ro(e) {
  for (var r = Object.keys(e), t = {}, n = 0; n < r.length; n++) {
    var a = r[n];
    process.env.NODE_ENV !== "production" && typeof e[a] > "u" && Ua('No reducer provided for key "' + a + '"'), typeof e[a] == "function" && (t[a] = e[a]);
  }
  var i = Object.keys(t), c;
  process.env.NODE_ENV !== "production" && (c = {});
  var o;
  try {
    fc(t);
  } catch (u) {
    o = u;
  }
  return function(s, l) {
    if (s === void 0 && (s = {}), o)
      throw o;
    if (process.env.NODE_ENV !== "production") {
      var d = cc(s, t, l, c);
      d && Ua(d);
    }
    for (var f = !1, p = {}, y = 0; y < i.length; y++) {
      var v = i[y], g = t[v], E = s[v], P = g(E, l);
      if (typeof P > "u") {
        var m = l && l.type;
        throw new Error(process.env.NODE_ENV === "production" ? Te(14) : "When called with an action of type " + (m ? '"' + String(m) + '"' : "(unknown type)") + ', the slice reducer for key "' + v + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      p[v] = P, f = f || P !== E;
    }
    return f = f || i.length !== Object.keys(s).length, f ? p : s;
  };
}
function Ot() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return r.length === 0 ? function(n) {
    return n;
  } : r.length === 1 ? r[0] : r.reduce(function(n, a) {
    return function() {
      return n(a.apply(void 0, arguments));
    };
  });
}
function lc() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    return function() {
      var a = n.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? Te(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, c = {
        getState: a.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, o = r.map(function(u) {
        return u(c);
      });
      return i = Ot.apply(void 0, o)(a.dispatch), qa(qa({}, a), {}, {
        dispatch: i
      });
    };
  };
}
var Pt = "NOT_FOUND";
function dc(e) {
  var r;
  return {
    get: function(n) {
      return r && e(r.key, n) ? r.value : Pt;
    },
    put: function(n, a) {
      r = {
        key: n,
        value: a
      };
    },
    getEntries: function() {
      return r ? [r] : [];
    },
    clear: function() {
      r = void 0;
    }
  };
}
function pc(e, r) {
  var t = [];
  function n(o) {
    var u = t.findIndex(function(l) {
      return r(o, l.key);
    });
    if (u > -1) {
      var s = t[u];
      return u > 0 && (t.splice(u, 1), t.unshift(s)), s.value;
    }
    return Pt;
  }
  function a(o, u) {
    n(o) === Pt && (t.unshift({
      key: o,
      value: u
    }), t.length > e && t.pop());
  }
  function i() {
    return t;
  }
  function c() {
    t = [];
  }
  return {
    get: n,
    put: a,
    getEntries: i,
    clear: c
  };
}
var vc = function(r, t) {
  return r === t;
};
function hc(e) {
  return function(t, n) {
    if (t === null || n === null || t.length !== n.length)
      return !1;
    for (var a = t.length, i = 0; i < a; i++)
      if (!e(t[i], n[i]))
        return !1;
    return !0;
  };
}
function Ln(e, r) {
  var t = typeof r == "object" ? r : {
    equalityCheck: r
  }, n = t.equalityCheck, a = n === void 0 ? vc : n, i = t.maxSize, c = i === void 0 ? 1 : i, o = t.resultEqualityCheck, u = hc(a), s = c === 1 ? dc(u) : pc(c, u);
  function l() {
    var d = s.get(arguments);
    if (d === Pt) {
      if (d = e.apply(null, arguments), o) {
        var f = s.getEntries(), p = f.find(function(y) {
          return o(y.value, d);
        });
        p && (d = p.value);
      }
      s.put(arguments, d);
    }
    return d;
  }
  return l.clearCache = function() {
    return s.clear();
  }, l;
}
function yc(e) {
  var r = Array.isArray(e[0]) ? e[0] : e;
  if (!r.every(function(n) {
    return typeof n == "function";
  })) {
    var t = r.map(function(n) {
      return typeof n == "function" ? "function " + (n.name || "unnamed") + "()" : typeof n;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + t + "]");
  }
  return r;
}
function gc(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  var a = function() {
    for (var c = arguments.length, o = new Array(c), u = 0; u < c; u++)
      o[u] = arguments[u];
    var s = 0, l, d = {
      memoizeOptions: void 0
    }, f = o.pop();
    if (typeof f == "object" && (d = f, f = o.pop()), typeof f != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof f + "]");
    var p = d, y = p.memoizeOptions, v = y === void 0 ? t : y, g = Array.isArray(v) ? v : [v], E = yc(o), P = e.apply(void 0, [function() {
      return s++, f.apply(null, arguments);
    }].concat(g)), m = e(function() {
      for (var h = [], _ = E.length, T = 0; T < _; T++)
        h.push(E[T].apply(null, arguments));
      return l = P.apply(null, h), l;
    });
    return Object.assign(m, {
      resultFunc: f,
      memoizedResultFunc: P,
      dependencies: E,
      lastResult: function() {
        return l;
      },
      recomputations: function() {
        return s;
      },
      resetRecomputations: function() {
        return s = 0;
      }
    }), m;
  };
  return a;
}
var Yr = /* @__PURE__ */ gc(Ln);
function Co(e) {
  var r = function(n) {
    var a = n.dispatch, i = n.getState;
    return function(c) {
      return function(o) {
        return typeof o == "function" ? o(a, i, e) : c(o);
      };
    };
  };
  return r;
}
var Ao = Co();
Ao.withExtraArgument = Co;
const La = Ao;
var mc = globalThis && globalThis.__extends || function() {
  var e = function(r, t) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (n[i] = a[i]);
    }, e(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    e(r, t);
    function n() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), bc = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, c;
  return c = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function o(s) {
    return function(l) {
      return u([s, l]);
    };
  }
  function u(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (l) {
        s = [6, l], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Tt = globalThis && globalThis.__spreadArray || function(e, r) {
  for (var t = 0, n = r.length, a = e.length; t < n; t++, a++)
    e[a] = r[t];
  return e;
}, _c = Object.defineProperty, Sc = Object.defineProperties, Ec = Object.getOwnPropertyDescriptors, Fa = Object.getOwnPropertySymbols, Oc = Object.prototype.hasOwnProperty, Pc = Object.prototype.propertyIsEnumerable, Qa = function(e, r, t) {
  return r in e ? _c(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
}, sr = function(e, r) {
  for (var t in r || (r = {}))
    Oc.call(r, t) && Qa(e, t, r[t]);
  if (Fa)
    for (var n = 0, a = Fa(r); n < a.length; n++) {
      var t = a[n];
      Pc.call(r, t) && Qa(e, t, r[t]);
    }
  return e;
}, yn = function(e, r) {
  return Sc(e, Ec(r));
}, Tc = function(e, r, t) {
  return new Promise(function(n, a) {
    var i = function(u) {
      try {
        o(t.next(u));
      } catch (s) {
        a(s);
      }
    }, c = function(u) {
      try {
        o(t.throw(u));
      } catch (s) {
        a(s);
      }
    }, o = function(u) {
      return u.done ? n(u.value) : Promise.resolve(u.value).then(i, c);
    };
    o((t = t.apply(e, r)).next());
  });
}, wc = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? Ot : Ot.apply(null, arguments);
};
function Je(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var r = Object.getPrototypeOf(e);
  if (r === null)
    return !0;
  for (var t = r; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return r === t;
}
function Io(e, r) {
  var t = 0;
  return {
    measureTime: function(n) {
      var a = Date.now();
      try {
        return n();
      } finally {
        var i = Date.now();
        t += i - a;
      }
    },
    warnIfExceeded: function() {
      t > e && console.warn(r + " took " + t + "ms, which is more than the warning threshold of " + e + `ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var Rc = (
  /** @class */
  function(e) {
    mc(r, e);
    function r() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      var a = e.apply(this, t) || this;
      return Object.setPrototypeOf(a, r.prototype), a;
    }
    return Object.defineProperty(r, Symbol.species, {
      get: function() {
        return r;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.concat = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return e.prototype.concat.apply(this, t);
    }, r.prototype.prepend = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return t.length === 1 && Array.isArray(t[0]) ? new (r.bind.apply(r, Tt([void 0], t[0].concat(this))))() : new (r.bind.apply(r, Tt([void 0], t.concat(this))))();
    }, r;
  }(Array)
);
function Fn(e) {
  return qe(e) ? it(e, function() {
  }) : e;
}
var Cc = process.env.NODE_ENV === "production", Va = "Invariant failed";
function za(e, r) {
  if (!e)
    throw Cc ? new Error(Va) : new Error(Va + ": " + (r || ""));
}
function Ac(e, r, t, n) {
  return JSON.stringify(e, Ic(r, n), t);
}
function Ic(e, r) {
  var t = [], n = [];
  return r || (r = function(a, i) {
    return t[0] === i ? "[Circular ~]" : "[Circular ~." + n.slice(0, t.indexOf(i)).join(".") + "]";
  }), function(a, i) {
    if (t.length > 0) {
      var c = t.indexOf(this);
      ~c ? t.splice(c + 1) : t.push(this), ~c ? n.splice(c, 1 / 0, a) : n.push(a), ~t.indexOf(i) && (i = r.call(this, a, i));
    } else
      t.push(i);
    return e == null ? i : e.call(this, a, i);
  };
}
function xc(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function $c(e, r, t) {
  var n = xo(e, r, t);
  return {
    detectMutations: function() {
      return $o(e, r, n, t);
    }
  };
}
function xo(e, r, t, n) {
  r === void 0 && (r = []), n === void 0 && (n = "");
  var a = { value: t };
  if (!e(t)) {
    a.children = {};
    for (var i in t) {
      var c = n ? n + "." + i : i;
      r.length && r.indexOf(c) !== -1 || (a.children[i] = xo(e, r, t[i], c));
    }
  }
  return a;
}
function $o(e, r, t, n, a, i) {
  r === void 0 && (r = []), a === void 0 && (a = !1), i === void 0 && (i = "");
  var c = t ? t.value : void 0, o = c === n;
  if (a && !o && !Number.isNaN(n))
    return { wasMutated: !0, path: i };
  if (e(c) || e(n))
    return { wasMutated: !1 };
  var u = {};
  for (var s in t.children)
    u[s] = !0;
  for (var s in n)
    u[s] = !0;
  var l = r.length > 0, d = function(p) {
    var y = i ? i + "." + p : p;
    if (l) {
      var v = r.some(function(E) {
        return E instanceof RegExp ? E.test(y) : y === E;
      });
      if (v)
        return "continue";
    }
    var g = $o(e, r, t.children[p], n[p], o, y);
    if (g.wasMutated)
      return { value: g };
  };
  for (var s in u) {
    var f = d(s);
    if (typeof f == "object")
      return f.value;
  }
  return { wasMutated: !1 };
}
function Nc(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(u) {
        return function(s) {
          return u(s);
        };
      };
    };
  var r = e.isImmutable, t = r === void 0 ? xc : r, n = e.ignoredPaths, a = e.warnAfter, i = a === void 0 ? 32 : a, c = e.ignore;
  n = n || c;
  var o = $c.bind(null, t, n);
  return function(u) {
    var s = u.getState, l = s(), d = o(l), f;
    return function(p) {
      return function(y) {
        var v = Io(i, "ImmutableStateInvariantMiddleware");
        v.measureTime(function() {
          l = s(), f = d.detectMutations(), d = o(l), za(!f.wasMutated, "A state mutation was detected between dispatches, in the path '" + (f.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var g = p(y);
        return v.measureTime(function() {
          l = s(), f = d.detectMutations(), d = o(l), f.wasMutated && za(!f.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (f.path || "") + ". Take a look at the reducer(s) handling the action " + Ac(y) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), v.warnIfExceeded(), g;
      };
    };
  };
}
function No(e) {
  var r = typeof e;
  return e == null || r === "string" || r === "boolean" || r === "number" || Array.isArray(e) || Je(e);
}
function Qn(e, r, t, n, a, i) {
  r === void 0 && (r = ""), t === void 0 && (t = No), a === void 0 && (a = []);
  var c;
  if (!t(e))
    return {
      keyPath: r || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || i != null && i.has(e))
    return !1;
  for (var o = n != null ? n(e) : Object.entries(e), u = a.length > 0, s = function(g, E) {
    var P = r ? r + "." + g : g;
    if (u) {
      var m = a.some(function(b) {
        return b instanceof RegExp ? b.test(P) : P === b;
      });
      if (m)
        return "continue";
    }
    if (!t(E))
      return { value: {
        keyPath: P,
        value: E
      } };
    if (typeof E == "object" && (c = Qn(E, P, t, n, a, i), c))
      return { value: c };
  }, l = 0, d = o; l < d.length; l++) {
    var f = d[l], p = f[0], y = f[1], v = s(p, y);
    if (typeof v == "object")
      return v.value;
  }
  return i && Do(e) && i.add(e), !1;
}
function Do(e) {
  if (!Object.isFrozen(e))
    return !1;
  for (var r = 0, t = Object.values(e); r < t.length; r++) {
    var n = t[r];
    if (!(typeof n != "object" || n === null) && !Do(n))
      return !1;
  }
  return !0;
}
function Dc(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(m) {
        return function(b) {
          return m(b);
        };
      };
    };
  var r = e.isSerializable, t = r === void 0 ? No : r, n = e.getEntries, a = e.ignoredActions, i = a === void 0 ? [] : a, c = e.ignoredActionPaths, o = c === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : c, u = e.ignoredPaths, s = u === void 0 ? [] : u, l = e.warnAfter, d = l === void 0 ? 32 : l, f = e.ignoreState, p = f === void 0 ? !1 : f, y = e.ignoreActions, v = y === void 0 ? !1 : y, g = e.disableCache, E = g === void 0 ? !1 : g, P = !E && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(m) {
    return function(b) {
      return function(h) {
        var _ = b(h), T = Io(d, "SerializableStateInvariantMiddleware");
        return !v && !(i.length && i.indexOf(h.type) !== -1) && T.measureTime(function() {
          var O = Qn(h, "", t, n, o, P);
          if (O) {
            var w = O.keyPath, R = O.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + w + "`. Value:", R, `
Take a look at the logic that dispatched this action: `, h, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), p || (T.measureTime(function() {
          var O = m.getState(), w = Qn(O, "", t, n, s, P);
          if (w) {
            var R = w.keyPath, C = w.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + R + "`. Value:", C, `
Take a look at the reducer(s) handling this action type: ` + h.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), T.warnIfExceeded()), _;
      };
    };
  };
}
function gn(e) {
  return typeof e == "boolean";
}
function Mc() {
  return function(r) {
    return jc(r);
  };
}
function jc(e) {
  e === void 0 && (e = {});
  var r = e.thunk, t = r === void 0 ? !0 : r, n = e.immutableCheck, a = n === void 0 ? !0 : n, i = e.serializableCheck, c = i === void 0 ? !0 : i, o = new Rc();
  if (t && (gn(t) ? o.push(La) : o.push(La.withExtraArgument(t.extraArgument))), process.env.NODE_ENV !== "production") {
    if (a) {
      var u = {};
      gn(a) || (u = a), o.unshift(Nc(u));
    }
    if (c) {
      var s = {};
      gn(c) || (s = c), o.push(Dc(s));
    }
  }
  return o;
}
var mn = process.env.NODE_ENV === "production";
function qc(e) {
  var r = Mc(), t = e || {}, n = t.reducer, a = n === void 0 ? void 0 : n, i = t.middleware, c = i === void 0 ? r() : i, o = t.devTools, u = o === void 0 ? !0 : o, s = t.preloadedState, l = s === void 0 ? void 0 : s, d = t.enhancers, f = d === void 0 ? void 0 : d, p;
  if (typeof a == "function")
    p = a;
  else if (Je(a))
    p = Ro(a);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var y = c;
  if (typeof y == "function" && (y = y(r), !mn && !Array.isArray(y)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!mn && y.some(function(m) {
    return typeof m != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var v = lc.apply(void 0, y), g = Ot;
  u && (g = wc(sr({
    trace: !mn
  }, typeof u == "object" && u)));
  var E = [v];
  Array.isArray(f) ? E = Tt([v], f) : typeof f == "function" && (E = f(E));
  var P = g.apply(void 0, E);
  return wo(p, l, P);
}
function xe(e, r) {
  function t() {
    for (var n = [], a = 0; a < arguments.length; a++)
      n[a] = arguments[a];
    if (r) {
      var i = r.apply(void 0, n);
      if (!i)
        throw new Error("prepareAction did not return an object");
      return sr(sr({
        type: e,
        payload: i.payload
      }, "meta" in i && { meta: i.meta }), "error" in i && { error: i.error });
    }
    return { type: e, payload: n[0] };
  }
  return t.toString = function() {
    return "" + e;
  }, t.type = e, t.match = function(n) {
    return n.type === e;
  }, t;
}
function Mo(e) {
  var r = {}, t = [], n, a = {
    addCase: function(i, c) {
      if (process.env.NODE_ENV !== "production") {
        if (t.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var o = typeof i == "string" ? i : i.type;
      if (o in r)
        throw new Error("addCase cannot be called with two reducers for the same action type");
      return r[o] = c, a;
    },
    addMatcher: function(i, c) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return t.push({ matcher: i, reducer: c }), a;
    },
    addDefaultCase: function(i) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return n = i, a;
    }
  };
  return e(a), [r, t, n];
}
function kc(e) {
  return typeof e == "function";
}
var Ka = !1;
function Uc(e, r, t, n) {
  t === void 0 && (t = []), process.env.NODE_ENV !== "production" && typeof r == "object" && (Ka || (Ka = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var a = typeof r == "function" ? Mo(r) : [r, t, n], i = a[0], c = a[1], o = a[2], u;
  if (kc(e))
    u = function() {
      return Fn(e());
    };
  else {
    var s = Fn(e);
    u = function() {
      return s;
    };
  }
  function l(d, f) {
    d === void 0 && (d = u());
    var p = Tt([
      i[f.type]
    ], c.filter(function(y) {
      var v = y.matcher;
      return v(f);
    }).map(function(y) {
      var v = y.reducer;
      return v;
    }));
    return p.filter(function(y) {
      return !!y;
    }).length === 0 && (p = [o]), p.reduce(function(y, v) {
      if (v)
        if (Be(y)) {
          var g = y, E = v(g, f);
          return E === void 0 ? y : E;
        } else {
          if (qe(y))
            return it(y, function(P) {
              return v(P, f);
            });
          var E = v(y, f);
          if (E === void 0) {
            if (y === null)
              return y;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return E;
        }
      return y;
    }, d);
  }
  return l.getInitialState = u, l;
}
var Ga = !1;
function Lc(e, r) {
  return e + "/" + r;
}
function wr(e) {
  var r = e.name;
  if (!r)
    throw new Error("`name` is a required option for createSlice");
  typeof process < "u" && process.env.NODE_ENV === "development" && e.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var t = typeof e.initialState == "function" ? e.initialState : Fn(e.initialState), n = e.reducers || {}, a = Object.keys(n), i = {}, c = {}, o = {};
  a.forEach(function(l) {
    var d = n[l], f = Lc(r, l), p, y;
    "reducer" in d ? (p = d.reducer, y = d.prepare) : p = d, i[l] = p, c[f] = p, o[l] = y ? xe(f, y) : xe(f);
  });
  function u() {
    process.env.NODE_ENV !== "production" && typeof e.extraReducers == "object" && (Ga || (Ga = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var l = typeof e.extraReducers == "function" ? Mo(e.extraReducers) : [e.extraReducers], d = l[0], f = d === void 0 ? {} : d, p = l[1], y = p === void 0 ? [] : p, v = l[2], g = v === void 0 ? void 0 : v, E = sr(sr({}, f), c);
    return Uc(t, function(P) {
      for (var m in E)
        P.addCase(m, E[m]);
      for (var b = 0, h = y; b < h.length; b++) {
        var _ = h[b];
        P.addMatcher(_.matcher, _.reducer);
      }
      g && P.addDefaultCase(g);
    });
  }
  var s;
  return {
    name: r,
    reducer: function(l, d) {
      return s || (s = u()), s(l, d);
    },
    actions: o,
    caseReducers: i,
    getInitialState: function() {
      return s || (s = u()), s.getInitialState();
    }
  };
}
var Fc = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", jo = function(e) {
  e === void 0 && (e = 21);
  for (var r = "", t = e; t--; )
    r += Fc[Math.random() * 64 | 0];
  return r;
}, Qc = [
  "name",
  "message",
  "stack",
  "code"
], bn = (
  /** @class */
  function() {
    function e(r, t) {
      this.payload = r, this.meta = t;
    }
    return e;
  }()
), Ha = (
  /** @class */
  function() {
    function e(r, t) {
      this.payload = r, this.meta = t;
    }
    return e;
  }()
), Vc = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var r = {}, t = 0, n = Qc; t < n.length; t++) {
      var a = n[t];
      typeof e[a] == "string" && (r[a] = e[a]);
    }
    return r;
  }
  return { message: String(e) };
}, Ya = function() {
  function e(r, t, n) {
    var a = xe(r + "/fulfilled", function(l, d, f, p) {
      return {
        payload: l,
        meta: yn(sr({}, p || {}), {
          arg: f,
          requestId: d,
          requestStatus: "fulfilled"
        })
      };
    }), i = xe(r + "/pending", function(l, d, f) {
      return {
        payload: void 0,
        meta: yn(sr({}, f || {}), {
          arg: d,
          requestId: l,
          requestStatus: "pending"
        })
      };
    }), c = xe(r + "/rejected", function(l, d, f, p, y) {
      return {
        payload: p,
        error: (n && n.serializeError || Vc)(l || "Rejected"),
        meta: yn(sr({}, y || {}), {
          arg: f,
          requestId: d,
          rejectedWithValue: !!p,
          requestStatus: "rejected",
          aborted: (l == null ? void 0 : l.name) === "AbortError",
          condition: (l == null ? void 0 : l.name) === "ConditionError"
        })
      };
    }), o = !1, u = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function l() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return l.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (o || (o = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, l;
      }()
    );
    function s(l) {
      return function(d, f, p) {
        var y = n != null && n.idGenerator ? n.idGenerator(l) : jo(), v = new u(), g;
        function E(m) {
          g = m, v.abort();
        }
        var P = function() {
          return Tc(this, null, function() {
            var m, b, h, _, T, O, w;
            return bc(this, function(R) {
              switch (R.label) {
                case 0:
                  return R.trys.push([0, 4, , 5]), _ = (m = n == null ? void 0 : n.condition) == null ? void 0 : m.call(n, l, { getState: f, extra: p }), Kc(_) ? [4, _] : [3, 2];
                case 1:
                  _ = R.sent(), R.label = 2;
                case 2:
                  if (_ === !1 || v.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return T = new Promise(function(C, A) {
                    return v.signal.addEventListener("abort", function() {
                      return A({
                        name: "AbortError",
                        message: g || "Aborted"
                      });
                    });
                  }), d(i(y, l, (b = n == null ? void 0 : n.getPendingMeta) == null ? void 0 : b.call(n, { requestId: y, arg: l }, { getState: f, extra: p }))), [4, Promise.race([
                    T,
                    Promise.resolve(t(l, {
                      dispatch: d,
                      getState: f,
                      extra: p,
                      requestId: y,
                      signal: v.signal,
                      abort: E,
                      rejectWithValue: function(C, A) {
                        return new bn(C, A);
                      },
                      fulfillWithValue: function(C, A) {
                        return new Ha(C, A);
                      }
                    })).then(function(C) {
                      if (C instanceof bn)
                        throw C;
                      return C instanceof Ha ? a(C.payload, y, l, C.meta) : a(C, y, l);
                    })
                  ])];
                case 3:
                  return h = R.sent(), [3, 5];
                case 4:
                  return O = R.sent(), h = O instanceof bn ? c(null, y, l, O.payload, O.meta) : c(O, y, l), [3, 5];
                case 5:
                  return w = n && !n.dispatchConditionRejection && c.match(h) && h.meta.condition, w || d(h), [2, h];
              }
            });
          });
        }();
        return Object.assign(P, {
          abort: E,
          requestId: y,
          arg: l,
          unwrap: function() {
            return P.then(zc);
          }
        });
      };
    }
    return Object.assign(s, {
      pending: i,
      rejected: c,
      fulfilled: a,
      typePrefix: r
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
}();
function zc(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function Kc(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var Gc = function(e) {
  return e && typeof e.match == "function";
}, qo = function(e, r) {
  return Gc(e) ? e.match(r) : e(r);
};
function $r() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return function(t) {
    return e.some(function(n) {
      return qo(n, t);
    });
  };
}
function Wr() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return function(t) {
    return e.every(function(n) {
      return qo(n, t);
    });
  };
}
function Qt(e, r) {
  if (!e || !e.meta)
    return !1;
  var t = typeof e.meta.requestId == "string", n = r.indexOf(e.meta.requestStatus) > -1;
  return t && n;
}
function ot(e) {
  return typeof e[0] == "function" && "pending" in e[0] && "fulfilled" in e[0] && "rejected" in e[0];
}
function oa() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return e.length === 0 ? function(t) {
    return Qt(t, ["pending"]);
  } : ot(e) ? function(t) {
    var n = e.map(function(i) {
      return i.pending;
    }), a = $r.apply(void 0, n);
    return a(t);
  } : oa()(e[0]);
}
function Zr() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return e.length === 0 ? function(t) {
    return Qt(t, ["rejected"]);
  } : ot(e) ? function(t) {
    var n = e.map(function(i) {
      return i.rejected;
    }), a = $r.apply(void 0, n);
    return a(t);
  } : Zr()(e[0]);
}
function Vt() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  var t = function(n) {
    return n && n.meta && n.meta.rejectedWithValue;
  };
  return e.length === 0 ? function(n) {
    var a = Wr(Zr.apply(void 0, e), t);
    return a(n);
  } : ot(e) ? function(n) {
    var a = Wr(Zr.apply(void 0, e), t);
    return a(n);
  } : Vt()(e[0]);
}
function _r() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return e.length === 0 ? function(t) {
    return Qt(t, ["fulfilled"]);
  } : ot(e) ? function(t) {
    var n = e.map(function(i) {
      return i.fulfilled;
    }), a = $r.apply(void 0, n);
    return a(t);
  } : _r()(e[0]);
}
function Vn() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return e.length === 0 ? function(t) {
    return Qt(t, ["pending", "fulfilled", "rejected"]);
  } : ot(e) ? function(t) {
    for (var n = [], a = 0, i = e; a < i.length; a++) {
      var c = i[a];
      n.push(c.pending, c.rejected, c.fulfilled);
    }
    var o = $r.apply(void 0, n);
    return o(t);
  } : Vn()(e[0]);
}
var ua = "listenerMiddleware";
xe(ua + "/add");
xe(ua + "/removeAll");
xe(ua + "/remove");
var Kr = "RTK_autoBatch", Wa = function() {
  return function(e) {
    var r;
    return {
      payload: e,
      meta: (r = {}, r[Kr] = !0, r)
    };
  };
}, Ba;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
Ws();
var wt = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, c;
  return c = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function o(s) {
    return function(l) {
      return u([s, l]);
    };
  }
  function u(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (l) {
        s = [6, l], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Rt = globalThis && globalThis.__spreadArray || function(e, r) {
  for (var t = 0, n = r.length, a = e.length; t < n; t++, a++)
    e[a] = r[t];
  return e;
}, Hc = Object.defineProperty, Yc = Object.defineProperties, Wc = Object.getOwnPropertyDescriptors, Ct = Object.getOwnPropertySymbols, ko = Object.prototype.hasOwnProperty, Uo = Object.prototype.propertyIsEnumerable, Ja = function(e, r, t) {
  return r in e ? Hc(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
}, ve = function(e, r) {
  for (var t in r || (r = {}))
    ko.call(r, t) && Ja(e, t, r[t]);
  if (Ct)
    for (var n = 0, a = Ct(r); n < a.length; n++) {
      var t = a[n];
      Uo.call(r, t) && Ja(e, t, r[t]);
    }
  return e;
}, Fe = function(e, r) {
  return Yc(e, Wc(r));
}, Xa = function(e, r) {
  var t = {};
  for (var n in e)
    ko.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ct)
    for (var a = 0, i = Ct(e); a < i.length; a++) {
      var n = i[a];
      r.indexOf(n) < 0 && Uo.call(e, n) && (t[n] = e[n]);
    }
  return t;
}, At = function(e, r, t) {
  return new Promise(function(n, a) {
    var i = function(u) {
      try {
        o(t.next(u));
      } catch (s) {
        a(s);
      }
    }, c = function(u) {
      try {
        o(t.throw(u));
      } catch (s) {
        a(s);
      }
    }, o = function(u) {
      return u.done ? n(u.value) : Promise.resolve(u.value).then(i, c);
    };
    o((t = t.apply(e, r)).next());
  });
}, ce;
(function(e) {
  e.uninitialized = "uninitialized", e.pending = "pending", e.fulfilled = "fulfilled", e.rejected = "rejected";
})(ce || (ce = {}));
function Bc(e) {
  return {
    status: e,
    isUninitialized: e === ce.uninitialized,
    isLoading: e === ce.pending,
    isSuccess: e === ce.fulfilled,
    isError: e === ce.rejected
  };
}
function Jc(e) {
  return new RegExp("(^|:)//").test(e);
}
var Xc = function(e) {
  return e.replace(/\/$/, "");
}, Zc = function(e) {
  return e.replace(/^\//, "");
};
function ef(e, r) {
  if (!e)
    return r;
  if (!r)
    return e;
  if (Jc(r))
    return r;
  var t = e.endsWith("/") || !r.startsWith("?") ? "/" : "";
  return e = Xc(e), r = Zc(r), "" + e + t + r;
}
var Za = function(e) {
  return [].concat.apply([], e);
};
function rf() {
  return typeof navigator > "u" || navigator.onLine === void 0 ? !0 : navigator.onLine;
}
function tf() {
  return typeof document > "u" ? !0 : document.visibilityState !== "hidden";
}
var ei = Je;
function Lo(e, r) {
  if (e === r || !(ei(e) && ei(r) || Array.isArray(e) && Array.isArray(r)))
    return r;
  for (var t = Object.keys(r), n = Object.keys(e), a = t.length === n.length, i = Array.isArray(r) ? [] : {}, c = 0, o = t; c < o.length; c++) {
    var u = o[c];
    i[u] = Lo(e[u], r[u]), a && (a = e[u] === i[u]);
  }
  return a ? e : i;
}
var ri = function() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return fetch.apply(void 0, e);
}, nf = function(e) {
  return e.status >= 200 && e.status <= 299;
}, af = function(e) {
  return /ion\/(vnd\.api\+)?json/.test(e.get("content-type") || "");
};
function ti(e) {
  if (!Je(e))
    return e;
  for (var r = ve({}, e), t = 0, n = Object.entries(r); t < n.length; t++) {
    var a = n[t], i = a[0], c = a[1];
    c === void 0 && delete r[i];
  }
  return r;
}
function of(e) {
  var r = this;
  e === void 0 && (e = {});
  var t = e, n = t.baseUrl, a = t.prepareHeaders, i = a === void 0 ? function(P) {
    return P;
  } : a, c = t.fetchFn, o = c === void 0 ? ri : c, u = t.paramsSerializer, s = t.isJsonContentType, l = s === void 0 ? af : s, d = t.jsonContentType, f = d === void 0 ? "application/json" : d, p = t.jsonReplacer, y = t.timeout, v = t.validateStatus, g = Xa(t, [
    "baseUrl",
    "prepareHeaders",
    "fetchFn",
    "paramsSerializer",
    "isJsonContentType",
    "jsonContentType",
    "jsonReplacer",
    "timeout",
    "validateStatus"
  ]);
  return typeof fetch > "u" && o === ri && console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments."), function(P, m) {
    return At(r, null, function() {
      var b, h, _, T, O, w, R, C, A, I, x, D, q, k, U, L, H, z, Y, F, K, J, W, ae, me, Se, Ee, he, N, le, j, Re, De, Ke, tr, ct;
      return wt(this, function(Pe) {
        switch (Pe.label) {
          case 0:
            return b = m.signal, h = m.getState, _ = m.extra, T = m.endpoint, O = m.forced, w = m.type, C = typeof P == "string" ? { url: P } : P, A = C.url, I = C.headers, x = I === void 0 ? new Headers(g.headers) : I, D = C.params, q = D === void 0 ? void 0 : D, k = C.responseHandler, U = k === void 0 ? "json" : k, L = C.validateStatus, H = L === void 0 ? v ?? nf : L, z = C.timeout, Y = z === void 0 ? y : z, F = Xa(C, [
              "url",
              "headers",
              "params",
              "responseHandler",
              "validateStatus",
              "timeout"
            ]), K = ve(Fe(ve({}, g), {
              signal: b
            }), F), x = new Headers(ti(x)), J = K, [4, i(x, {
              getState: h,
              extra: _,
              endpoint: T,
              forced: O,
              type: w
            })];
          case 1:
            J.headers = Pe.sent() || x, W = function(Ie) {
              return typeof Ie == "object" && (Je(Ie) || Array.isArray(Ie) || typeof Ie.toJSON == "function");
            }, !K.headers.has("content-type") && W(K.body) && K.headers.set("content-type", f), W(K.body) && l(K.headers) && (K.body = JSON.stringify(K.body, p)), q && (ae = ~A.indexOf("?") ? "&" : "?", me = u ? u(q) : new URLSearchParams(ti(q)), A += ae + me), A = ef(n, A), Se = new Request(A, K), Ee = Se.clone(), R = { request: Ee }, N = !1, le = Y && setTimeout(function() {
              N = !0, m.abort();
            }, Y), Pe.label = 2;
          case 2:
            return Pe.trys.push([2, 4, 5, 6]), [4, o(Se)];
          case 3:
            return he = Pe.sent(), [3, 6];
          case 4:
            return j = Pe.sent(), [2, {
              error: {
                status: N ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                error: String(j)
              },
              meta: R
            }];
          case 5:
            return le && clearTimeout(le), [
              7
              /*endfinally*/
            ];
          case 6:
            Re = he.clone(), R.response = Re, Ke = "", Pe.label = 7;
          case 7:
            return Pe.trys.push([7, 9, , 10]), [4, Promise.all([
              E(he, U).then(function(Ie) {
                return De = Ie;
              }, function(Ie) {
                return tr = Ie;
              }),
              Re.text().then(function(Ie) {
                return Ke = Ie;
              }, function() {
              })
            ])];
          case 8:
            if (Pe.sent(), tr)
              throw tr;
            return [3, 10];
          case 9:
            return ct = Pe.sent(), [2, {
              error: {
                status: "PARSING_ERROR",
                originalStatus: he.status,
                data: Ke,
                error: String(ct)
              },
              meta: R
            }];
          case 10:
            return [2, H(he, De) ? {
              data: De,
              meta: R
            } : {
              error: {
                status: he.status,
                data: De
              },
              meta: R
            }];
        }
      });
    });
  };
  function E(P, m) {
    return At(this, null, function() {
      var b;
      return wt(this, function(h) {
        switch (h.label) {
          case 0:
            return typeof m == "function" ? [2, m(P)] : (m === "content-type" && (m = l(P.headers) ? "json" : "text"), m !== "json" ? [3, 2] : [4, P.text()]);
          case 1:
            return b = h.sent(), [2, b.length ? JSON.parse(b) : null];
          case 2:
            return [2, P.text()];
        }
      });
    });
  }
}
var ni = (
  /** @class */
  function() {
    function e(r, t) {
      t === void 0 && (t = void 0), this.value = r, this.meta = t;
    }
    return e;
  }()
), et = /* @__PURE__ */ xe("__rtkq/focused"), It = /* @__PURE__ */ xe("__rtkq/unfocused"), rt = /* @__PURE__ */ xe("__rtkq/online"), xt = /* @__PURE__ */ xe("__rtkq/offline"), _n = !1;
function uf(e, r) {
  function t() {
    var n = function() {
      return e(et());
    }, a = function() {
      return e(It());
    }, i = function() {
      return e(rt());
    }, c = function() {
      return e(xt());
    }, o = function() {
      window.document.visibilityState === "visible" ? n() : a();
    };
    _n || typeof window < "u" && window.addEventListener && (window.addEventListener("visibilitychange", o, !1), window.addEventListener("focus", n, !1), window.addEventListener("online", i, !1), window.addEventListener("offline", c, !1), _n = !0);
    var u = function() {
      window.removeEventListener("focus", n), window.removeEventListener("visibilitychange", o), window.removeEventListener("online", i), window.removeEventListener("offline", c), _n = !1;
    };
    return u;
  }
  return r ? r(e, { onFocus: et, onFocusLost: It, onOffline: xt, onOnline: rt }) : t();
}
var ze;
(function(e) {
  e.query = "query", e.mutation = "mutation";
})(ze || (ze = {}));
function Fo(e) {
  return e.type === ze.query;
}
function sf(e) {
  return e.type === ze.mutation;
}
function Qo(e, r, t, n, a, i) {
  return cf(e) ? e(r, t, n, a).map(zn).map(i) : Array.isArray(e) ? e.map(zn).map(i) : [];
}
function cf(e) {
  return typeof e == "function";
}
function zn(e) {
  return typeof e == "string" ? { type: e } : e;
}
function Sn(e) {
  return e != null;
}
var tt = Symbol("forceQueryFn"), Kn = function(e) {
  return typeof e[tt] == "function";
};
function ff(e) {
  var r = e.serializeQueryArgs, t = e.queryThunk, n = e.mutationThunk, a = e.api, i = e.context, c = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), u = a.internalActions, s = u.unsubscribeQueryResult, l = u.removeMutationResult, d = u.updateSubscriptionOptions;
  return {
    buildInitiateQuery: m,
    buildInitiateMutation: b,
    getRunningQueryThunk: y,
    getRunningMutationThunk: v,
    getRunningQueriesThunk: g,
    getRunningMutationsThunk: E,
    getRunningOperationPromises: p,
    removalWarning: f
  };
  function f() {
    throw new Error(`This method had to be removed due to a conceptual bug in RTK.
       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.
       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.`);
  }
  function p() {
    if (typeof process < "u" && process.env.NODE_ENV === "development")
      f();
    else {
      var h = function(_) {
        return Array.from(_.values()).flatMap(function(T) {
          return T ? Object.values(T) : [];
        });
      };
      return Rt(Rt([], h(c)), h(o)).filter(Sn);
    }
  }
  function y(h, _) {
    return function(T) {
      var O, w = i.endpointDefinitions[h], R = r({
        queryArgs: _,
        endpointDefinition: w,
        endpointName: h
      });
      return (O = c.get(T)) == null ? void 0 : O[R];
    };
  }
  function v(h, _) {
    return function(T) {
      var O;
      return (O = o.get(T)) == null ? void 0 : O[_];
    };
  }
  function g() {
    return function(h) {
      return Object.values(c.get(h) || {}).filter(Sn);
    };
  }
  function E() {
    return function(h) {
      return Object.values(o.get(h) || {}).filter(Sn);
    };
  }
  function P(h) {
    if (process.env.NODE_ENV !== "production") {
      if (P.triggered)
        return;
      var _ = h(a.internalActions.internal_probeSubscription({
        queryCacheKey: "DOES_NOT_EXIST",
        requestId: "DUMMY_REQUEST_ID"
      }));
      if (P.triggered = !0, typeof _ != "boolean")
        throw new Error('Warning: Middleware for RTK-Query API at reducerPath "' + a.reducerPath + `" has not been added to the store.
You must add the middleware for RTK-Query to function correctly!`);
    }
  }
  function m(h, _) {
    var T = function(O, w) {
      var R = w === void 0 ? {} : w, C = R.subscribe, A = C === void 0 ? !0 : C, I = R.forceRefetch, x = R.subscriptionOptions, D = tt, q = R[D];
      return function(k, U) {
        var L, H, z = r({
          queryArgs: O,
          endpointDefinition: _,
          endpointName: h
        }), Y = t((L = {
          type: "query",
          subscribe: A,
          forceRefetch: I,
          subscriptionOptions: x,
          endpointName: h,
          originalArgs: O,
          queryCacheKey: z
        }, L[tt] = q, L)), F = a.endpoints[h].select(O), K = k(Y), J = F(U());
        P(k);
        var W = K.requestId, ae = K.abort, me = J.requestId !== W, Se = (H = c.get(k)) == null ? void 0 : H[z], Ee = function() {
          return F(U());
        }, he = Object.assign(q ? K.then(Ee) : me && !Se ? Promise.resolve(J) : Promise.all([Se, K]).then(Ee), {
          arg: O,
          requestId: W,
          subscriptionOptions: x,
          queryCacheKey: z,
          abort: ae,
          unwrap: function() {
            return At(this, null, function() {
              var le;
              return wt(this, function(j) {
                switch (j.label) {
                  case 0:
                    return [4, he];
                  case 1:
                    if (le = j.sent(), le.isError)
                      throw le.error;
                    return [2, le.data];
                }
              });
            });
          },
          refetch: function() {
            return k(T(O, { subscribe: !1, forceRefetch: !0 }));
          },
          unsubscribe: function() {
            A && k(s({
              queryCacheKey: z,
              requestId: W
            }));
          },
          updateSubscriptionOptions: function(le) {
            he.subscriptionOptions = le, k(d({
              endpointName: h,
              requestId: W,
              queryCacheKey: z,
              options: le
            }));
          }
        });
        if (!Se && !me && !q) {
          var N = c.get(k) || {};
          N[z] = he, c.set(k, N), he.then(function() {
            delete N[z], Object.keys(N).length || c.delete(k);
          });
        }
        return he;
      };
    };
    return T;
  }
  function b(h) {
    return function(_, T) {
      var O = T === void 0 ? {} : T, w = O.track, R = w === void 0 ? !0 : w, C = O.fixedCacheKey;
      return function(A, I) {
        var x = n({
          type: "mutation",
          endpointName: h,
          originalArgs: _,
          track: R,
          fixedCacheKey: C
        }), D = A(x);
        P(A);
        var q = D.requestId, k = D.abort, U = D.unwrap, L = D.unwrap().then(function(F) {
          return { data: F };
        }).catch(function(F) {
          return { error: F };
        }), H = function() {
          A(l({ requestId: q, fixedCacheKey: C }));
        }, z = Object.assign(L, {
          arg: D.arg,
          requestId: q,
          abort: k,
          unwrap: U,
          unsubscribe: H,
          reset: H
        }), Y = o.get(A) || {};
        return o.set(A, Y), Y[q] = z, z.then(function() {
          delete Y[q], Object.keys(Y).length || o.delete(A);
        }), C && (Y[C] = z, z.then(function() {
          Y[C] === z && (delete Y[C], Object.keys(Y).length || o.delete(A));
        })), z;
      };
    };
  }
}
function ai(e) {
  return e;
}
function lf(e) {
  var r = this, t = e.reducerPath, n = e.baseQuery, a = e.context.endpointDefinitions, i = e.serializeQueryArgs, c = e.api, o = function(m, b, h) {
    return function(_) {
      var T = a[m];
      _(c.internalActions.queryResultPatched({
        queryCacheKey: i({
          queryArgs: b,
          endpointDefinition: T,
          endpointName: m
        }),
        patches: h
      }));
    };
  }, u = function(m, b, h) {
    return function(_, T) {
      var O, w, R = c.endpoints[m].select(b)(T()), C = {
        patches: [],
        inversePatches: [],
        undo: function() {
          return _(c.util.patchQueryData(m, b, C.inversePatches));
        }
      };
      if (R.status === ce.uninitialized)
        return C;
      if ("data" in R)
        if (qe(R.data)) {
          var A = Po(R.data, h), I = A[1], x = A[2];
          (O = C.patches).push.apply(O, I), (w = C.inversePatches).push.apply(w, x);
        } else {
          var D = h(R.data);
          C.patches.push({ op: "replace", path: [], value: D }), C.inversePatches.push({
            op: "replace",
            path: [],
            value: R.data
          });
        }
      return _(c.util.patchQueryData(m, b, C.patches)), C;
    };
  }, s = function(m, b, h) {
    return function(_) {
      var T;
      return _(c.endpoints[m].initiate(b, (T = {
        subscribe: !1,
        forceRefetch: !0
      }, T[tt] = function() {
        return {
          data: h
        };
      }, T)));
    };
  }, l = function(m, b) {
    return At(r, [m, b], function(h, _) {
      var T, O, w, R, C, A, I, x, D, q, k, U, L, H, z, Y, F, K, J = _.signal, W = _.abort, ae = _.rejectWithValue, me = _.fulfillWithValue, Se = _.dispatch, Ee = _.getState, he = _.extra;
      return wt(this, function(N) {
        switch (N.label) {
          case 0:
            T = a[h.endpointName], N.label = 1;
          case 1:
            return N.trys.push([1, 8, , 13]), O = ai, w = void 0, R = {
              signal: J,
              abort: W,
              dispatch: Se,
              getState: Ee,
              extra: he,
              endpoint: h.endpointName,
              type: h.type,
              forced: h.type === "query" ? d(h, Ee()) : void 0
            }, C = h.type === "query" ? h[tt] : void 0, C ? (w = C(), [3, 6]) : [3, 2];
          case 2:
            return T.query ? [4, n(T.query(h.originalArgs), R, T.extraOptions)] : [3, 4];
          case 3:
            return w = N.sent(), T.transformResponse && (O = T.transformResponse), [3, 6];
          case 4:
            return [4, T.queryFn(h.originalArgs, R, T.extraOptions, function(le) {
              return n(le, R, T.extraOptions);
            })];
          case 5:
            w = N.sent(), N.label = 6;
          case 6:
            if (typeof process < "u" && process.env.NODE_ENV === "development") {
              if (A = T.query ? "`baseQuery`" : "`queryFn`", I = void 0, !w)
                I = A + " did not return anything.";
              else if (typeof w != "object")
                I = A + " did not return an object.";
              else if (w.error && w.data)
                I = A + " returned an object containing both `error` and `result`.";
              else if (w.error === void 0 && w.data === void 0)
                I = A + " returned an object containing neither a valid `error` and `result`. At least one of them should not be `undefined`";
              else
                for (x = 0, D = Object.keys(w); x < D.length; x++)
                  if (q = D[x], q !== "error" && q !== "data" && q !== "meta") {
                    I = "The object returned by " + A + " has the unknown property " + q + ".";
                    break;
                  }
              I && console.error("Error encountered handling the endpoint " + h.endpointName + `.
              ` + I + "\n              It needs to return an object with either the shape `{ data: <value> }` or `{ error: <value> }` that may contain an optional `meta` property.\n              Object returned was:", w);
            }
            if (w.error)
              throw new ni(w.error, w.meta);
            return k = me, [4, O(w.data, w.meta, h.originalArgs)];
          case 7:
            return [2, k.apply(void 0, [N.sent(), (F = {
              fulfilledTimeStamp: Date.now(),
              baseQueryMeta: w.meta
            }, F[Kr] = !0, F)])];
          case 8:
            if (U = N.sent(), L = U, !(L instanceof ni))
              return [3, 12];
            H = ai, T.query && T.transformErrorResponse && (H = T.transformErrorResponse), N.label = 9;
          case 9:
            return N.trys.push([9, 11, , 12]), z = ae, [4, H(L.value, L.meta, h.originalArgs)];
          case 10:
            return [2, z.apply(void 0, [N.sent(), (K = { baseQueryMeta: L.meta }, K[Kr] = !0, K)])];
          case 11:
            return Y = N.sent(), L = Y, [3, 12];
          case 12:
            throw typeof process < "u" && process.env.NODE_ENV !== "production" ? console.error('An unhandled error occurred processing a request for the endpoint "' + h.endpointName + `".
In the case of an unhandled error, no tags will be "provided" or "invalidated".`, L) : console.error(L), L;
          case 13:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  function d(m, b) {
    var h, _, T, O, w = (_ = (h = b[t]) == null ? void 0 : h.queries) == null ? void 0 : _[m.queryCacheKey], R = (T = b[t]) == null ? void 0 : T.config.refetchOnMountOrArgChange, C = w == null ? void 0 : w.fulfilledTimeStamp, A = (O = m.forceRefetch) != null ? O : m.subscribe && R;
    return A ? A === !0 || (Number(/* @__PURE__ */ new Date()) - Number(C)) / 1e3 >= A : !1;
  }
  var f = Ya(t + "/executeQuery", l, {
    getPendingMeta: function() {
      var m;
      return m = { startedTimeStamp: Date.now() }, m[Kr] = !0, m;
    },
    condition: function(m, b) {
      var h = b.getState, _, T, O, w = h(), R = (T = (_ = w[t]) == null ? void 0 : _.queries) == null ? void 0 : T[m.queryCacheKey], C = R == null ? void 0 : R.fulfilledTimeStamp, A = m.originalArgs, I = R == null ? void 0 : R.originalArgs, x = a[m.endpointName];
      return Kn(m) ? !0 : (R == null ? void 0 : R.status) === "pending" ? !1 : d(m, w) || Fo(x) && ((O = x == null ? void 0 : x.forceRefetch) != null && O.call(x, {
        currentArg: A,
        previousArg: I,
        endpointState: R,
        state: w
      })) ? !0 : !C;
    },
    dispatchConditionRejection: !0
  }), p = Ya(t + "/executeMutation", l, {
    getPendingMeta: function() {
      var m;
      return m = { startedTimeStamp: Date.now() }, m[Kr] = !0, m;
    }
  }), y = function(m) {
    return "force" in m;
  }, v = function(m) {
    return "ifOlderThan" in m;
  }, g = function(m, b, h) {
    return function(_, T) {
      var O = y(h) && h.force, w = v(h) && h.ifOlderThan, R = function(x) {
        return x === void 0 && (x = !0), c.endpoints[m].initiate(b, { forceRefetch: x });
      }, C = c.endpoints[m].select(b)(T());
      if (O)
        _(R());
      else if (w) {
        var A = C == null ? void 0 : C.fulfilledTimeStamp;
        if (!A) {
          _(R());
          return;
        }
        var I = (Number(/* @__PURE__ */ new Date()) - Number(new Date(A))) / 1e3 >= w;
        I && _(R());
      } else
        _(R(!1));
    };
  };
  function E(m) {
    return function(b) {
      var h, _;
      return ((_ = (h = b == null ? void 0 : b.meta) == null ? void 0 : h.arg) == null ? void 0 : _.endpointName) === m;
    };
  }
  function P(m, b) {
    return {
      matchPending: Wr(oa(m), E(b)),
      matchFulfilled: Wr(_r(m), E(b)),
      matchRejected: Wr(Zr(m), E(b))
    };
  }
  return {
    queryThunk: f,
    mutationThunk: p,
    prefetch: g,
    updateQueryData: u,
    upsertQueryData: s,
    patchQueryData: o,
    buildMatchThunkActions: P
  };
}
function Vo(e, r, t, n) {
  return Qo(t[e.meta.arg.endpointName][r], _r(e) ? e.payload : void 0, Vt(e) ? e.payload : void 0, e.meta.arg.originalArgs, "baseQueryMeta" in e.meta ? e.meta.baseQueryMeta : void 0, n);
}
function lt(e, r, t) {
  var n = e[r];
  n && t(n);
}
function nt(e) {
  var r;
  return (r = "arg" in e ? e.arg.fixedCacheKey : e.fixedCacheKey) != null ? r : e.requestId;
}
function ii(e, r, t) {
  var n = e[nt(r)];
  n && t(n);
}
var Qr = {};
function df(e) {
  var r = e.reducerPath, t = e.queryThunk, n = e.mutationThunk, a = e.context, i = a.endpointDefinitions, c = a.apiUid, o = a.extractRehydrationInfo, u = a.hasRehydrationInfo, s = e.assertTagType, l = e.config, d = xe(r + "/resetApiState"), f = wr({
    name: r + "/queries",
    initialState: Qr,
    reducers: {
      removeQueryResult: {
        reducer: function(h, _) {
          var T = _.payload.queryCacheKey;
          delete h[T];
        },
        prepare: Wa()
      },
      queryResultPatched: function(h, _) {
        var T = _.payload, O = T.queryCacheKey, w = T.patches;
        lt(h, O, function(R) {
          R.data = Ma(R.data, w.concat());
        });
      }
    },
    extraReducers: function(h) {
      h.addCase(t.pending, function(_, T) {
        var O = T.meta, w = T.meta.arg, R, C, A = Kn(w);
        (w.subscribe || A) && ((C = _[R = w.queryCacheKey]) != null || (_[R] = {
          status: ce.uninitialized,
          endpointName: w.endpointName
        })), lt(_, w.queryCacheKey, function(I) {
          I.status = ce.pending, I.requestId = A && I.requestId ? I.requestId : O.requestId, w.originalArgs !== void 0 && (I.originalArgs = w.originalArgs), I.startedTimeStamp = O.startedTimeStamp;
        });
      }).addCase(t.fulfilled, function(_, T) {
        var O = T.meta, w = T.payload;
        lt(_, O.arg.queryCacheKey, function(R) {
          var C;
          if (!(R.requestId !== O.requestId && !Kn(O.arg))) {
            var A = i[O.arg.endpointName].merge;
            if (R.status = ce.fulfilled, A)
              if (R.data !== void 0) {
                var I = O.fulfilledTimeStamp, x = O.arg, D = O.baseQueryMeta, q = O.requestId, k = it(R.data, function(U) {
                  return A(U, w, {
                    arg: x.originalArgs,
                    baseQueryMeta: D,
                    fulfilledTimeStamp: I,
                    requestId: q
                  });
                });
                R.data = k;
              } else
                R.data = w;
            else
              R.data = (C = i[O.arg.endpointName].structuralSharing) == null || C ? Lo(R.data, w) : w;
            delete R.error, R.fulfilledTimeStamp = O.fulfilledTimeStamp;
          }
        });
      }).addCase(t.rejected, function(_, T) {
        var O = T.meta, w = O.condition, R = O.arg, C = O.requestId, A = T.error, I = T.payload;
        lt(_, R.queryCacheKey, function(x) {
          if (!w) {
            if (x.requestId !== C)
              return;
            x.status = ce.rejected, x.error = I ?? A;
          }
        });
      }).addMatcher(u, function(_, T) {
        for (var O = o(T).queries, w = 0, R = Object.entries(O); w < R.length; w++) {
          var C = R[w], A = C[0], I = C[1];
          ((I == null ? void 0 : I.status) === ce.fulfilled || (I == null ? void 0 : I.status) === ce.rejected) && (_[A] = I);
        }
      });
    }
  }), p = wr({
    name: r + "/mutations",
    initialState: Qr,
    reducers: {
      removeMutationResult: {
        reducer: function(h, _) {
          var T = _.payload, O = nt(T);
          O in h && delete h[O];
        },
        prepare: Wa()
      }
    },
    extraReducers: function(h) {
      h.addCase(n.pending, function(_, T) {
        var O = T.meta, w = T.meta, R = w.requestId, C = w.arg, A = w.startedTimeStamp;
        C.track && (_[nt(O)] = {
          requestId: R,
          status: ce.pending,
          endpointName: C.endpointName,
          startedTimeStamp: A
        });
      }).addCase(n.fulfilled, function(_, T) {
        var O = T.payload, w = T.meta;
        w.arg.track && ii(_, w, function(R) {
          R.requestId === w.requestId && (R.status = ce.fulfilled, R.data = O, R.fulfilledTimeStamp = w.fulfilledTimeStamp);
        });
      }).addCase(n.rejected, function(_, T) {
        var O = T.payload, w = T.error, R = T.meta;
        R.arg.track && ii(_, R, function(C) {
          C.requestId === R.requestId && (C.status = ce.rejected, C.error = O ?? w);
        });
      }).addMatcher(u, function(_, T) {
        for (var O = o(T).mutations, w = 0, R = Object.entries(O); w < R.length; w++) {
          var C = R[w], A = C[0], I = C[1];
          ((I == null ? void 0 : I.status) === ce.fulfilled || (I == null ? void 0 : I.status) === ce.rejected) && A !== (I == null ? void 0 : I.requestId) && (_[A] = I);
        }
      });
    }
  }), y = wr({
    name: r + "/invalidation",
    initialState: Qr,
    reducers: {},
    extraReducers: function(h) {
      h.addCase(f.actions.removeQueryResult, function(_, T) {
        for (var O = T.payload.queryCacheKey, w = 0, R = Object.values(_); w < R.length; w++)
          for (var C = R[w], A = 0, I = Object.values(C); A < I.length; A++) {
            var x = I[A], D = x.indexOf(O);
            D !== -1 && x.splice(D, 1);
          }
      }).addMatcher(u, function(_, T) {
        for (var O, w, R, C, A = o(T).provided, I = 0, x = Object.entries(A); I < x.length; I++)
          for (var D = x[I], q = D[0], k = D[1], U = 0, L = Object.entries(k); U < L.length; U++)
            for (var H = L[U], z = H[0], Y = H[1], F = (C = (w = (O = _[q]) != null ? O : _[q] = {})[R = z || "__internal_without_id"]) != null ? C : w[R] = [], K = 0, J = Y; K < J.length; K++) {
              var W = J[K], ae = F.includes(W);
              ae || F.push(W);
            }
      }).addMatcher($r(_r(t), Vt(t)), function(_, T) {
        for (var O, w, R, C, A = Vo(T, "providesTags", i, s), I = T.meta.arg.queryCacheKey, x = 0, D = Object.values(_); x < D.length; x++)
          for (var q = D[x], k = 0, U = Object.values(q); k < U.length; k++) {
            var L = U[k], H = L.indexOf(I);
            H !== -1 && L.splice(H, 1);
          }
        for (var z = 0, Y = A; z < Y.length; z++) {
          var F = Y[z], K = F.type, J = F.id, W = (C = (w = (O = _[K]) != null ? O : _[K] = {})[R = J || "__internal_without_id"]) != null ? C : w[R] = [], ae = W.includes(I);
          ae || W.push(I);
        }
      });
    }
  }), v = wr({
    name: r + "/subscriptions",
    initialState: Qr,
    reducers: {
      updateSubscriptionOptions: function(h, _) {
      },
      unsubscribeQueryResult: function(h, _) {
      },
      internal_probeSubscription: function(h, _) {
      }
    }
  }), g = wr({
    name: r + "/internalSubscriptions",
    initialState: Qr,
    reducers: {
      subscriptionsUpdated: function(h, _) {
        return Ma(h, _.payload);
      }
    }
  }), E = wr({
    name: r + "/config",
    initialState: ve({
      online: rf(),
      focused: tf(),
      middlewareRegistered: !1
    }, l),
    reducers: {
      middlewareRegistered: function(h, _) {
        var T = _.payload;
        h.middlewareRegistered = h.middlewareRegistered === "conflict" || c !== T ? "conflict" : !0;
      }
    },
    extraReducers: function(h) {
      h.addCase(rt, function(_) {
        _.online = !0;
      }).addCase(xt, function(_) {
        _.online = !1;
      }).addCase(et, function(_) {
        _.focused = !0;
      }).addCase(It, function(_) {
        _.focused = !1;
      }).addMatcher(u, function(_) {
        return ve({}, _);
      });
    }
  }), P = Ro({
    queries: f.reducer,
    mutations: p.reducer,
    provided: y.reducer,
    subscriptions: g.reducer,
    config: E.reducer
  }), m = function(h, _) {
    return P(d.match(_) ? void 0 : h, _);
  }, b = Fe(ve(ve(ve(ve(ve({}, E.actions), f.actions), v.actions), g.actions), p.actions), {
    unsubscribeMutationResult: p.actions.removeMutationResult,
    resetApiState: d
  });
  return { reducer: m, actions: b };
}
var hr = /* @__PURE__ */ Symbol.for("RTKQ/skipToken"), zo = {
  status: ce.uninitialized
}, oi = /* @__PURE__ */ it(zo, function() {
}), ui = /* @__PURE__ */ it(zo, function() {
});
function pf(e) {
  var r = e.serializeQueryArgs, t = e.reducerPath, n = function(l) {
    return oi;
  }, a = function(l) {
    return ui;
  };
  return { buildQuerySelector: o, buildMutationSelector: u, selectInvalidatedBy: s };
  function i(l) {
    return ve(ve({}, l), Bc(l.status));
  }
  function c(l) {
    var d = l[t];
    if (process.env.NODE_ENV !== "production" && !d) {
      if (c.triggered)
        return d;
      c.triggered = !0, console.error("Error: No data found at `state." + t + "`. Did you forget to add the reducer to the store?");
    }
    return d;
  }
  function o(l, d) {
    return function(f) {
      var p = r({
        queryArgs: f,
        endpointDefinition: d,
        endpointName: l
      }), y = function(g) {
        var E, P, m;
        return (m = (P = (E = c(g)) == null ? void 0 : E.queries) == null ? void 0 : P[p]) != null ? m : oi;
      }, v = f === hr ? n : y;
      return Yr(v, i);
    };
  }
  function u() {
    return function(l) {
      var d, f;
      typeof l == "object" ? f = (d = nt(l)) != null ? d : hr : f = l;
      var p = function(v) {
        var g, E, P;
        return (P = (E = (g = c(v)) == null ? void 0 : g.mutations) == null ? void 0 : E[f]) != null ? P : ui;
      }, y = f === hr ? a : p;
      return Yr(y, i);
    };
  }
  function s(l, d) {
    for (var f, p = l[t], y = /* @__PURE__ */ new Set(), v = 0, g = d.map(zn); v < g.length; v++) {
      var E = g[v], P = p.provided[E.type];
      if (P)
        for (var m = (f = E.id !== void 0 ? P[E.id] : Za(Object.values(P))) != null ? f : [], b = 0, h = m; b < h.length; b++) {
          var _ = h[b];
          y.add(_);
        }
    }
    return Za(Array.from(y.values()).map(function(T) {
      var O = p.queries[T];
      return O ? [
        {
          queryCacheKey: T,
          endpointName: O.endpointName,
          originalArgs: O.originalArgs
        }
      ] : [];
    }));
  }
}
var dt = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, si = function(e) {
  var r = e.endpointName, t = e.queryArgs, n = "", a = dt == null ? void 0 : dt.get(t);
  if (typeof a == "string")
    n = a;
  else {
    var i = JSON.stringify(t, function(c, o) {
      return Je(o) ? Object.keys(o).sort().reduce(function(u, s) {
        return u[s] = o[s], u;
      }, {}) : o;
    });
    Je(t) && (dt == null || dt.set(t, i)), n = i;
  }
  return r + "(" + n + ")";
};
function vf() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return function(n) {
    var a = Ln(function(l) {
      var d, f;
      return (f = n.extractRehydrationInfo) == null ? void 0 : f.call(n, l, {
        reducerPath: (d = n.reducerPath) != null ? d : "api"
      });
    }), i = Fe(ve({
      reducerPath: "api",
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: !1,
      refetchOnFocus: !1,
      refetchOnReconnect: !1
    }, n), {
      extractRehydrationInfo: a,
      serializeQueryArgs: function(l) {
        var d = si;
        if ("serializeQueryArgs" in l.endpointDefinition) {
          var f = l.endpointDefinition.serializeQueryArgs;
          d = function(p) {
            var y = f(p);
            return typeof y == "string" ? y : si(Fe(ve({}, p), {
              queryArgs: y
            }));
          };
        } else
          n.serializeQueryArgs && (d = n.serializeQueryArgs);
        return d(l);
      },
      tagTypes: Rt([], n.tagTypes || [])
    }), c = {
      endpointDefinitions: {},
      batch: function(l) {
        l();
      },
      apiUid: jo(),
      extractRehydrationInfo: a,
      hasRehydrationInfo: Ln(function(l) {
        return a(l) != null;
      })
    }, o = {
      injectEndpoints: s,
      enhanceEndpoints: function(l) {
        var d = l.addTagTypes, f = l.endpoints;
        if (d)
          for (var p = 0, y = d; p < y.length; p++) {
            var v = y[p];
            i.tagTypes.includes(v) || i.tagTypes.push(v);
          }
        if (f)
          for (var g = 0, E = Object.entries(f); g < E.length; g++) {
            var P = E[g], m = P[0], b = P[1];
            typeof b == "function" ? b(c.endpointDefinitions[m]) : Object.assign(c.endpointDefinitions[m] || {}, b);
          }
        return o;
      }
    }, u = e.map(function(l) {
      return l.init(o, i, c);
    });
    function s(l) {
      for (var d = l.endpoints({
        query: function(b) {
          return Fe(ve({}, b), { type: ze.query });
        },
        mutation: function(b) {
          return Fe(ve({}, b), { type: ze.mutation });
        }
      }), f = 0, p = Object.entries(d); f < p.length; f++) {
        var y = p[f], v = y[0], g = y[1];
        if (!l.overrideExisting && v in c.endpointDefinitions) {
          typeof process < "u" && process.env.NODE_ENV === "development" && console.error("called `injectEndpoints` to override already-existing endpointName " + v + " without specifying `overrideExisting: true`");
          continue;
        }
        c.endpointDefinitions[v] = g;
        for (var E = 0, P = u; E < P.length; E++) {
          var m = P[E];
          m.injectEndpoint(v, g);
        }
      }
      return o;
    }
    return o.injectEndpoints({ endpoints: n.endpoints });
  };
}
function hf(e) {
  for (var r in e)
    return !1;
  return !0;
}
var yf = 2147483647 / 1e3 - 1, gf = function(e) {
  var r = e.reducerPath, t = e.api, n = e.context, a = e.internalState, i = t.internalActions, c = i.removeQueryResult, o = i.unsubscribeQueryResult;
  function u(f) {
    var p = a.currentSubscriptions[f];
    return !!p && !hf(p);
  }
  var s = {}, l = function(f, p, y) {
    var v;
    if (o.match(f)) {
      var g = p.getState()[r], E = f.payload.queryCacheKey;
      d(E, (v = g.queries[E]) == null ? void 0 : v.endpointName, p, g.config);
    }
    if (t.util.resetApiState.match(f))
      for (var P = 0, m = Object.entries(s); P < m.length; P++) {
        var b = m[P], h = b[0], _ = b[1];
        _ && clearTimeout(_), delete s[h];
      }
    if (n.hasRehydrationInfo(f))
      for (var g = p.getState()[r], T = n.extractRehydrationInfo(f).queries, O = 0, w = Object.entries(T); O < w.length; O++) {
        var R = w[O], E = R[0], C = R[1];
        d(E, C == null ? void 0 : C.endpointName, p, g.config);
      }
  };
  function d(f, p, y, v) {
    var g, E = n.endpointDefinitions[p], P = (g = E == null ? void 0 : E.keepUnusedDataFor) != null ? g : v.keepUnusedDataFor;
    if (P !== 1 / 0) {
      var m = Math.max(0, Math.min(P, yf));
      if (!u(f)) {
        var b = s[f];
        b && clearTimeout(b), s[f] = setTimeout(function() {
          u(f) || y.dispatch(c({ queryCacheKey: f })), delete s[f];
        }, m * 1e3);
      }
    }
  }
  return l;
}, mf = function(e) {
  var r = e.reducerPath, t = e.context, n = e.context.endpointDefinitions, a = e.mutationThunk, i = e.api, c = e.assertTagType, o = e.refetchQuery, u = i.internalActions.removeQueryResult, s = $r(_r(a), Vt(a)), l = function(f, p) {
    s(f) && d(Vo(f, "invalidatesTags", n, c), p), i.util.invalidateTags.match(f) && d(Qo(f.payload, void 0, void 0, void 0, void 0, c), p);
  };
  function d(f, p) {
    var y = p.getState(), v = y[r], g = i.util.selectInvalidatedBy(y, f);
    t.batch(function() {
      for (var E, P = Array.from(g.values()), m = 0, b = P; m < b.length; m++) {
        var h = b[m].queryCacheKey, _ = v.queries[h], T = (E = v.subscriptions[h]) != null ? E : {};
        _ && (Object.keys(T).length === 0 ? p.dispatch(u({
          queryCacheKey: h
        })) : _.status !== ce.uninitialized && p.dispatch(o(_, h)));
      }
    });
  }
  return l;
}, bf = function(e) {
  var r = e.reducerPath, t = e.queryThunk, n = e.api, a = e.refetchQuery, i = e.internalState, c = {}, o = function(p, y) {
    (n.internalActions.updateSubscriptionOptions.match(p) || n.internalActions.unsubscribeQueryResult.match(p)) && s(p.payload, y), (t.pending.match(p) || t.rejected.match(p) && p.meta.condition) && s(p.meta.arg, y), (t.fulfilled.match(p) || t.rejected.match(p) && !p.meta.condition) && u(p.meta.arg, y), n.util.resetApiState.match(p) && d();
  };
  function u(p, y) {
    var v = p.queryCacheKey, g = y.getState()[r], E = g.queries[v], P = i.currentSubscriptions[v];
    if (!(!E || E.status === ce.uninitialized)) {
      var m = f(P);
      if (Number.isFinite(m)) {
        var b = c[v];
        b != null && b.timeout && (clearTimeout(b.timeout), b.timeout = void 0);
        var h = Date.now() + m, _ = c[v] = {
          nextPollTimestamp: h,
          pollingInterval: m,
          timeout: setTimeout(function() {
            _.timeout = void 0, y.dispatch(a(E, v));
          }, m)
        };
      }
    }
  }
  function s(p, y) {
    var v = p.queryCacheKey, g = y.getState()[r], E = g.queries[v], P = i.currentSubscriptions[v];
    if (!(!E || E.status === ce.uninitialized)) {
      var m = f(P);
      if (!Number.isFinite(m)) {
        l(v);
        return;
      }
      var b = c[v], h = Date.now() + m;
      (!b || h < b.nextPollTimestamp) && u({ queryCacheKey: v }, y);
    }
  }
  function l(p) {
    var y = c[p];
    y != null && y.timeout && clearTimeout(y.timeout), delete c[p];
  }
  function d() {
    for (var p = 0, y = Object.keys(c); p < y.length; p++) {
      var v = y[p];
      l(v);
    }
  }
  function f(p) {
    p === void 0 && (p = {});
    var y = Number.POSITIVE_INFINITY;
    for (var v in p)
      p[v].pollingInterval && (y = Math.min(p[v].pollingInterval, y));
    return y;
  }
  return o;
}, _f = function(e) {
  var r = e.reducerPath, t = e.context, n = e.api, a = e.refetchQuery, i = e.internalState, c = n.internalActions.removeQueryResult, o = function(s, l) {
    et.match(s) && u(l, "refetchOnFocus"), rt.match(s) && u(l, "refetchOnReconnect");
  };
  function u(s, l) {
    var d = s.getState()[r], f = d.queries, p = i.currentSubscriptions;
    t.batch(function() {
      for (var y = 0, v = Object.keys(p); y < v.length; y++) {
        var g = v[y], E = f[g], P = p[g];
        if (!(!P || !E)) {
          var m = Object.values(P).some(function(b) {
            return b[l] === !0;
          }) || Object.values(P).every(function(b) {
            return b[l] === void 0;
          }) && d.config[l];
          m && (Object.keys(P).length === 0 ? s.dispatch(c({
            queryCacheKey: g
          })) : E.status !== ce.uninitialized && s.dispatch(a(E, g)));
        }
      }
    });
  }
  return o;
}, ci = new Error("Promise never resolved before cacheEntryRemoved."), Sf = function(e) {
  var r = e.api, t = e.reducerPath, n = e.context, a = e.queryThunk, i = e.mutationThunk;
  e.internalState;
  var c = Vn(a), o = Vn(i), u = _r(a, i), s = {}, l = function(p, y, v) {
    var g = d(p);
    if (a.pending.match(p)) {
      var E = v[t].queries[g], P = y.getState()[t].queries[g];
      !E && P && f(p.meta.arg.endpointName, p.meta.arg.originalArgs, g, y, p.meta.requestId);
    } else if (i.pending.match(p)) {
      var P = y.getState()[t].mutations[g];
      P && f(p.meta.arg.endpointName, p.meta.arg.originalArgs, g, y, p.meta.requestId);
    } else if (u(p)) {
      var m = s[g];
      m != null && m.valueResolved && (m.valueResolved({
        data: p.payload,
        meta: p.meta.baseQueryMeta
      }), delete m.valueResolved);
    } else if (r.internalActions.removeQueryResult.match(p) || r.internalActions.removeMutationResult.match(p)) {
      var m = s[g];
      m && (delete s[g], m.cacheEntryRemoved());
    } else if (r.util.resetApiState.match(p))
      for (var b = 0, h = Object.entries(s); b < h.length; b++) {
        var _ = h[b], T = _[0], m = _[1];
        delete s[T], m.cacheEntryRemoved();
      }
  };
  function d(p) {
    return c(p) ? p.meta.arg.queryCacheKey : o(p) ? p.meta.requestId : r.internalActions.removeQueryResult.match(p) ? p.payload.queryCacheKey : r.internalActions.removeMutationResult.match(p) ? nt(p.payload) : "";
  }
  function f(p, y, v, g, E) {
    var P = n.endpointDefinitions[p], m = P == null ? void 0 : P.onCacheEntryAdded;
    if (m) {
      var b = {}, h = new Promise(function(C) {
        b.cacheEntryRemoved = C;
      }), _ = Promise.race([
        new Promise(function(C) {
          b.valueResolved = C;
        }),
        h.then(function() {
          throw ci;
        })
      ]);
      _.catch(function() {
      }), s[v] = b;
      var T = r.endpoints[p].select(P.type === ze.query ? y : v), O = g.dispatch(function(C, A, I) {
        return I;
      }), w = Fe(ve({}, g), {
        getCacheEntry: function() {
          return T(g.getState());
        },
        requestId: E,
        extra: O,
        updateCachedData: P.type === ze.query ? function(C) {
          return g.dispatch(r.util.updateQueryData(p, y, C));
        } : void 0,
        cacheDataLoaded: _,
        cacheEntryRemoved: h
      }), R = m(y, w);
      Promise.resolve(R).catch(function(C) {
        if (C !== ci)
          throw C;
      });
    }
  }
  return l;
}, Ef = function(e) {
  var r = e.api, t = e.context, n = e.queryThunk, a = e.mutationThunk, i = oa(n, a), c = Zr(n, a), o = _r(n, a), u = {}, s = function(l, d) {
    var f, p, y;
    if (i(l)) {
      var v = l.meta, g = v.requestId, E = v.arg, P = E.endpointName, m = E.originalArgs, b = t.endpointDefinitions[P], h = b == null ? void 0 : b.onQueryStarted;
      if (h) {
        var _ = {}, T = new Promise(function(D, q) {
          _.resolve = D, _.reject = q;
        });
        T.catch(function() {
        }), u[g] = _;
        var O = r.endpoints[P].select(b.type === ze.query ? m : g), w = d.dispatch(function(D, q, k) {
          return k;
        }), R = Fe(ve({}, d), {
          getCacheEntry: function() {
            return O(d.getState());
          },
          requestId: g,
          extra: w,
          updateCachedData: b.type === ze.query ? function(D) {
            return d.dispatch(r.util.updateQueryData(P, m, D));
          } : void 0,
          queryFulfilled: T
        });
        h(m, R);
      }
    } else if (o(l)) {
      var C = l.meta, g = C.requestId, A = C.baseQueryMeta;
      (f = u[g]) == null || f.resolve({
        data: l.payload,
        meta: A
      }), delete u[g];
    } else if (c(l)) {
      var I = l.meta, g = I.requestId, x = I.rejectedWithValue, A = I.baseQueryMeta;
      (y = u[g]) == null || y.reject({
        error: (p = l.payload) != null ? p : l.error,
        isUnhandledError: !x,
        meta: A
      }), delete u[g];
    }
  };
  return s;
}, Of = function(e) {
  var r = e.api, t = e.context.apiUid, n = e.reducerPath;
  return function(a, i) {
    var c, o;
    r.util.resetApiState.match(a) && i.dispatch(r.internalActions.middlewareRegistered(t)), typeof process < "u" && process.env.NODE_ENV === "development" && r.internalActions.middlewareRegistered.match(a) && a.payload === t && ((o = (c = i.getState()[n]) == null ? void 0 : c.config) == null ? void 0 : o.middlewareRegistered) === "conflict" && console.warn('There is a mismatch between slice and middleware for the reducerPath "' + n + `".
You can only have one api per reducer path, this will lead to crashes in various situations!` + (n === "api" ? `
If you have multiple apis, you *have* to specify the reducerPath option when using createApi!` : ""));
  };
}, fi, Pf = typeof queueMicrotask == "function" ? queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis) : function(e) {
  return (fi || (fi = Promise.resolve())).then(e).catch(function(r) {
    return setTimeout(function() {
      throw r;
    }, 0);
  });
}, Tf = function(e) {
  var r = e.api, t = e.queryThunk, n = e.internalState, a = r.reducerPath + "/subscriptions", i = null, c = !1, o = r.internalActions, u = o.updateSubscriptionOptions, s = o.unsubscribeQueryResult, l = function(d, f) {
    var p, y, v, g, E, P, m, b, h;
    if (u.match(f)) {
      var _ = f.payload, T = _.queryCacheKey, O = _.requestId, w = _.options;
      return (p = d == null ? void 0 : d[T]) != null && p[O] && (d[T][O] = w), !0;
    }
    if (s.match(f)) {
      var R = f.payload, T = R.queryCacheKey, O = R.requestId;
      return d[T] && delete d[T][O], !0;
    }
    if (r.internalActions.removeQueryResult.match(f))
      return delete d[f.payload.queryCacheKey], !0;
    if (t.pending.match(f)) {
      var C = f.meta, A = C.arg, O = C.requestId;
      if (A.subscribe) {
        var I = (v = d[y = A.queryCacheKey]) != null ? v : d[y] = {};
        return I[O] = (E = (g = A.subscriptionOptions) != null ? g : I[O]) != null ? E : {}, !0;
      }
    }
    if (t.rejected.match(f)) {
      var x = f.meta, D = x.condition, A = x.arg, O = x.requestId;
      if (D && A.subscribe) {
        var I = (m = d[P = A.queryCacheKey]) != null ? m : d[P] = {};
        return I[O] = (h = (b = A.subscriptionOptions) != null ? b : I[O]) != null ? h : {}, !0;
      }
    }
    return !1;
  };
  return function(d, f) {
    var p, y;
    if (i || (i = JSON.parse(JSON.stringify(n.currentSubscriptions))), r.internalActions.internal_probeSubscription.match(d)) {
      var v = d.payload, g = v.queryCacheKey, E = v.requestId, P = !!((p = n.currentSubscriptions[g]) != null && p[E]);
      return [!1, P];
    }
    var m = l(n.currentSubscriptions, d);
    if (m) {
      c || (Pf(function() {
        var T = JSON.parse(JSON.stringify(n.currentSubscriptions)), O = Po(i, function() {
          return T;
        }), w = O[1];
        f.next(r.internalActions.subscriptionsUpdated(w)), i = T, c = !1;
      }), c = !0);
      var b = !!((y = d.type) != null && y.startsWith(a)), h = t.rejected.match(d) && d.meta.condition && !!d.meta.arg.subscribe, _ = !b && !h;
      return [_, !1];
    }
    return [!0, !1];
  };
};
function wf(e) {
  var r = e.reducerPath, t = e.queryThunk, n = e.api, a = e.context, i = a.apiUid, c = {
    invalidateTags: xe(r + "/invalidateTags")
  }, o = function(d) {
    return !!d && typeof d.type == "string" && d.type.startsWith(r + "/");
  }, u = [
    Of,
    gf,
    mf,
    bf,
    Sf,
    Ef
  ], s = function(d) {
    var f = !1, p = {
      currentSubscriptions: {}
    }, y = Fe(ve({}, e), {
      internalState: p,
      refetchQuery: l
    }), v = u.map(function(P) {
      return P(y);
    }), g = Tf(y), E = _f(y);
    return function(P) {
      return function(m) {
        f || (f = !0, d.dispatch(n.internalActions.middlewareRegistered(i)));
        var b = Fe(ve({}, d), { next: P }), h = d.getState(), _ = g(m, b, h), T = _[0], O = _[1], w;
        if (T ? w = P(m) : w = O, d.getState()[r] && (E(m, b, h), o(m) || a.hasRehydrationInfo(m)))
          for (var R = 0, C = v; R < C.length; R++) {
            var A = C[R];
            A(m, b, h);
          }
        return w;
      };
    };
  };
  return { middleware: s, actions: c };
  function l(d, f, p) {
    return p === void 0 && (p = {}), t(ve({
      type: "query",
      endpointName: d.endpointName,
      originalArgs: d.originalArgs,
      subscribe: !1,
      forceRefetch: !0,
      queryCacheKey: f
    }, p));
  }
}
function nr(e) {
  for (var r = [], t = 1; t < arguments.length; t++)
    r[t - 1] = arguments[t];
  Object.assign.apply(Object, Rt([e], r));
}
var li = /* @__PURE__ */ Symbol(), Rf = function() {
  return {
    name: li,
    init: function(e, r, t) {
      var n = r.baseQuery, a = r.tagTypes, i = r.reducerPath, c = r.serializeQueryArgs, o = r.keepUnusedDataFor, u = r.refetchOnMountOrArgChange, s = r.refetchOnFocus, l = r.refetchOnReconnect;
      Bs();
      var d = function(F) {
        return typeof process < "u" && process.env.NODE_ENV === "development" && (a.includes(F.type) || console.error("Tag type '" + F.type + "' was used, but not specified in `tagTypes`!")), F;
      };
      Object.assign(e, {
        reducerPath: i,
        endpoints: {},
        internalActions: {
          onOnline: rt,
          onOffline: xt,
          onFocus: et,
          onFocusLost: It
        },
        util: {}
      });
      var f = lf({
        baseQuery: n,
        reducerPath: i,
        context: t,
        api: e,
        serializeQueryArgs: c
      }), p = f.queryThunk, y = f.mutationThunk, v = f.patchQueryData, g = f.updateQueryData, E = f.upsertQueryData, P = f.prefetch, m = f.buildMatchThunkActions, b = df({
        context: t,
        queryThunk: p,
        mutationThunk: y,
        reducerPath: i,
        assertTagType: d,
        config: {
          refetchOnFocus: s,
          refetchOnReconnect: l,
          refetchOnMountOrArgChange: u,
          keepUnusedDataFor: o,
          reducerPath: i
        }
      }), h = b.reducer, _ = b.actions;
      nr(e.util, {
        patchQueryData: v,
        updateQueryData: g,
        upsertQueryData: E,
        prefetch: P,
        resetApiState: _.resetApiState
      }), nr(e.internalActions, _);
      var T = wf({
        reducerPath: i,
        context: t,
        queryThunk: p,
        mutationThunk: y,
        api: e,
        assertTagType: d
      }), O = T.middleware, w = T.actions;
      nr(e.util, w), nr(e, { reducer: h, middleware: O });
      var R = pf({
        serializeQueryArgs: c,
        reducerPath: i
      }), C = R.buildQuerySelector, A = R.buildMutationSelector, I = R.selectInvalidatedBy;
      nr(e.util, { selectInvalidatedBy: I });
      var x = ff({
        queryThunk: p,
        mutationThunk: y,
        api: e,
        serializeQueryArgs: c,
        context: t
      }), D = x.buildInitiateQuery, q = x.buildInitiateMutation, k = x.getRunningMutationThunk, U = x.getRunningMutationsThunk, L = x.getRunningQueriesThunk, H = x.getRunningQueryThunk, z = x.getRunningOperationPromises, Y = x.removalWarning;
      return nr(e.util, {
        getRunningOperationPromises: z,
        getRunningOperationPromise: Y,
        getRunningMutationThunk: k,
        getRunningMutationsThunk: U,
        getRunningQueryThunk: H,
        getRunningQueriesThunk: L
      }), {
        name: li,
        injectEndpoint: function(F, K) {
          var J, W, ae = e;
          (W = (J = ae.endpoints)[F]) != null || (J[F] = {}), Fo(K) ? nr(ae.endpoints[F], {
            name: F,
            select: C(F, K),
            initiate: D(F, K)
          }, m(p, F)) : sf(K) && nr(ae.endpoints[F], {
            name: F,
            select: A(),
            initiate: q(F)
          }, m(y, F));
        }
      };
    }
  };
}, Gn = { exports: {} }, En = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var di;
function Cf() {
  if (di)
    return En;
  di = 1;
  var e = We;
  function r(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var t = typeof Object.is == "function" ? Object.is : r, n = e.useState, a = e.useEffect, i = e.useLayoutEffect, c = e.useDebugValue;
  function o(d, f) {
    var p = f(), y = n({ inst: { value: p, getSnapshot: f } }), v = y[0].inst, g = y[1];
    return i(function() {
      v.value = p, v.getSnapshot = f, u(v) && g({ inst: v });
    }, [d, p, f]), a(function() {
      return u(v) && g({ inst: v }), d(function() {
        u(v) && g({ inst: v });
      });
    }, [d]), c(p), p;
  }
  function u(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var p = f();
      return !t(d, p);
    } catch {
      return !0;
    }
  }
  function s(d, f) {
    return f();
  }
  var l = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? s : o;
  return En.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : l, En;
}
var On = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pi;
function Af() {
  return pi || (pi = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = We, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(m) {
      {
        for (var b = arguments.length, h = new Array(b > 1 ? b - 1 : 0), _ = 1; _ < b; _++)
          h[_ - 1] = arguments[_];
        n("error", m, h);
      }
    }
    function n(m, b, h) {
      {
        var _ = r.ReactDebugCurrentFrame, T = _.getStackAddendum();
        T !== "" && (b += "%s", h = h.concat([T]));
        var O = h.map(function(w) {
          return String(w);
        });
        O.unshift("Warning: " + b), Function.prototype.apply.call(console[m], console, O);
      }
    }
    function a(m, b) {
      return m === b && (m !== 0 || 1 / m === 1 / b) || m !== m && b !== b;
    }
    var i = typeof Object.is == "function" ? Object.is : a, c = e.useState, o = e.useEffect, u = e.useLayoutEffect, s = e.useDebugValue, l = !1, d = !1;
    function f(m, b, h) {
      l || e.startTransition !== void 0 && (l = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var _ = b();
      if (!d) {
        var T = b();
        i(_, T) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var O = c({
        inst: {
          value: _,
          getSnapshot: b
        }
      }), w = O[0].inst, R = O[1];
      return u(function() {
        w.value = _, w.getSnapshot = b, p(w) && R({
          inst: w
        });
      }, [m, _, b]), o(function() {
        p(w) && R({
          inst: w
        });
        var C = function() {
          p(w) && R({
            inst: w
          });
        };
        return m(C);
      }, [m]), s(_), _;
    }
    function p(m) {
      var b = m.getSnapshot, h = m.value;
      try {
        var _ = b();
        return !i(h, _);
      } catch {
        return !0;
      }
    }
    function y(m, b, h) {
      return b();
    }
    var v = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", g = !v, E = g ? y : f, P = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : E;
    On.useSyncExternalStore = P, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), On;
}
process.env.NODE_ENV === "production" ? Gn.exports = Cf() : Gn.exports = Af();
var Ko = Gn.exports, Hn = { exports: {} }, Pn = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vi;
function If() {
  if (vi)
    return Pn;
  vi = 1;
  var e = We, r = Ko;
  function t(s, l) {
    return s === l && (s !== 0 || 1 / s === 1 / l) || s !== s && l !== l;
  }
  var n = typeof Object.is == "function" ? Object.is : t, a = r.useSyncExternalStore, i = e.useRef, c = e.useEffect, o = e.useMemo, u = e.useDebugValue;
  return Pn.useSyncExternalStoreWithSelector = function(s, l, d, f, p) {
    var y = i(null);
    if (y.current === null) {
      var v = { hasValue: !1, value: null };
      y.current = v;
    } else
      v = y.current;
    y = o(function() {
      function E(_) {
        if (!P) {
          if (P = !0, m = _, _ = f(_), p !== void 0 && v.hasValue) {
            var T = v.value;
            if (p(T, _))
              return b = T;
          }
          return b = _;
        }
        if (T = b, n(m, _))
          return T;
        var O = f(_);
        return p !== void 0 && p(T, O) ? T : (m = _, b = O);
      }
      var P = !1, m, b, h = d === void 0 ? null : d;
      return [function() {
        return E(l());
      }, h === null ? void 0 : function() {
        return E(h());
      }];
    }, [l, d, f, p]);
    var g = a(s, y[0], y[1]);
    return c(function() {
      v.hasValue = !0, v.value = g;
    }, [g]), u(g), g;
  }, Pn;
}
var Tn = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hi;
function xf() {
  return hi || (hi = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = We, r = Ko;
    function t(l, d) {
      return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
    }
    var n = typeof Object.is == "function" ? Object.is : t, a = r.useSyncExternalStore, i = e.useRef, c = e.useEffect, o = e.useMemo, u = e.useDebugValue;
    function s(l, d, f, p, y) {
      var v = i(null), g;
      v.current === null ? (g = {
        hasValue: !1,
        value: null
      }, v.current = g) : g = v.current;
      var E = o(function() {
        var h = !1, _, T, O = function(A) {
          if (!h) {
            h = !0, _ = A;
            var I = p(A);
            if (y !== void 0 && g.hasValue) {
              var x = g.value;
              if (y(x, I))
                return T = x, x;
            }
            return T = I, I;
          }
          var D = _, q = T;
          if (n(D, A))
            return q;
          var k = p(A);
          return y !== void 0 && y(q, k) ? q : (_ = A, T = k, k);
        }, w = f === void 0 ? null : f, R = function() {
          return O(d());
        }, C = w === null ? void 0 : function() {
          return O(w());
        };
        return [R, C];
      }, [d, f, p, y]), P = E[0], m = E[1], b = a(l, P, m);
      return c(function() {
        g.hasValue = !0, g.value = b;
      }, [b]), u(b), b;
    }
    Tn.useSyncExternalStoreWithSelector = s, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Tn;
}
process.env.NODE_ENV === "production" ? Hn.exports = If() : Hn.exports = xf();
var $f = Hn.exports;
function Nf(e) {
  e();
}
let Go = Nf;
const Df = (e) => Go = e, Mf = () => Go, Xe = /* @__PURE__ */ Ut(null);
process.env.NODE_ENV !== "production" && (Xe.displayName = "ReactRedux");
function Ho() {
  const e = Ze(Xe);
  if (process.env.NODE_ENV !== "production" && !e)
    throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
  return e;
}
const jf = () => {
  throw new Error("uSES not initialized!");
};
let Yo = jf;
const qf = (e) => {
  Yo = e;
}, kf = (e, r) => e === r;
function Uf(e = Xe) {
  const r = e === Xe ? Ho : () => Ze(e);
  return function(n, a = kf) {
    if (process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof a != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const {
      store: i,
      subscription: c,
      getServerState: o
    } = r(), u = Yo(c.addNestedSub, i.getState, o || i.getState, n, a);
    return Dn(u), u;
  };
}
const Lf = /* @__PURE__ */ Uf();
var Yn = { exports: {} }, Z = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yi;
function Ff() {
  if (yi)
    return Z;
  yi = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
  function m(h) {
    if (typeof h == "object" && h !== null) {
      var _ = h.$$typeof;
      switch (_) {
        case r:
          switch (h = h.type, h) {
            case u:
            case s:
            case n:
            case i:
            case a:
            case d:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case o:
                case l:
                case y:
                case p:
                case c:
                  return h;
                default:
                  return _;
              }
          }
        case t:
          return _;
      }
    }
  }
  function b(h) {
    return m(h) === s;
  }
  return Z.AsyncMode = u, Z.ConcurrentMode = s, Z.ContextConsumer = o, Z.ContextProvider = c, Z.Element = r, Z.ForwardRef = l, Z.Fragment = n, Z.Lazy = y, Z.Memo = p, Z.Portal = t, Z.Profiler = i, Z.StrictMode = a, Z.Suspense = d, Z.isAsyncMode = function(h) {
    return b(h) || m(h) === u;
  }, Z.isConcurrentMode = b, Z.isContextConsumer = function(h) {
    return m(h) === o;
  }, Z.isContextProvider = function(h) {
    return m(h) === c;
  }, Z.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === r;
  }, Z.isForwardRef = function(h) {
    return m(h) === l;
  }, Z.isFragment = function(h) {
    return m(h) === n;
  }, Z.isLazy = function(h) {
    return m(h) === y;
  }, Z.isMemo = function(h) {
    return m(h) === p;
  }, Z.isPortal = function(h) {
    return m(h) === t;
  }, Z.isProfiler = function(h) {
    return m(h) === i;
  }, Z.isStrictMode = function(h) {
    return m(h) === a;
  }, Z.isSuspense = function(h) {
    return m(h) === d;
  }, Z.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === n || h === s || h === i || h === a || h === d || h === f || typeof h == "object" && h !== null && (h.$$typeof === y || h.$$typeof === p || h.$$typeof === c || h.$$typeof === o || h.$$typeof === l || h.$$typeof === g || h.$$typeof === E || h.$$typeof === P || h.$$typeof === v);
  }, Z.typeOf = m, Z;
}
var ee = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gi;
function Qf() {
  return gi || (gi = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
    function m(N) {
      return typeof N == "string" || typeof N == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      N === n || N === s || N === i || N === a || N === d || N === f || typeof N == "object" && N !== null && (N.$$typeof === y || N.$$typeof === p || N.$$typeof === c || N.$$typeof === o || N.$$typeof === l || N.$$typeof === g || N.$$typeof === E || N.$$typeof === P || N.$$typeof === v);
    }
    function b(N) {
      if (typeof N == "object" && N !== null) {
        var le = N.$$typeof;
        switch (le) {
          case r:
            var j = N.type;
            switch (j) {
              case u:
              case s:
              case n:
              case i:
              case a:
              case d:
                return j;
              default:
                var Re = j && j.$$typeof;
                switch (Re) {
                  case o:
                  case l:
                  case y:
                  case p:
                  case c:
                    return Re;
                  default:
                    return le;
                }
            }
          case t:
            return le;
        }
      }
    }
    var h = u, _ = s, T = o, O = c, w = r, R = l, C = n, A = y, I = p, x = t, D = i, q = a, k = d, U = !1;
    function L(N) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(N) || b(N) === u;
    }
    function H(N) {
      return b(N) === s;
    }
    function z(N) {
      return b(N) === o;
    }
    function Y(N) {
      return b(N) === c;
    }
    function F(N) {
      return typeof N == "object" && N !== null && N.$$typeof === r;
    }
    function K(N) {
      return b(N) === l;
    }
    function J(N) {
      return b(N) === n;
    }
    function W(N) {
      return b(N) === y;
    }
    function ae(N) {
      return b(N) === p;
    }
    function me(N) {
      return b(N) === t;
    }
    function Se(N) {
      return b(N) === i;
    }
    function Ee(N) {
      return b(N) === a;
    }
    function he(N) {
      return b(N) === d;
    }
    ee.AsyncMode = h, ee.ConcurrentMode = _, ee.ContextConsumer = T, ee.ContextProvider = O, ee.Element = w, ee.ForwardRef = R, ee.Fragment = C, ee.Lazy = A, ee.Memo = I, ee.Portal = x, ee.Profiler = D, ee.StrictMode = q, ee.Suspense = k, ee.isAsyncMode = L, ee.isConcurrentMode = H, ee.isContextConsumer = z, ee.isContextProvider = Y, ee.isElement = F, ee.isForwardRef = K, ee.isFragment = J, ee.isLazy = W, ee.isMemo = ae, ee.isPortal = me, ee.isProfiler = Se, ee.isStrictMode = Ee, ee.isSuspense = he, ee.isValidElementType = m, ee.typeOf = b;
  }()), ee;
}
process.env.NODE_ENV === "production" ? Yn.exports = Ff() : Yn.exports = Qf();
var Vf = Yn.exports, Wo = Vf, zf = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Kf = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Bo = {};
Bo[Wo.ForwardRef] = zf;
Bo[Wo.Memo] = Kf;
var re = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mi;
function Gf() {
  if (mi)
    return re;
  mi = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), c = Symbol.for("react.context"), o = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y;
  y = Symbol.for("react.module.reference");
  function v(g) {
    if (typeof g == "object" && g !== null) {
      var E = g.$$typeof;
      switch (E) {
        case e:
          switch (g = g.type, g) {
            case t:
            case a:
            case n:
            case s:
            case l:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case o:
                case c:
                case u:
                case f:
                case d:
                case i:
                  return g;
                default:
                  return E;
              }
          }
        case r:
          return E;
      }
    }
  }
  return re.ContextConsumer = c, re.ContextProvider = i, re.Element = e, re.ForwardRef = u, re.Fragment = t, re.Lazy = f, re.Memo = d, re.Portal = r, re.Profiler = a, re.StrictMode = n, re.Suspense = s, re.SuspenseList = l, re.isAsyncMode = function() {
    return !1;
  }, re.isConcurrentMode = function() {
    return !1;
  }, re.isContextConsumer = function(g) {
    return v(g) === c;
  }, re.isContextProvider = function(g) {
    return v(g) === i;
  }, re.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, re.isForwardRef = function(g) {
    return v(g) === u;
  }, re.isFragment = function(g) {
    return v(g) === t;
  }, re.isLazy = function(g) {
    return v(g) === f;
  }, re.isMemo = function(g) {
    return v(g) === d;
  }, re.isPortal = function(g) {
    return v(g) === r;
  }, re.isProfiler = function(g) {
    return v(g) === a;
  }, re.isStrictMode = function(g) {
    return v(g) === n;
  }, re.isSuspense = function(g) {
    return v(g) === s;
  }, re.isSuspenseList = function(g) {
    return v(g) === l;
  }, re.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === t || g === a || g === n || g === s || g === l || g === p || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === i || g.$$typeof === c || g.$$typeof === u || g.$$typeof === y || g.getModuleId !== void 0);
  }, re.typeOf = v, re;
}
var te = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bi;
function Hf() {
  return bi || (bi = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), c = Symbol.for("react.context"), o = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y = !1, v = !1, g = !1, E = !1, P = !1, m;
    m = Symbol.for("react.module.reference");
    function b(j) {
      return !!(typeof j == "string" || typeof j == "function" || j === t || j === a || P || j === n || j === s || j === l || E || j === p || y || v || g || typeof j == "object" && j !== null && (j.$$typeof === f || j.$$typeof === d || j.$$typeof === i || j.$$typeof === c || j.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      j.$$typeof === m || j.getModuleId !== void 0));
    }
    function h(j) {
      if (typeof j == "object" && j !== null) {
        var Re = j.$$typeof;
        switch (Re) {
          case e:
            var De = j.type;
            switch (De) {
              case t:
              case a:
              case n:
              case s:
              case l:
                return De;
              default:
                var Ke = De && De.$$typeof;
                switch (Ke) {
                  case o:
                  case c:
                  case u:
                  case f:
                  case d:
                  case i:
                    return Ke;
                  default:
                    return Re;
                }
            }
          case r:
            return Re;
        }
      }
    }
    var _ = c, T = i, O = e, w = u, R = t, C = f, A = d, I = r, x = a, D = n, q = s, k = l, U = !1, L = !1;
    function H(j) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(j) {
      return L || (L = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(j) {
      return h(j) === c;
    }
    function F(j) {
      return h(j) === i;
    }
    function K(j) {
      return typeof j == "object" && j !== null && j.$$typeof === e;
    }
    function J(j) {
      return h(j) === u;
    }
    function W(j) {
      return h(j) === t;
    }
    function ae(j) {
      return h(j) === f;
    }
    function me(j) {
      return h(j) === d;
    }
    function Se(j) {
      return h(j) === r;
    }
    function Ee(j) {
      return h(j) === a;
    }
    function he(j) {
      return h(j) === n;
    }
    function N(j) {
      return h(j) === s;
    }
    function le(j) {
      return h(j) === l;
    }
    te.ContextConsumer = _, te.ContextProvider = T, te.Element = O, te.ForwardRef = w, te.Fragment = R, te.Lazy = C, te.Memo = A, te.Portal = I, te.Profiler = x, te.StrictMode = D, te.Suspense = q, te.SuspenseList = k, te.isAsyncMode = H, te.isConcurrentMode = z, te.isContextConsumer = Y, te.isContextProvider = F, te.isElement = K, te.isForwardRef = J, te.isFragment = W, te.isLazy = ae, te.isMemo = me, te.isPortal = Se, te.isProfiler = Ee, te.isStrictMode = he, te.isSuspense = N, te.isSuspenseList = le, te.isValidElementType = b, te.typeOf = h;
  }()), te;
}
process.env.NODE_ENV === "production" ? Gf() : Hf();
function Yf() {
  const e = Mf();
  let r = null, t = null;
  return {
    clear() {
      r = null, t = null;
    },
    notify() {
      e(() => {
        let n = r;
        for (; n; )
          n.callback(), n = n.next;
      });
    },
    get() {
      let n = [], a = r;
      for (; a; )
        n.push(a), a = a.next;
      return n;
    },
    subscribe(n) {
      let a = !0, i = t = {
        callback: n,
        next: null,
        prev: t
      };
      return i.prev ? i.prev.next = i : r = i, function() {
        !a || r === null || (a = !1, i.next ? i.next.prev = i.prev : t = i.prev, i.prev ? i.prev.next = i.next : r = i.next);
      };
    }
  };
}
const _i = {
  notify() {
  },
  get: () => []
};
function Wf(e, r) {
  let t, n = _i;
  function a(d) {
    return u(), n.subscribe(d);
  }
  function i() {
    n.notify();
  }
  function c() {
    l.onStateChange && l.onStateChange();
  }
  function o() {
    return !!t;
  }
  function u() {
    t || (t = r ? r.addNestedSub(c) : e.subscribe(c), n = Yf());
  }
  function s() {
    t && (t(), t = void 0, n.clear(), n = _i);
  }
  const l = {
    addNestedSub: a,
    notifyNestedSubs: i,
    handleChangeWrapper: c,
    isSubscribed: o,
    trySubscribe: u,
    tryUnsubscribe: s,
    getListeners: () => n
  };
  return l;
}
const Bf = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Jf = Bf ? lo : Ae;
function Si(e, r) {
  return e === r ? e !== 0 || r !== 0 || 1 / e === 1 / r : e !== e && r !== r;
}
function $t(e, r) {
  if (Si(e, r))
    return !0;
  if (typeof e != "object" || e === null || typeof r != "object" || r === null)
    return !1;
  const t = Object.keys(e), n = Object.keys(r);
  if (t.length !== n.length)
    return !1;
  for (let a = 0; a < t.length; a++)
    if (!Object.prototype.hasOwnProperty.call(r, t[a]) || !Si(e[t[a]], r[t[a]]))
      return !1;
  return !0;
}
function Xf({
  store: e,
  context: r,
  children: t,
  serverState: n
}) {
  const a = be(() => {
    const o = Wf(e);
    return {
      store: e,
      subscription: o,
      getServerState: n ? () => n : void 0
    };
  }, [e, n]), i = be(() => e.getState(), [e]);
  Jf(() => {
    const {
      subscription: o
    } = a;
    return o.onStateChange = o.notifyNestedSubs, o.trySubscribe(), i !== e.getState() && o.notifyNestedSubs(), () => {
      o.tryUnsubscribe(), o.onStateChange = void 0;
    };
  }, [a, i]);
  const c = r || Xe;
  return /* @__PURE__ */ We.createElement(c.Provider, {
    value: a
  }, t);
}
function Jo(e = Xe) {
  const r = (
    // @ts-ignore
    e === Xe ? Ho : () => Ze(e)
  );
  return function() {
    const {
      store: n
    } = r();
    return n;
  };
}
const Xo = /* @__PURE__ */ Jo();
function Zf(e = Xe) {
  const r = (
    // @ts-ignore
    e === Xe ? Xo : Jo(e)
  );
  return function() {
    return r().dispatch;
  };
}
const el = /* @__PURE__ */ Zf();
qf($f.useSyncExternalStoreWithSelector);
Df(po);
var rl = globalThis && globalThis.__spreadArray || function(e, r) {
  for (var t = 0, n = r.length, a = e.length; t < n; t++, a++)
    e[a] = r[t];
  return e;
}, tl = Object.defineProperty, nl = Object.defineProperties, al = Object.getOwnPropertyDescriptors, Ei = Object.getOwnPropertySymbols, il = Object.prototype.hasOwnProperty, ol = Object.prototype.propertyIsEnumerable, Oi = function(e, r, t) {
  return r in e ? tl(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
}, Ye = function(e, r) {
  for (var t in r || (r = {}))
    il.call(r, t) && Oi(e, t, r[t]);
  if (Ei)
    for (var n = 0, a = Ei(r); n < a.length; n++) {
      var t = a[n];
      ol.call(r, t) && Oi(e, t, r[t]);
    }
  return e;
}, bt = function(e, r) {
  return nl(e, al(r));
};
function Pi(e, r, t, n) {
  var a = be(function() {
    return {
      queryArgs: e,
      serialized: typeof e == "object" ? r({ queryArgs: e, endpointDefinition: t, endpointName: n }) : e
    };
  }, [e, r, t, n]), i = vr(a);
  return Ae(function() {
    i.current.serialized !== a.serialized && (i.current = a);
  }, [a]), i.current.serialized === a.serialized ? i.current.queryArgs : e;
}
var wn = Symbol();
function Rn(e) {
  var r = vr(e);
  return Ae(function() {
    $t(r.current, e) || (r.current = e);
  }, [e]), $t(r.current, e) ? r.current : e;
}
var pt = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, ul = function(e) {
  var r = e.endpointName, t = e.queryArgs, n = "", a = pt == null ? void 0 : pt.get(t);
  if (typeof a == "string")
    n = a;
  else {
    var i = JSON.stringify(t, function(c, o) {
      return Je(o) ? Object.keys(o).sort().reduce(function(u, s) {
        return u[s] = o[s], u;
      }, {}) : o;
    });
    Je(t) && (pt == null || pt.set(t, i)), n = i;
  }
  return r + "(" + n + ")";
}, sl = typeof window < "u" && window.document && window.document.createElement ? lo : Ae, cl = function(e) {
  return e;
}, fl = function(e) {
  return e.isUninitialized ? bt(Ye({}, e), {
    isUninitialized: !1,
    isFetching: !0,
    isLoading: e.data === void 0,
    status: ce.pending
  }) : e;
};
function ll(e) {
  var r = e.api, t = e.moduleOptions, n = t.batch, a = t.useDispatch, i = t.useSelector, c = t.useStore, o = t.unstable__sideEffectsInRender, u = e.serializeQueryArgs, s = e.context, l = o ? function(v) {
    return v();
  } : Ae;
  return { buildQueryHooks: p, buildMutationHook: y, usePrefetch: f };
  function d(v, g, E) {
    if (g != null && g.endpointName && v.isUninitialized) {
      var P = g.endpointName, m = s.endpointDefinitions[P];
      u({
        queryArgs: g.originalArgs,
        endpointDefinition: m,
        endpointName: P
      }) === u({
        queryArgs: E,
        endpointDefinition: m,
        endpointName: P
      }) && (g = void 0);
    }
    var b = v.isSuccess ? v.data : g == null ? void 0 : g.data;
    b === void 0 && (b = v.data);
    var h = b !== void 0, _ = v.isLoading, T = !h && _, O = v.isSuccess || _ && h;
    return bt(Ye({}, v), {
      data: b,
      currentData: v.data,
      isFetching: _,
      isLoading: T,
      isSuccess: O
    });
  }
  function f(v, g) {
    var E = a(), P = Rn(g);
    return Le(function(m, b) {
      return E(r.util.prefetch(v, m, Ye(Ye({}, P), b)));
    }, [v, E, P]);
  }
  function p(v) {
    var g = function(m, b) {
      var h = b === void 0 ? {} : b, _ = h.refetchOnReconnect, T = h.refetchOnFocus, O = h.refetchOnMountOrArgChange, w = h.skip, R = w === void 0 ? !1 : w, C = h.pollingInterval, A = C === void 0 ? 0 : C, I = r.endpoints[v].initiate, x = a(), D = Pi(R ? hr : m, ul, s.endpointDefinitions[v], v), q = Rn({
        refetchOnReconnect: _,
        refetchOnFocus: T,
        pollingInterval: A
      }), k = vr(!1), U = vr(), L = U.current || {}, H = L.queryCacheKey, z = L.requestId, Y = !1;
      if (H && z) {
        var F = x(r.internalActions.internal_probeSubscription({
          queryCacheKey: H,
          requestId: z
        }));
        if (process.env.NODE_ENV !== "production" && typeof F != "boolean")
          throw new Error('Warning: Middleware for RTK-Query API at reducerPath "' + r.reducerPath + `" has not been added to the store.
    You must add the middleware for RTK-Query to function correctly!`);
        Y = !!F;
      }
      var K = !Y && k.current;
      return l(function() {
        k.current = Y;
      }), l(function() {
        K && (U.current = void 0);
      }, [K]), l(function() {
        var J, W = U.current;
        if (typeof process < "u" && process.env.NODE_ENV === "removeMeOnCompilation" && console.log(K), D === hr) {
          W == null || W.unsubscribe(), U.current = void 0;
          return;
        }
        var ae = (J = U.current) == null ? void 0 : J.subscriptionOptions;
        if (!W || W.arg !== D) {
          W == null || W.unsubscribe();
          var me = x(I(D, {
            subscriptionOptions: q,
            forceRefetch: O
          }));
          U.current = me;
        } else
          q !== ae && W.updateSubscriptionOptions(q);
      }, [
        x,
        I,
        O,
        D,
        q,
        K
      ]), Ae(function() {
        return function() {
          var J;
          (J = U.current) == null || J.unsubscribe(), U.current = void 0;
        };
      }, []), be(function() {
        return {
          refetch: function() {
            var J;
            if (!U.current)
              throw new Error("Cannot refetch a query that has not been started yet.");
            return (J = U.current) == null ? void 0 : J.refetch();
          }
        };
      }, []);
    }, E = function(m) {
      var b = m === void 0 ? {} : m, h = b.refetchOnReconnect, _ = b.refetchOnFocus, T = b.pollingInterval, O = T === void 0 ? 0 : T, w = r.endpoints[v].initiate, R = a(), C = Ir(wn), A = C[0], I = C[1], x = vr(), D = Rn({
        refetchOnReconnect: h,
        refetchOnFocus: _,
        pollingInterval: O
      });
      l(function() {
        var U, L, H = (U = x.current) == null ? void 0 : U.subscriptionOptions;
        D !== H && ((L = x.current) == null || L.updateSubscriptionOptions(D));
      }, [D]);
      var q = vr(D);
      l(function() {
        q.current = D;
      }, [D]);
      var k = Le(function(U, L) {
        L === void 0 && (L = !1);
        var H;
        return n(function() {
          var z;
          (z = x.current) == null || z.unsubscribe(), x.current = H = R(w(U, {
            subscriptionOptions: q.current,
            forceRefetch: !L
          })), I(U);
        }), H;
      }, [R, w]);
      return Ae(function() {
        return function() {
          var U;
          (U = x == null ? void 0 : x.current) == null || U.unsubscribe();
        };
      }, []), Ae(function() {
        A !== wn && !x.current && k(A, !0);
      }, [A, k]), be(function() {
        return [k, A];
      }, [k, A]);
    }, P = function(m, b) {
      var h = b === void 0 ? {} : b, _ = h.skip, T = _ === void 0 ? !1 : _, O = h.selectFromResult, w = r.endpoints[v].select, R = Pi(T ? hr : m, u, s.endpointDefinitions[v], v), C = vr(), A = be(function() {
        return Yr([
          w(R),
          function(k, U) {
            return U;
          },
          function(k) {
            return R;
          }
        ], d);
      }, [w, R]), I = be(function() {
        return O ? Yr([A], O) : A;
      }, [A, O]), x = i(function(k) {
        return I(k, C.current);
      }, $t), D = c(), q = A(D.getState(), C.current);
      return sl(function() {
        C.current = q;
      }, [q]), x;
    };
    return {
      useQueryState: P,
      useQuerySubscription: g,
      useLazyQuerySubscription: E,
      useLazyQuery: function(m) {
        var b = E(m), h = b[0], _ = b[1], T = P(_, bt(Ye({}, m), {
          skip: _ === wn
        })), O = be(function() {
          return { lastArg: _ };
        }, [_]);
        return be(function() {
          return [h, T, O];
        }, [h, T, O]);
      },
      useQuery: function(m, b) {
        var h = g(m, b), _ = P(m, Ye({
          selectFromResult: m === hr || b != null && b.skip ? void 0 : fl
        }, b)), T = _.data, O = _.status, w = _.isLoading, R = _.isSuccess, C = _.isError, A = _.error;
        return Dn({ data: T, status: O, isLoading: w, isSuccess: R, isError: C, error: A }), be(function() {
          return Ye(Ye({}, _), h);
        }, [_, h]);
      }
    };
  }
  function y(v) {
    return function(g) {
      var E = g === void 0 ? {} : g, P = E.selectFromResult, m = P === void 0 ? cl : P, b = E.fixedCacheKey, h = r.endpoints[v], _ = h.select, T = h.initiate, O = a(), w = Ir(), R = w[0], C = w[1];
      Ae(function() {
        return function() {
          R != null && R.arg.fixedCacheKey || R == null || R.reset();
        };
      }, [R]);
      var A = Le(function(W) {
        var ae = O(T(W, { fixedCacheKey: b }));
        return C(ae), ae;
      }, [O, T, b]), I = (R || {}).requestId, x = be(function() {
        return Yr([_({ fixedCacheKey: b, requestId: R == null ? void 0 : R.requestId })], m);
      }, [_, R, m, b]), D = i(x, $t), q = b == null ? R == null ? void 0 : R.arg.originalArgs : void 0, k = Le(function() {
        n(function() {
          R && C(void 0), b && O(r.internalActions.removeMutationResult({
            requestId: I,
            fixedCacheKey: b
          }));
        });
      }, [O, b, R, I]), U = D.endpointName, L = D.data, H = D.status, z = D.isLoading, Y = D.isSuccess, F = D.isError, K = D.error;
      Dn({
        endpointName: U,
        data: L,
        status: H,
        isLoading: z,
        isSuccess: Y,
        isError: F,
        error: K
      });
      var J = be(function() {
        return bt(Ye({}, D), { originalArgs: q, reset: k });
      }, [D, q, k]);
      return be(function() {
        return [A, J];
      }, [A, J]);
    };
  }
}
var Nt;
(function(e) {
  e.query = "query", e.mutation = "mutation";
})(Nt || (Nt = {}));
function dl(e) {
  return e.type === Nt.query;
}
function pl(e) {
  return e.type === Nt.mutation;
}
function Cn(e) {
  return e.replace(e[0], e[0].toUpperCase());
}
function vt(e) {
  for (var r = [], t = 1; t < arguments.length; t++)
    r[t - 1] = arguments[t];
  Object.assign.apply(Object, rl([e], r));
}
var vl = /* @__PURE__ */ Symbol(), hl = function(e) {
  var r = e === void 0 ? {} : e, t = r.batch, n = t === void 0 ? po : t, a = r.useDispatch, i = a === void 0 ? el : a, c = r.useSelector, o = c === void 0 ? Lf : c, u = r.useStore, s = u === void 0 ? Xo : u, l = r.unstable__sideEffectsInRender, d = l === void 0 ? !1 : l;
  return {
    name: vl,
    init: function(f, p, y) {
      var v = p.serializeQueryArgs, g = f, E = ll({
        api: f,
        moduleOptions: {
          batch: n,
          useDispatch: i,
          useSelector: o,
          useStore: s,
          unstable__sideEffectsInRender: d
        },
        serializeQueryArgs: v,
        context: y
      }), P = E.buildQueryHooks, m = E.buildMutationHook, b = E.usePrefetch;
      return vt(g, { usePrefetch: b }), vt(y, { batch: n }), {
        injectEndpoint: function(h, _) {
          if (dl(_)) {
            var T = P(h), O = T.useQuery, w = T.useLazyQuery, R = T.useLazyQuerySubscription, C = T.useQueryState, A = T.useQuerySubscription;
            vt(g.endpoints[h], {
              useQuery: O,
              useLazyQuery: w,
              useLazyQuerySubscription: R,
              useQueryState: C,
              useQuerySubscription: A
            }), f["use" + Cn(h) + "Query"] = O, f["useLazy" + Cn(h) + "Query"] = w;
          } else if (pl(_)) {
            var I = m(h);
            vt(g.endpoints[h], {
              useMutation: I
            }), f["use" + Cn(h) + "Mutation"] = I;
          }
        }
      };
    }
  };
};
function yl(e) {
  var r = We.useState(function() {
    var t;
    return qc({
      reducer: (t = {}, t[e.api.reducerPath] = e.api.reducer, t),
      middleware: function(n) {
        return n().concat(e.api.middleware);
      }
    });
  })[0];
  return Ae(function() {
    return e.setupListeners === !1 ? void 0 : uf(r.dispatch, e.setupListeners);
  }, [e.setupListeners, r.dispatch]), /* @__PURE__ */ We.createElement(Xf, {
    store: r,
    context: e.context
  }, e.children);
}
var gl = /* @__PURE__ */ vf(Rf(), hl());
function ml(e, r, t, n) {
  for (var a = e.length, i = t + (n ? 1 : -1); n ? i-- : ++i < a; )
    if (r(e[i], i, e))
      return i;
  return -1;
}
var bl = ml;
function _l(e) {
  return e !== e;
}
var Sl = _l;
function El(e, r, t) {
  for (var n = t - 1, a = e.length; ++n < a; )
    if (e[n] === r)
      return n;
  return -1;
}
var Ol = El, Pl = bl, Tl = Sl, wl = Ol;
function Rl(e, r, t) {
  return r === r ? wl(e, r, t) : Pl(e, Tl, t);
}
var Cl = Rl, Al = typeof ft == "object" && ft && ft.Object === Object && ft, Zo = Al, Il = Zo, xl = typeof self == "object" && self && self.Object === Object && self, $l = Il || xl || Function("return this")(), er = $l, Nl = er, Dl = Nl.Symbol, zt = Dl, Ti = zt, eu = Object.prototype, Ml = eu.hasOwnProperty, jl = eu.toString, Vr = Ti ? Ti.toStringTag : void 0;
function ql(e) {
  var r = Ml.call(e, Vr), t = e[Vr];
  try {
    e[Vr] = void 0;
    var n = !0;
  } catch {
  }
  var a = jl.call(e);
  return n && (r ? e[Vr] = t : delete e[Vr]), a;
}
var kl = ql, Ul = Object.prototype, Ll = Ul.toString;
function Fl(e) {
  return Ll.call(e);
}
var Ql = Fl, wi = zt, Vl = kl, zl = Ql, Kl = "[object Null]", Gl = "[object Undefined]", Ri = wi ? wi.toStringTag : void 0;
function Hl(e) {
  return e == null ? e === void 0 ? Gl : Kl : Ri && Ri in Object(e) ? Vl(e) : zl(e);
}
var Nr = Hl;
function Yl(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var Kt = Yl, Wl = Nr, Bl = Kt, Jl = "[object AsyncFunction]", Xl = "[object Function]", Zl = "[object GeneratorFunction]", ed = "[object Proxy]";
function rd(e) {
  if (!Bl(e))
    return !1;
  var r = Wl(e);
  return r == Xl || r == Zl || r == Jl || r == ed;
}
var ru = rd, td = 9007199254740991;
function nd(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= td;
}
var sa = nd, ad = ru, id = sa;
function od(e) {
  return e != null && id(e.length) && !ad(e);
}
var Gt = od, ud = Array.isArray, ke = ud;
function sd(e) {
  return e != null && typeof e == "object";
}
var Dr = sd, cd = Nr, fd = ke, ld = Dr, dd = "[object String]";
function pd(e) {
  return typeof e == "string" || !fd(e) && ld(e) && cd(e) == dd;
}
var vd = pd, hd = /\s/;
function yd(e) {
  for (var r = e.length; r-- && hd.test(e.charAt(r)); )
    ;
  return r;
}
var gd = yd, md = gd, bd = /^\s+/;
function _d(e) {
  return e && e.slice(0, md(e) + 1).replace(bd, "");
}
var Sd = _d, Ed = Nr, Od = Dr, Pd = "[object Symbol]";
function Td(e) {
  return typeof e == "symbol" || Od(e) && Ed(e) == Pd;
}
var Ht = Td, wd = Sd, Ci = Kt, Rd = Ht, Ai = 0 / 0, Cd = /^[-+]0x[0-9a-f]+$/i, Ad = /^0b[01]+$/i, Id = /^0o[0-7]+$/i, xd = parseInt;
function $d(e) {
  if (typeof e == "number")
    return e;
  if (Rd(e))
    return Ai;
  if (Ci(e)) {
    var r = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ci(r) ? r + "" : r;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = wd(e);
  var t = Ad.test(e);
  return t || Id.test(e) ? xd(e.slice(2), t ? 2 : 8) : Cd.test(e) ? Ai : +e;
}
var Nd = $d, Dd = Nd, Ii = 1 / 0, Md = 17976931348623157e292;
function jd(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Dd(e), e === Ii || e === -Ii) {
    var r = e < 0 ? -1 : 1;
    return r * Md;
  }
  return e === e ? e : 0;
}
var qd = jd, kd = qd;
function Ud(e) {
  var r = kd(e), t = r % 1;
  return r === r ? t ? r - t : r : 0;
}
var Ld = Ud;
function Fd(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = Array(n); ++t < n; )
    a[t] = r(e[t], t, e);
  return a;
}
var ca = Fd, Qd = ca;
function Vd(e, r) {
  return Qd(r, function(t) {
    return e[t];
  });
}
var zd = Vd;
function Kd(e, r) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = r(t);
  return n;
}
var Gd = Kd, Hd = Nr, Yd = Dr, Wd = "[object Arguments]";
function Bd(e) {
  return Yd(e) && Hd(e) == Wd;
}
var Jd = Bd, xi = Jd, Xd = Dr, tu = Object.prototype, Zd = tu.hasOwnProperty, ep = tu.propertyIsEnumerable, rp = xi(function() {
  return arguments;
}()) ? xi : function(e) {
  return Xd(e) && Zd.call(e, "callee") && !ep.call(e, "callee");
}, nu = rp, Dt = { exports: {} };
function tp() {
  return !1;
}
var np = tp;
Dt.exports;
(function(e, r) {
  var t = er, n = np, a = r && !r.nodeType && r, i = a && !0 && e && !e.nodeType && e, c = i && i.exports === a, o = c ? t.Buffer : void 0, u = o ? o.isBuffer : void 0, s = u || n;
  e.exports = s;
})(Dt, Dt.exports);
var au = Dt.exports, ap = 9007199254740991, ip = /^(?:0|[1-9]\d*)$/;
function op(e, r) {
  var t = typeof e;
  return r = r ?? ap, !!r && (t == "number" || t != "symbol" && ip.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var iu = op, up = Nr, sp = sa, cp = Dr, fp = "[object Arguments]", lp = "[object Array]", dp = "[object Boolean]", pp = "[object Date]", vp = "[object Error]", hp = "[object Function]", yp = "[object Map]", gp = "[object Number]", mp = "[object Object]", bp = "[object RegExp]", _p = "[object Set]", Sp = "[object String]", Ep = "[object WeakMap]", Op = "[object ArrayBuffer]", Pp = "[object DataView]", Tp = "[object Float32Array]", wp = "[object Float64Array]", Rp = "[object Int8Array]", Cp = "[object Int16Array]", Ap = "[object Int32Array]", Ip = "[object Uint8Array]", xp = "[object Uint8ClampedArray]", $p = "[object Uint16Array]", Np = "[object Uint32Array]", ue = {};
ue[Tp] = ue[wp] = ue[Rp] = ue[Cp] = ue[Ap] = ue[Ip] = ue[xp] = ue[$p] = ue[Np] = !0;
ue[fp] = ue[lp] = ue[Op] = ue[dp] = ue[Pp] = ue[pp] = ue[vp] = ue[hp] = ue[yp] = ue[gp] = ue[mp] = ue[bp] = ue[_p] = ue[Sp] = ue[Ep] = !1;
function Dp(e) {
  return cp(e) && sp(e.length) && !!ue[up(e)];
}
var Mp = Dp;
function jp(e) {
  return function(r) {
    return e(r);
  };
}
var qp = jp, Mt = { exports: {} };
Mt.exports;
(function(e, r) {
  var t = Zo, n = r && !r.nodeType && r, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, c = i && t.process, o = function() {
    try {
      var u = a && a.require && a.require("util").types;
      return u || c && c.binding && c.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(Mt, Mt.exports);
var kp = Mt.exports, Up = Mp, Lp = qp, $i = kp, Ni = $i && $i.isTypedArray, Fp = Ni ? Lp(Ni) : Up, ou = Fp, Qp = Gd, Vp = nu, zp = ke, Kp = au, Gp = iu, Hp = ou, Yp = Object.prototype, Wp = Yp.hasOwnProperty;
function Bp(e, r) {
  var t = zp(e), n = !t && Vp(e), a = !t && !n && Kp(e), i = !t && !n && !a && Hp(e), c = t || n || a || i, o = c ? Qp(e.length, String) : [], u = o.length;
  for (var s in e)
    (r || Wp.call(e, s)) && !(c && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    Gp(s, u))) && o.push(s);
  return o;
}
var Jp = Bp, Xp = Object.prototype;
function Zp(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || Xp;
  return e === t;
}
var ev = Zp;
function rv(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var tv = rv, nv = tv, av = nv(Object.keys, Object), iv = av, ov = ev, uv = iv, sv = Object.prototype, cv = sv.hasOwnProperty;
function fv(e) {
  if (!ov(e))
    return uv(e);
  var r = [];
  for (var t in Object(e))
    cv.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
var lv = fv, dv = Jp, pv = lv, vv = Gt;
function hv(e) {
  return vv(e) ? dv(e) : pv(e);
}
var Yt = hv, yv = zd, gv = Yt;
function mv(e) {
  return e == null ? [] : yv(e, gv(e));
}
var bv = mv, _v = Cl, Sv = Gt, Ev = vd, Ov = Ld, Pv = bv, Tv = Math.max;
function wv(e, r, t, n) {
  e = Sv(e) ? e : Pv(e), t = t && !n ? Ov(t) : 0;
  var a = e.length;
  return t < 0 && (t = Tv(a + t, 0)), Ev(e) ? t <= a && e.indexOf(r, t) > -1 : !!a && _v(e, r, t) > -1;
}
var Rv = wv;
const Di = /* @__PURE__ */ ea(Rv);
var ht, Cv = new Uint8Array(16);
function Av() {
  if (!ht && (ht = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !ht))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ht(Cv);
}
const Iv = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function xv(e) {
  return typeof e == "string" && Iv.test(e);
}
var Oe = [];
for (var An = 0; An < 256; ++An)
  Oe.push((An + 256).toString(16).substr(1));
function $v(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = (Oe[e[r + 0]] + Oe[e[r + 1]] + Oe[e[r + 2]] + Oe[e[r + 3]] + "-" + Oe[e[r + 4]] + Oe[e[r + 5]] + "-" + Oe[e[r + 6]] + Oe[e[r + 7]] + "-" + Oe[e[r + 8]] + Oe[e[r + 9]] + "-" + Oe[e[r + 10]] + Oe[e[r + 11]] + Oe[e[r + 12]] + Oe[e[r + 13]] + Oe[e[r + 14]] + Oe[e[r + 15]]).toLowerCase();
  if (!xv(t))
    throw TypeError("Stringified UUID is invalid");
  return t;
}
function Nv(e, r, t) {
  e = e || {};
  var n = e.random || (e.rng || Av)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, r) {
    t = t || 0;
    for (var a = 0; a < 16; ++a)
      r[t + a] = n[a];
    return r;
  }
  return $v(n);
}
function Dv() {
  return je().useGetMultipleDesignsMutation();
}
const uu = (e) => typeof window > "u" ? null : new URLSearchParams(window.location.search).get(e), CE = (e) => !!uu(e), Mv = "current", lr = () => {
  const e = je(), t = uu("projectId") || Mv;
  return e.useGetProjectQuery(t, {
    selectFromResult: ({ data: n, isSuccess: a }) => ({
      isSuccess: a,
      projectId: (n == null ? void 0 : n.id) || t
    })
  });
}, Wt = () => {
  const e = je(), { projectId: r, isSuccess: t } = lr();
  return e.useGetProjectQuery(r, { skip: !r || !t });
}, AE = () => je().useCreateProjectMutation();
var jv = 20, qv = 1, mr = 1e6, Mi = 1e6, kv = -7, Uv = 21, Lv = !1, ut = "[big.js] ", Sr = ut + "Invalid ", Bt = Sr + "decimal places", Fv = Sr + "rounding mode", su = ut + "Division by zero", ne = {}, Ve = void 0, Qv = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
function cu() {
  function e(r) {
    var t = this;
    if (!(t instanceof e))
      return r === Ve ? cu() : new e(r);
    if (r instanceof e)
      t.s = r.s, t.e = r.e, t.c = r.c.slice();
    else {
      if (typeof r != "string") {
        if (e.strict === !0 && typeof r != "bigint")
          throw TypeError(Sr + "value");
        r = r === 0 && 1 / r < 0 ? "-0" : String(r);
      }
      Vv(t, r);
    }
    t.constructor = e;
  }
  return e.prototype = ne, e.DP = jv, e.RM = qv, e.NE = kv, e.PE = Uv, e.strict = Lv, e.roundDown = 0, e.roundHalfUp = 1, e.roundHalfEven = 2, e.roundUp = 3, e;
}
function Vv(e, r) {
  var t, n, a;
  if (!Qv.test(r))
    throw Error(Sr + "number");
  for (e.s = r.charAt(0) == "-" ? (r = r.slice(1), -1) : 1, (t = r.indexOf(".")) > -1 && (r = r.replace(".", "")), (n = r.search(/e/i)) > 0 ? (t < 0 && (t = n), t += +r.slice(n + 1), r = r.substring(0, n)) : t < 0 && (t = r.length), a = r.length, n = 0; n < a && r.charAt(n) == "0"; )
    ++n;
  if (n == a)
    e.c = [e.e = 0];
  else {
    for (; a > 0 && r.charAt(--a) == "0"; )
      ;
    for (e.e = t - n - 1, e.c = [], t = 0; n <= a; )
      e.c[t++] = +r.charAt(n++);
  }
  return e;
}
function Er(e, r, t, n) {
  var a = e.c;
  if (t === Ve && (t = e.constructor.RM), t !== 0 && t !== 1 && t !== 2 && t !== 3)
    throw Error(Fv);
  if (r < 1)
    n = t === 3 && (n || !!a[0]) || r === 0 && (t === 1 && a[0] >= 5 || t === 2 && (a[0] > 5 || a[0] === 5 && (n || a[1] !== Ve))), a.length = 1, n ? (e.e = e.e - r + 1, a[0] = 1) : a[0] = e.e = 0;
  else if (r < a.length) {
    if (n = t === 1 && a[r] >= 5 || t === 2 && (a[r] > 5 || a[r] === 5 && (n || a[r + 1] !== Ve || a[r - 1] & 1)) || t === 3 && (n || !!a[0]), a.length = r, n) {
      for (; ++a[--r] > 9; )
        if (a[r] = 0, r === 0) {
          ++e.e, a.unshift(1);
          break;
        }
    }
    for (r = a.length; !a[--r]; )
      a.pop();
  }
  return e;
}
function Mr(e, r, t) {
  var n = e.e, a = e.c.join(""), i = a.length;
  if (r)
    a = a.charAt(0) + (i > 1 ? "." + a.slice(1) : "") + (n < 0 ? "e" : "e+") + n;
  else if (n < 0) {
    for (; ++n; )
      a = "0" + a;
    a = "0." + a;
  } else if (n > 0)
    if (++n > i)
      for (n -= i; n--; )
        a += "0";
    else
      n < i && (a = a.slice(0, n) + "." + a.slice(n));
  else
    i > 1 && (a = a.charAt(0) + "." + a.slice(1));
  return e.s < 0 && t ? "-" + a : a;
}
ne.abs = function() {
  var e = new this.constructor(this);
  return e.s = 1, e;
};
ne.cmp = function(e) {
  var r, t = this, n = t.c, a = (e = new t.constructor(e)).c, i = t.s, c = e.s, o = t.e, u = e.e;
  if (!n[0] || !a[0])
    return n[0] ? i : a[0] ? -c : 0;
  if (i != c)
    return i;
  if (r = i < 0, o != u)
    return o > u ^ r ? 1 : -1;
  for (c = (o = n.length) < (u = a.length) ? o : u, i = -1; ++i < c; )
    if (n[i] != a[i])
      return n[i] > a[i] ^ r ? 1 : -1;
  return o == u ? 0 : o > u ^ r ? 1 : -1;
};
ne.div = function(e) {
  var r = this, t = r.constructor, n = r.c, a = (e = new t(e)).c, i = r.s == e.s ? 1 : -1, c = t.DP;
  if (c !== ~~c || c < 0 || c > mr)
    throw Error(Bt);
  if (!a[0])
    throw Error(su);
  if (!n[0])
    return e.s = i, e.c = [e.e = 0], e;
  var o, u, s, l, d, f = a.slice(), p = o = a.length, y = n.length, v = n.slice(0, o), g = v.length, E = e, P = E.c = [], m = 0, b = c + (E.e = r.e - e.e) + 1;
  for (E.s = i, i = b < 0 ? 0 : b, f.unshift(0); g++ < o; )
    v.push(0);
  do {
    for (s = 0; s < 10; s++) {
      if (o != (g = v.length))
        l = o > g ? 1 : -1;
      else
        for (d = -1, l = 0; ++d < o; )
          if (a[d] != v[d]) {
            l = a[d] > v[d] ? 1 : -1;
            break;
          }
      if (l < 0) {
        for (u = g == o ? a : f; g; ) {
          if (v[--g] < u[g]) {
            for (d = g; d && !v[--d]; )
              v[d] = 9;
            --v[d], v[g] += 10;
          }
          v[g] -= u[g];
        }
        for (; !v[0]; )
          v.shift();
      } else
        break;
    }
    P[m++] = l ? s : ++s, v[0] && l ? v[g] = n[p] || 0 : v = [n[p]];
  } while ((p++ < y || v[0] !== Ve) && i--);
  return !P[0] && m != 1 && (P.shift(), E.e--, b--), m > b && Er(E, b, t.RM, v[0] !== Ve), E;
};
ne.eq = function(e) {
  return this.cmp(e) === 0;
};
ne.gt = function(e) {
  return this.cmp(e) > 0;
};
ne.gte = function(e) {
  return this.cmp(e) > -1;
};
ne.lt = function(e) {
  return this.cmp(e) < 0;
};
ne.lte = function(e) {
  return this.cmp(e) < 1;
};
ne.minus = ne.sub = function(e) {
  var r, t, n, a, i = this, c = i.constructor, o = i.s, u = (e = new c(e)).s;
  if (o != u)
    return e.s = -u, i.plus(e);
  var s = i.c.slice(), l = i.e, d = e.c, f = e.e;
  if (!s[0] || !d[0])
    return d[0] ? e.s = -u : s[0] ? e = new c(i) : e.s = 1, e;
  if (o = l - f) {
    for ((a = o < 0) ? (o = -o, n = s) : (f = l, n = d), n.reverse(), u = o; u--; )
      n.push(0);
    n.reverse();
  } else
    for (t = ((a = s.length < d.length) ? s : d).length, o = u = 0; u < t; u++)
      if (s[u] != d[u]) {
        a = s[u] < d[u];
        break;
      }
  if (a && (n = s, s = d, d = n, e.s = -e.s), (u = (t = d.length) - (r = s.length)) > 0)
    for (; u--; )
      s[r++] = 0;
  for (u = r; t > o; ) {
    if (s[--t] < d[t]) {
      for (r = t; r && !s[--r]; )
        s[r] = 9;
      --s[r], s[t] += 10;
    }
    s[t] -= d[t];
  }
  for (; s[--u] === 0; )
    s.pop();
  for (; s[0] === 0; )
    s.shift(), --f;
  return s[0] || (e.s = 1, s = [f = 0]), e.c = s, e.e = f, e;
};
ne.mod = function(e) {
  var r, t = this, n = t.constructor, a = t.s, i = (e = new n(e)).s;
  if (!e.c[0])
    throw Error(su);
  return t.s = e.s = 1, r = e.cmp(t) == 1, t.s = a, e.s = i, r ? new n(t) : (a = n.DP, i = n.RM, n.DP = n.RM = 0, t = t.div(e), n.DP = a, n.RM = i, this.minus(t.times(e)));
};
ne.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, e;
};
ne.plus = ne.add = function(e) {
  var r, t, n, a = this, i = a.constructor;
  if (e = new i(e), a.s != e.s)
    return e.s = -e.s, a.minus(e);
  var c = a.e, o = a.c, u = e.e, s = e.c;
  if (!o[0] || !s[0])
    return s[0] || (o[0] ? e = new i(a) : e.s = a.s), e;
  if (o = o.slice(), r = c - u) {
    for (r > 0 ? (u = c, n = s) : (r = -r, n = o), n.reverse(); r--; )
      n.push(0);
    n.reverse();
  }
  for (o.length - s.length < 0 && (n = s, s = o, o = n), r = s.length, t = 0; r; o[r] %= 10)
    t = (o[--r] = o[r] + s[r] + t) / 10 | 0;
  for (t && (o.unshift(t), ++u), r = o.length; o[--r] === 0; )
    o.pop();
  return e.c = o, e.e = u, e;
};
ne.pow = function(e) {
  var r = this, t = new r.constructor("1"), n = t, a = e < 0;
  if (e !== ~~e || e < -Mi || e > Mi)
    throw Error(Sr + "exponent");
  for (a && (e = -e); e & 1 && (n = n.times(r)), e >>= 1, !!e; )
    r = r.times(r);
  return a ? t.div(n) : n;
};
ne.prec = function(e, r) {
  if (e !== ~~e || e < 1 || e > mr)
    throw Error(Sr + "precision");
  return Er(new this.constructor(this), e, r);
};
ne.round = function(e, r) {
  if (e === Ve)
    e = 0;
  else if (e !== ~~e || e < -mr || e > mr)
    throw Error(Bt);
  return Er(new this.constructor(this), e + this.e + 1, r);
};
ne.sqrt = function() {
  var e, r, t, n = this, a = n.constructor, i = n.s, c = n.e, o = new a("0.5");
  if (!n.c[0])
    return new a(n);
  if (i < 0)
    throw Error(ut + "No square root");
  i = Math.sqrt(n + ""), i === 0 || i === 1 / 0 ? (r = n.c.join(""), r.length + c & 1 || (r += "0"), i = Math.sqrt(r), c = ((c + 1) / 2 | 0) - (c < 0 || c & 1), e = new a((i == 1 / 0 ? "5e" : (i = i.toExponential()).slice(0, i.indexOf("e") + 1)) + c)) : e = new a(i + ""), c = e.e + (a.DP += 4);
  do
    t = e, e = o.times(t.plus(n.div(t)));
  while (t.c.slice(0, c).join("") !== e.c.slice(0, c).join(""));
  return Er(e, (a.DP -= 4) + e.e + 1, a.RM);
};
ne.times = ne.mul = function(e) {
  var r, t = this, n = t.constructor, a = t.c, i = (e = new n(e)).c, c = a.length, o = i.length, u = t.e, s = e.e;
  if (e.s = t.s == e.s ? 1 : -1, !a[0] || !i[0])
    return e.c = [e.e = 0], e;
  for (e.e = u + s, c < o && (r = a, a = i, i = r, s = c, c = o, o = s), r = new Array(s = c + o); s--; )
    r[s] = 0;
  for (u = o; u--; ) {
    for (o = 0, s = c + u; s > u; )
      o = r[s] + i[u] * a[s - u - 1] + o, r[s--] = o % 10, o = o / 10 | 0;
    r[s] = o;
  }
  for (o ? ++e.e : r.shift(), u = r.length; !r[--u]; )
    r.pop();
  return e.c = r, e;
};
ne.toExponential = function(e, r) {
  var t = this, n = t.c[0];
  if (e !== Ve) {
    if (e !== ~~e || e < 0 || e > mr)
      throw Error(Bt);
    for (t = Er(new t.constructor(t), ++e, r); t.c.length < e; )
      t.c.push(0);
  }
  return Mr(t, !0, !!n);
};
ne.toFixed = function(e, r) {
  var t = this, n = t.c[0];
  if (e !== Ve) {
    if (e !== ~~e || e < 0 || e > mr)
      throw Error(Bt);
    for (t = Er(new t.constructor(t), e + t.e + 1, r), e = e + t.e + 1; t.c.length < e; )
      t.c.push(0);
  }
  return Mr(t, !1, !!n);
};
ne[Symbol.for("nodejs.util.inspect.custom")] = ne.toJSON = ne.toString = function() {
  var e = this, r = e.constructor;
  return Mr(e, e.e <= r.NE || e.e >= r.PE, !!e.c[0]);
};
ne.toNumber = function() {
  var e = Number(Mr(this, !0, !0));
  if (this.constructor.strict === !0 && !this.eq(e.toString()))
    throw Error(ut + "Imprecise conversion");
  return e;
};
ne.toPrecision = function(e, r) {
  var t = this, n = t.constructor, a = t.c[0];
  if (e !== Ve) {
    if (e !== ~~e || e < 1 || e > mr)
      throw Error(Sr + "precision");
    for (t = Er(new n(t), e, r); t.c.length < e; )
      t.c.push(0);
  }
  return Mr(t, e <= t.e || t.e <= n.NE || t.e >= n.PE, !!a);
};
ne.valueOf = function() {
  var e = this, r = e.constructor;
  if (r.strict === !0)
    throw Error(ut + "valueOf disallowed");
  return Mr(e, e.e <= r.NE || e.e >= r.PE, !0);
};
var $e = cu();
const fu = (e) => e.reduce((r, t) => {
  var a;
  const n = (a = t.design) == null ? void 0 : a.cid;
  if (n) {
    const i = r[n] || [];
    i.push(t), r[n] = i;
  }
  return r;
}, {}), ji = (e = "") => /([$])/g.test(e), zv = (e) => {
  const r = { ...e };
  return Object.keys(e).forEach((t) => {
    var s, l, d, f;
    const n = e[t], a = r[t], i = n.super_rush_shipping, c = ji(
      (s = n.super_rush_shipping) == null ? void 0 : s.charge
    );
    i && !c && qi(
      i,
      e[t].total_price,
      a.super_rush_shipping,
      (l = e[t].voucher) == null ? void 0 : l.discount
    );
    const o = n.rush_shipping, u = ji(
      (d = n.rush_shipping) == null ? void 0 : d.charge
    );
    o && !u && (qi(
      o,
      e[t].total_price,
      a.rush_shipping,
      (f = e[t].voucher) == null ? void 0 : f.discount
    ), a.standard_shipping && (a.standard_shipping.delivery_price = "0.00")), n.rush_shipping && u && ki(
      n.rush_shipping,
      a.rush_shipping
    ), n.super_rush_shipping && c && ki(
      n.super_rush_shipping,
      a.super_rush_shipping
    ), a.standard_shipping && (a.standard_shipping.delivery_price = "0.00");
  }), r;
}, qi = (e, r, t, n) => {
  var o;
  const a = n ? $e(r || "0").minus(n) : r, i = (o = e.charge) == null ? void 0 : o.split("%", 1), c = $e((i == null ? void 0 : i[0]) || "0").times("0.01").times($e(a || "0")).toFixed(2);
  t && (t.delivery_price = c);
}, ki = (e, r) => {
  var n;
  const t = (n = e.charge) == null ? void 0 : n.split("$");
  r && (r.delivery_price = $e((t == null ? void 0 : t[1]) || "0").toFixed(2));
}, Kv = (e) => e.split(/\s*@\s*\$/), Gv = (e) => {
  const r = /(.*)\s+(\d+$)/;
  return e.reduce((t, n) => {
    const [a, i] = Kv(n);
    return a.split(/,\s*/).forEach((c) => {
      const o = c.match(r), [u, s] = (o == null ? void 0 : o.slice(1)) || [];
      u && (t[u] = {
        quantity: parseInt(s, 10),
        subtotal: $e(s).times(i).toFixed(2),
        unitPrice: i
      });
    }), t;
  }, {});
}, Hv = (e) => Object.values(e).reduce((r, t) => $e(r).add(t.subtotal), $e(0)).toFixed(2);
function lu(e, r, t, n) {
  const a = (e + (n || "")).toString().includes("%");
  if (typeof e == "string" ? [e, r, t, n] = e.match(/(0?\.?\d+)%?\b/g).map((i) => Number(i)) : n !== void 0 && (n = Number.parseFloat(n)), typeof e != "number" || typeof r != "number" || typeof t != "number" || e > 255 || r > 255 || t > 255)
    throw new TypeError("Expected three numbers below 256");
  if (typeof n == "number") {
    if (!a && n >= 0 && n <= 1)
      n = Math.round(255 * n);
    else if (a && n >= 0 && n <= 100)
      n = Math.round(255 * n / 100);
    else
      throw new TypeError(`Expected alpha value (${n}) as a fraction or percentage`);
    n = (n | 256).toString(16).slice(1);
  } else
    n = "";
  return (t | r << 8 | e << 16 | 1 << 24).toString(16).slice(1) + n;
}
function Yv() {
  this.__data__ = [], this.size = 0;
}
var Wv = Yv;
function Bv(e, r) {
  return e === r || e !== e && r !== r;
}
var du = Bv, Jv = du;
function Xv(e, r) {
  for (var t = e.length; t--; )
    if (Jv(e[t][0], r))
      return t;
  return -1;
}
var Jt = Xv, Zv = Jt, eh = Array.prototype, rh = eh.splice;
function th(e) {
  var r = this.__data__, t = Zv(r, e);
  if (t < 0)
    return !1;
  var n = r.length - 1;
  return t == n ? r.pop() : rh.call(r, t, 1), --this.size, !0;
}
var nh = th, ah = Jt;
function ih(e) {
  var r = this.__data__, t = ah(r, e);
  return t < 0 ? void 0 : r[t][1];
}
var oh = ih, uh = Jt;
function sh(e) {
  return uh(this.__data__, e) > -1;
}
var ch = sh, fh = Jt;
function lh(e, r) {
  var t = this.__data__, n = fh(t, e);
  return n < 0 ? (++this.size, t.push([e, r])) : t[n][1] = r, this;
}
var dh = lh, ph = Wv, vh = nh, hh = oh, yh = ch, gh = dh;
function jr(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
jr.prototype.clear = ph;
jr.prototype.delete = vh;
jr.prototype.get = hh;
jr.prototype.has = yh;
jr.prototype.set = gh;
var Xt = jr, mh = Xt;
function bh() {
  this.__data__ = new mh(), this.size = 0;
}
var _h = bh;
function Sh(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
var Eh = Sh;
function Oh(e) {
  return this.__data__.get(e);
}
var Ph = Oh;
function Th(e) {
  return this.__data__.has(e);
}
var wh = Th, Rh = er, Ch = Rh["__core-js_shared__"], Ah = Ch, In = Ah, Ui = function() {
  var e = /[^.]+$/.exec(In && In.keys && In.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Ih(e) {
  return !!Ui && Ui in e;
}
var xh = Ih, $h = Function.prototype, Nh = $h.toString;
function Dh(e) {
  if (e != null) {
    try {
      return Nh.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var pu = Dh, Mh = ru, jh = xh, qh = Kt, kh = pu, Uh = /[\\^$.*+?()[\]{}|]/g, Lh = /^\[object .+?Constructor\]$/, Fh = Function.prototype, Qh = Object.prototype, Vh = Fh.toString, zh = Qh.hasOwnProperty, Kh = RegExp(
  "^" + Vh.call(zh).replace(Uh, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Gh(e) {
  if (!qh(e) || jh(e))
    return !1;
  var r = Mh(e) ? Kh : Lh;
  return r.test(kh(e));
}
var Hh = Gh;
function Yh(e, r) {
  return e == null ? void 0 : e[r];
}
var Wh = Yh, Bh = Hh, Jh = Wh;
function Xh(e, r) {
  var t = Jh(e, r);
  return Bh(t) ? t : void 0;
}
var qr = Xh, Zh = qr, ey = er, ry = Zh(ey, "Map"), fa = ry, ty = qr, ny = ty(Object, "create"), Zt = ny, Li = Zt;
function ay() {
  this.__data__ = Li ? Li(null) : {}, this.size = 0;
}
var iy = ay;
function oy(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var uy = oy, sy = Zt, cy = "__lodash_hash_undefined__", fy = Object.prototype, ly = fy.hasOwnProperty;
function dy(e) {
  var r = this.__data__;
  if (sy) {
    var t = r[e];
    return t === cy ? void 0 : t;
  }
  return ly.call(r, e) ? r[e] : void 0;
}
var py = dy, vy = Zt, hy = Object.prototype, yy = hy.hasOwnProperty;
function gy(e) {
  var r = this.__data__;
  return vy ? r[e] !== void 0 : yy.call(r, e);
}
var my = gy, by = Zt, _y = "__lodash_hash_undefined__";
function Sy(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = by && r === void 0 ? _y : r, this;
}
var Ey = Sy, Oy = iy, Py = uy, Ty = py, wy = my, Ry = Ey;
function kr(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
kr.prototype.clear = Oy;
kr.prototype.delete = Py;
kr.prototype.get = Ty;
kr.prototype.has = wy;
kr.prototype.set = Ry;
var Cy = kr, Fi = Cy, Ay = Xt, Iy = fa;
function xy() {
  this.size = 0, this.__data__ = {
    hash: new Fi(),
    map: new (Iy || Ay)(),
    string: new Fi()
  };
}
var $y = xy;
function Ny(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
var Dy = Ny, My = Dy;
function jy(e, r) {
  var t = e.__data__;
  return My(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
var en = jy, qy = en;
function ky(e) {
  var r = qy(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
var Uy = ky, Ly = en;
function Fy(e) {
  return Ly(this, e).get(e);
}
var Qy = Fy, Vy = en;
function zy(e) {
  return Vy(this, e).has(e);
}
var Ky = zy, Gy = en;
function Hy(e, r) {
  var t = Gy(this, e), n = t.size;
  return t.set(e, r), this.size += t.size == n ? 0 : 1, this;
}
var Yy = Hy, Wy = $y, By = Uy, Jy = Qy, Xy = Ky, Zy = Yy;
function Ur(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Ur.prototype.clear = Wy;
Ur.prototype.delete = By;
Ur.prototype.get = Jy;
Ur.prototype.has = Xy;
Ur.prototype.set = Zy;
var la = Ur, eg = Xt, rg = fa, tg = la, ng = 200;
function ag(e, r) {
  var t = this.__data__;
  if (t instanceof eg) {
    var n = t.__data__;
    if (!rg || n.length < ng - 1)
      return n.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new tg(n);
  }
  return t.set(e, r), this.size = t.size, this;
}
var ig = ag, og = Xt, ug = _h, sg = Eh, cg = Ph, fg = wh, lg = ig;
function Lr(e) {
  var r = this.__data__ = new og(e);
  this.size = r.size;
}
Lr.prototype.clear = ug;
Lr.prototype.delete = sg;
Lr.prototype.get = cg;
Lr.prototype.has = fg;
Lr.prototype.set = lg;
var vu = Lr, dg = "__lodash_hash_undefined__";
function pg(e) {
  return this.__data__.set(e, dg), this;
}
var vg = pg;
function hg(e) {
  return this.__data__.has(e);
}
var yg = hg, gg = la, mg = vg, bg = yg;
function jt(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new gg(); ++r < t; )
    this.add(e[r]);
}
jt.prototype.add = jt.prototype.push = mg;
jt.prototype.has = bg;
var _g = jt;
function Sg(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n; )
    if (r(e[t], t, e))
      return !0;
  return !1;
}
var Eg = Sg;
function Og(e, r) {
  return e.has(r);
}
var Pg = Og, Tg = _g, wg = Eg, Rg = Pg, Cg = 1, Ag = 2;
function Ig(e, r, t, n, a, i) {
  var c = t & Cg, o = e.length, u = r.length;
  if (o != u && !(c && u > o))
    return !1;
  var s = i.get(e), l = i.get(r);
  if (s && l)
    return s == r && l == e;
  var d = -1, f = !0, p = t & Ag ? new Tg() : void 0;
  for (i.set(e, r), i.set(r, e); ++d < o; ) {
    var y = e[d], v = r[d];
    if (n)
      var g = c ? n(v, y, d, r, e, i) : n(y, v, d, e, r, i);
    if (g !== void 0) {
      if (g)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!wg(r, function(E, P) {
        if (!Rg(p, P) && (y === E || a(y, E, t, n, i)))
          return p.push(P);
      })) {
        f = !1;
        break;
      }
    } else if (!(y === v || a(y, v, t, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(r), f;
}
var hu = Ig, xg = er, $g = xg.Uint8Array, Ng = $g;
function Dg(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(n, a) {
    t[++r] = [a, n];
  }), t;
}
var Mg = Dg;
function jg(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(n) {
    t[++r] = n;
  }), t;
}
var qg = jg, Qi = zt, Vi = Ng, kg = du, Ug = hu, Lg = Mg, Fg = qg, Qg = 1, Vg = 2, zg = "[object Boolean]", Kg = "[object Date]", Gg = "[object Error]", Hg = "[object Map]", Yg = "[object Number]", Wg = "[object RegExp]", Bg = "[object Set]", Jg = "[object String]", Xg = "[object Symbol]", Zg = "[object ArrayBuffer]", em = "[object DataView]", zi = Qi ? Qi.prototype : void 0, xn = zi ? zi.valueOf : void 0;
function rm(e, r, t, n, a, i, c) {
  switch (t) {
    case em:
      if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
        return !1;
      e = e.buffer, r = r.buffer;
    case Zg:
      return !(e.byteLength != r.byteLength || !i(new Vi(e), new Vi(r)));
    case zg:
    case Kg:
    case Yg:
      return kg(+e, +r);
    case Gg:
      return e.name == r.name && e.message == r.message;
    case Wg:
    case Jg:
      return e == r + "";
    case Hg:
      var o = Lg;
    case Bg:
      var u = n & Qg;
      if (o || (o = Fg), e.size != r.size && !u)
        return !1;
      var s = c.get(e);
      if (s)
        return s == r;
      n |= Vg, c.set(e, r);
      var l = Ug(o(e), o(r), n, a, i, c);
      return c.delete(e), l;
    case Xg:
      if (xn)
        return xn.call(e) == xn.call(r);
  }
  return !1;
}
var tm = rm;
function nm(e, r) {
  for (var t = -1, n = r.length, a = e.length; ++t < n; )
    e[a + t] = r[t];
  return e;
}
var am = nm, im = am, om = ke;
function um(e, r, t) {
  var n = r(e);
  return om(e) ? n : im(n, t(e));
}
var sm = um;
function cm(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++t < n; ) {
    var c = e[t];
    r(c, t, e) && (i[a++] = c);
  }
  return i;
}
var fm = cm;
function lm() {
  return [];
}
var dm = lm, pm = fm, vm = dm, hm = Object.prototype, ym = hm.propertyIsEnumerable, Ki = Object.getOwnPropertySymbols, gm = Ki ? function(e) {
  return e == null ? [] : (e = Object(e), pm(Ki(e), function(r) {
    return ym.call(e, r);
  }));
} : vm, mm = gm, bm = sm, _m = mm, Sm = Yt;
function Em(e) {
  return bm(e, Sm, _m);
}
var Om = Em, Gi = Om, Pm = 1, Tm = Object.prototype, wm = Tm.hasOwnProperty;
function Rm(e, r, t, n, a, i) {
  var c = t & Pm, o = Gi(e), u = o.length, s = Gi(r), l = s.length;
  if (u != l && !c)
    return !1;
  for (var d = u; d--; ) {
    var f = o[d];
    if (!(c ? f in r : wm.call(r, f)))
      return !1;
  }
  var p = i.get(e), y = i.get(r);
  if (p && y)
    return p == r && y == e;
  var v = !0;
  i.set(e, r), i.set(r, e);
  for (var g = c; ++d < u; ) {
    f = o[d];
    var E = e[f], P = r[f];
    if (n)
      var m = c ? n(P, E, f, r, e, i) : n(E, P, f, e, r, i);
    if (!(m === void 0 ? E === P || a(E, P, t, n, i) : m)) {
      v = !1;
      break;
    }
    g || (g = f == "constructor");
  }
  if (v && !g) {
    var b = e.constructor, h = r.constructor;
    b != h && "constructor" in e && "constructor" in r && !(typeof b == "function" && b instanceof b && typeof h == "function" && h instanceof h) && (v = !1);
  }
  return i.delete(e), i.delete(r), v;
}
var Cm = Rm, Am = qr, Im = er, xm = Am(Im, "DataView"), $m = xm, Nm = qr, Dm = er, Mm = Nm(Dm, "Promise"), jm = Mm, qm = qr, km = er, Um = qm(km, "Set"), Lm = Um, Fm = qr, Qm = er, Vm = Fm(Qm, "WeakMap"), zm = Vm, Wn = $m, Bn = fa, Jn = jm, Xn = Lm, Zn = zm, yu = Nr, Fr = pu, Hi = "[object Map]", Km = "[object Object]", Yi = "[object Promise]", Wi = "[object Set]", Bi = "[object WeakMap]", Ji = "[object DataView]", Gm = Fr(Wn), Hm = Fr(Bn), Ym = Fr(Jn), Wm = Fr(Xn), Bm = Fr(Zn), pr = yu;
(Wn && pr(new Wn(new ArrayBuffer(1))) != Ji || Bn && pr(new Bn()) != Hi || Jn && pr(Jn.resolve()) != Yi || Xn && pr(new Xn()) != Wi || Zn && pr(new Zn()) != Bi) && (pr = function(e) {
  var r = yu(e), t = r == Km ? e.constructor : void 0, n = t ? Fr(t) : "";
  if (n)
    switch (n) {
      case Gm:
        return Ji;
      case Hm:
        return Hi;
      case Ym:
        return Yi;
      case Wm:
        return Wi;
      case Bm:
        return Bi;
    }
  return r;
});
var Jm = pr, $n = vu, Xm = hu, Zm = tm, eb = Cm, Xi = Jm, Zi = ke, eo = au, rb = ou, tb = 1, ro = "[object Arguments]", to = "[object Array]", yt = "[object Object]", nb = Object.prototype, no = nb.hasOwnProperty;
function ab(e, r, t, n, a, i) {
  var c = Zi(e), o = Zi(r), u = c ? to : Xi(e), s = o ? to : Xi(r);
  u = u == ro ? yt : u, s = s == ro ? yt : s;
  var l = u == yt, d = s == yt, f = u == s;
  if (f && eo(e)) {
    if (!eo(r))
      return !1;
    c = !0, l = !1;
  }
  if (f && !l)
    return i || (i = new $n()), c || rb(e) ? Xm(e, r, t, n, a, i) : Zm(e, r, u, t, n, a, i);
  if (!(t & tb)) {
    var p = l && no.call(e, "__wrapped__"), y = d && no.call(r, "__wrapped__");
    if (p || y) {
      var v = p ? e.value() : e, g = y ? r.value() : r;
      return i || (i = new $n()), a(v, g, t, n, i);
    }
  }
  return f ? (i || (i = new $n()), eb(e, r, t, n, a, i)) : !1;
}
var ib = ab, ob = ib, ao = Dr;
function gu(e, r, t, n, a) {
  return e === r ? !0 : e == null || r == null || !ao(e) && !ao(r) ? e !== e && r !== r : ob(e, r, t, n, gu, a);
}
var mu = gu, ub = vu, sb = mu, cb = 1, fb = 2;
function lb(e, r, t, n) {
  var a = t.length, i = a, c = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var o = t[a];
    if (c && o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    o = t[a];
    var u = o[0], s = e[u], l = o[1];
    if (c && o[2]) {
      if (s === void 0 && !(u in e))
        return !1;
    } else {
      var d = new ub();
      if (n)
        var f = n(s, l, u, e, r, d);
      if (!(f === void 0 ? sb(l, s, cb | fb, n, d) : f))
        return !1;
    }
  }
  return !0;
}
var db = lb, pb = Kt;
function vb(e) {
  return e === e && !pb(e);
}
var bu = vb, hb = bu, yb = Yt;
function gb(e) {
  for (var r = yb(e), t = r.length; t--; ) {
    var n = r[t], a = e[n];
    r[t] = [n, a, hb(a)];
  }
  return r;
}
var mb = gb;
function bb(e, r) {
  return function(t) {
    return t == null ? !1 : t[e] === r && (r !== void 0 || e in Object(t));
  };
}
var _u = bb, _b = db, Sb = mb, Eb = _u;
function Ob(e) {
  var r = Sb(e);
  return r.length == 1 && r[0][2] ? Eb(r[0][0], r[0][1]) : function(t) {
    return t === e || _b(t, e, r);
  };
}
var Pb = Ob, Tb = ke, wb = Ht, Rb = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Cb = /^\w*$/;
function Ab(e, r) {
  if (Tb(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || wb(e) ? !0 : Cb.test(e) || !Rb.test(e) || r != null && e in Object(r);
}
var da = Ab, Su = la, Ib = "Expected a function";
function pa(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(Ib);
  var t = function() {
    var n = arguments, a = r ? r.apply(this, n) : n[0], i = t.cache;
    if (i.has(a))
      return i.get(a);
    var c = e.apply(this, n);
    return t.cache = i.set(a, c) || i, c;
  };
  return t.cache = new (pa.Cache || Su)(), t;
}
pa.Cache = Su;
var xb = pa, $b = xb, Nb = 500;
function Db(e) {
  var r = $b(e, function(n) {
    return t.size === Nb && t.clear(), n;
  }), t = r.cache;
  return r;
}
var Mb = Db, jb = Mb, qb = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, kb = /\\(\\)?/g, Ub = jb(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(qb, function(t, n, a, i) {
    r.push(a ? i.replace(kb, "$1") : n || t);
  }), r;
}), Lb = Ub, io = zt, Fb = ca, Qb = ke, Vb = Ht, zb = 1 / 0, oo = io ? io.prototype : void 0, uo = oo ? oo.toString : void 0;
function Eu(e) {
  if (typeof e == "string")
    return e;
  if (Qb(e))
    return Fb(e, Eu) + "";
  if (Vb(e))
    return uo ? uo.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -zb ? "-0" : r;
}
var Kb = Eu, Gb = Kb;
function Hb(e) {
  return e == null ? "" : Gb(e);
}
var Yb = Hb, Wb = ke, Bb = da, Jb = Lb, Xb = Yb;
function Zb(e, r) {
  return Wb(e) ? e : Bb(e, r) ? [e] : Jb(Xb(e));
}
var Ou = Zb, e_ = Ht, r_ = 1 / 0;
function t_(e) {
  if (typeof e == "string" || e_(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -r_ ? "-0" : r;
}
var rn = t_, n_ = Ou, a_ = rn;
function i_(e, r) {
  r = n_(r, e);
  for (var t = 0, n = r.length; e != null && t < n; )
    e = e[a_(r[t++])];
  return t && t == n ? e : void 0;
}
var Pu = i_, o_ = Pu;
function u_(e, r, t) {
  var n = e == null ? void 0 : o_(e, r);
  return n === void 0 ? t : n;
}
var s_ = u_;
function c_(e, r) {
  return e != null && r in Object(e);
}
var f_ = c_, l_ = Ou, d_ = nu, p_ = ke, v_ = iu, h_ = sa, y_ = rn;
function g_(e, r, t) {
  r = l_(r, e);
  for (var n = -1, a = r.length, i = !1; ++n < a; ) {
    var c = y_(r[n]);
    if (!(i = e != null && t(e, c)))
      break;
    e = e[c];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && h_(a) && v_(c, a) && (p_(e) || d_(e)));
}
var m_ = g_, b_ = f_, __ = m_;
function S_(e, r) {
  return e != null && __(e, r, b_);
}
var E_ = S_, O_ = mu, P_ = s_, T_ = E_, w_ = da, R_ = bu, C_ = _u, A_ = rn, I_ = 1, x_ = 2;
function $_(e, r) {
  return w_(e) && R_(r) ? C_(A_(e), r) : function(t) {
    var n = P_(t, e);
    return n === void 0 && n === r ? T_(t, e) : O_(r, n, I_ | x_);
  };
}
var N_ = $_;
function D_(e) {
  return e;
}
var M_ = D_;
function j_(e) {
  return function(r) {
    return r == null ? void 0 : r[e];
  };
}
var q_ = j_, k_ = Pu;
function U_(e) {
  return function(r) {
    return k_(r, e);
  };
}
var L_ = U_, F_ = q_, Q_ = L_, V_ = da, z_ = rn;
function K_(e) {
  return V_(e) ? F_(z_(e)) : Q_(e);
}
var G_ = K_, H_ = Pb, Y_ = N_, W_ = M_, B_ = ke, J_ = G_;
function X_(e) {
  return typeof e == "function" ? e : e == null ? W_ : typeof e == "object" ? B_(e) ? Y_(e[0], e[1]) : H_(e) : J_(e);
}
var Tu = X_;
function Z_(e) {
  return function(r, t, n) {
    for (var a = -1, i = Object(r), c = n(r), o = c.length; o--; ) {
      var u = c[e ? o : ++a];
      if (t(i[u], u, i) === !1)
        break;
    }
    return r;
  };
}
var eS = Z_, rS = eS, tS = rS(), nS = tS, aS = nS, iS = Yt;
function oS(e, r) {
  return e && aS(e, r, iS);
}
var uS = oS, sS = Gt;
function cS(e, r) {
  return function(t, n) {
    if (t == null)
      return t;
    if (!sS(t))
      return e(t, n);
    for (var a = t.length, i = r ? a : -1, c = Object(t); (r ? i-- : ++i < a) && n(c[i], i, c) !== !1; )
      ;
    return t;
  };
}
var fS = cS, lS = uS, dS = fS, pS = dS(lS), wu = pS, vS = wu, hS = Gt;
function yS(e, r) {
  var t = -1, n = hS(e) ? Array(e.length) : [];
  return vS(e, function(a, i, c) {
    n[++t] = r(a, i, c);
  }), n;
}
var gS = yS, mS = ca, bS = Tu, _S = gS, SS = ke;
function ES(e, r) {
  var t = SS(e) ? mS : _S;
  return t(e, bS(r));
}
var OS = ES;
const PS = /* @__PURE__ */ ea(OS);
function rr(e) {
  return typeof e == "object" && Array.isArray(e) && e !== null;
}
function _e(e) {
  return typeof e == "object" && !Array.isArray(e) && e !== null;
}
function at(e) {
  return typeof e == "string";
}
function TS(e) {
  return e !== e;
}
function gr(e) {
  return typeof e == "number" && !TS(e);
}
function wS(e) {
  return typeof e == "symbol";
}
function RS(e) {
  if (!_e(e) || !we(e, "name"))
    return !1;
  const r = "active";
  return !(!we(e, r) || !e[r]);
}
function CS(e) {
  return !(!_e(e) || !st(e, ["id", "name"]));
}
function AS(e) {
  const r = ["red", "green", "blue"];
  if (!_e(e))
    return !1;
  const t = e;
  return !!r.every((n) => gr(t[n]));
}
function IE(e) {
  if (!_e(e))
    return !1;
  const r = "value";
  if (!we(e, r))
    return !1;
  const t = e[r];
  return !(!_e(t) || !st(t, ["colorId", "name"]));
}
function Ru(e) {
  return _e(e) ? Object.keys(e).every((r) => at(r)) && Object.values(e).every((r) => at(r)) : !1;
}
function Cu(e) {
  return !(!CS(e) || !("status" in e) || e.status !== "active");
}
function IS(e) {
  return at(e) || gr(e) || wS(e);
}
const we = (e, r) => IS(r) && r in e;
function st(e, r) {
  return r.every((t) => we(e, t));
}
function xS(e) {
  return !(!_e(e) || !st(e, ["id"]));
}
function Au(e) {
  if (!_e(e) || !we(e, "id"))
    return !1;
  const r = "product";
  return !(!we(e, r) || !_e(e[r]) || !we(e[r], "colorId"));
}
function Iu(e) {
  var r, t;
  return !(!((r = e.design) != null && r.cid) || !((t = e.product) != null && t.colorId) || !e.sizes || Object.keys(e.sizes || {}).length === 0 || !e.totalQuantity || e.totalQuantity === 0);
}
function $S(e) {
  return !(!_e(e) || !st(e, ["id", "name", "colors", "decoration_method"]));
}
function xE(e, r) {
  return !(!rr(r) || !r.find((t) => !(!RS(t) || t.name !== e)));
}
function NS({
  zipCode: e,
  items: r,
  isDesignsLoaded: t
}) {
  if (!e)
    return !1;
  const n = r.filter((i) => Iu(i)), a = r.some((i) => !(i != null && i.createdAt));
  return !(n.length === 0 || !t || a);
}
const so = (e, r) => PS(e, r), xu = (e, r) => !e || !rr(e) ? 0 : e.reduce((t, n) => {
  if (!_e(n) || !we(n, r))
    return t;
  const a = n[r];
  return !a || !gr(a) ? t : t + a;
}, 0), co = (e) => [...new Set(e)], $E = ({
  colors: e,
  colorId: r
}) => {
  if (!(!rr(e) || !gr(r)))
    return e.find((t) => Cu(t) ? t.id === r : !1);
};
function DS(e) {
  const r = "rgbs";
  if (!_e(e) || !we(e, r))
    return;
  const t = e[r];
  if (!rr(t))
    return;
  const n = t.length > 0 ? t[0] : {};
  if (!_e(n))
    return;
  const [a, i, c] = ["red", "green", "blue"];
  if (!we(n, a) || !gr(n[a]) || !we(n, i) || !gr(n[i]) || !we(n, c) || !gr(n[c]))
    return;
  const o = lu(n[a], n[i], n[c]);
  if (!(!at(o) || o.length !== 6))
    return `#${o}`;
}
function MS(e, r, t, n) {
  var a = -1, i = e == null ? 0 : e.length;
  for (n && i && (t = e[++a]); ++a < i; )
    t = r(t, e[a], a, e);
  return t;
}
var jS = MS;
function qS(e, r, t, n, a) {
  return a(e, function(i, c, o) {
    t = n ? (n = !1, i) : r(t, i, c, o);
  }), t;
}
var kS = qS, US = jS, LS = wu, FS = Tu, QS = kS, VS = ke;
function zS(e, r, t) {
  var n = VS(e) ? US : QS, a = arguments.length < 3;
  return n(e, FS(r), t, a, LS);
}
var KS = zS;
const $u = /* @__PURE__ */ ea(KS), GS = (e) => xu(e, "totalQuantity"), NE = (e) => {
  const r = Object.entries(e);
  if (r.length !== 1)
    return;
  const [t, n] = r[0];
  if (n)
    return `${n} ${t}`;
}, DE = (e, r) => {
  const t = (r || []).find(
    (n) => n.name === e
  );
  return !t || t.stock_status !== "in" && t.stock_status !== "low" || t.status !== "active";
}, HS = (e) => xu(e, "quantity");
function ME(e) {
  var t;
  const r = ((t = e.match(/X/g)) == null ? void 0 : t.length) || 0;
  return r < 2 ? e : e.replace(/^X+/, `${r}X`);
}
const Rr = {
  adult: "Adult",
  youth: "Youth",
  oneSize: "Quantity"
};
function jE(e) {
  const r = (n) => /Quan.*|One.*/.test(n), t = (n) => n === "Newborn" || n === "Youth" || n.charAt(0) === "Y" || /^\d.*(M|T)$/.test(n);
  return (e || []).reduce(
    (n, a) => (r(a) ? n[Rr.oneSize].push(a) : t(a) ? n[Rr.youth].push(a) : n[Rr.adult].push(a), n),
    {
      [Rr.youth]: [],
      [Rr.adult]: [],
      [Rr.oneSize]: []
    }
  );
}
function Nu(e) {
  if (!Au(e))
    throw new Error("invalid project item");
  return {
    ...e,
    totalQuantity: HS(e.sizesQuantities),
    sizes: tE(e.sizesQuantities || [])
  };
}
function Gr(e) {
  return rr(e) ? e.reduce((r, t) => {
    if (!Au(t))
      return console.error("invalid project item"), r;
    const n = Nu(t);
    return r.push(n), r;
  }, []) : e;
}
function gt(e) {
  if (!xS(e))
    return {};
  if (!rr(e.items))
    return e;
  const r = Gr(e.items), t = GS(r), n = co(so(r, "product.colorId")), a = co(so(r, "design.cid")).filter(Boolean);
  return {
    ...e,
    colorIds: n,
    designCids: a,
    items: r,
    totalQuantity: t
  };
}
function YS({ complements: e }, r, { styleId: t }) {
  const n = (e || []).find(
    (a) => a.name === "ordering"
  );
  return ((n == null ? void 0 : n.color_ids) || []).map((a) => ({
    colorId: a,
    styleId: t
  }));
}
function WS(e) {
  let r = !1, t = !1;
  const n = (e.views || []).reduce((c, o) => (r = r || o.icons.some((u) => u.type === "NAMES"), t = t || o.icons.some((u) => u.type === "NUMBERS"), c[o.name] = o.colorCount, c), {});
  let a = 0, i = 0;
  return (e.personalization || []).map((c) => {
    a += r && c.name ? 1 : 0, i += t && c.number ? 1 : 0;
  }), { ...e, colorCounts: n, nameCount: a, numberCount: i };
}
function BS(e) {
  return Object.keys(e).reduce((r, t) => (r[t] = WS(e[t]), r), {});
}
function JS(e) {
  const { left_sleeve: r, right_sleeve: t, ...n } = e;
  return { ...n, sleeve: (r || t) && [
    r || 0,
    t || 0
  ] };
}
function Du(e) {
  if (!$S(e))
    throw new Error("invalid response");
  if (!rr(e.colors))
    throw new Error(
      "invalid response, expected product to have an array of colors"
    );
  const r = e.colors.reduce((t, n) => {
    if (!Cu(n))
      return t;
    const a = DS(n);
    if (!a)
      return t;
    const i = {
      colorId: n.id,
      hex: a,
      name: n.name,
      singlesEnabled: n.singles_enabled,
      dtgEnabled: n.dtg_enabled
    };
    if (n.trim_rgb && AS(n.trim_rgb)) {
      const c = lu(
        n.trim_rgb.red,
        n.trim_rgb.green,
        n.trim_rgb.blue
      );
      i.trimRgb = `#${c}`;
    }
    return t.push(i), t;
  }, []);
  return {
    ...e,
    swatches: r
  };
}
function Mu(e) {
  if (!rr(e))
    throw new Error("invalid response, expected products to be an array");
  return e.map((r) => Du(r));
}
function XS(e) {
  if (!rr(e))
    throw new Error("invalid response, expected products to be an array");
  return Mu(e)[0];
}
function ZS(e) {
  return Du(e);
}
function eE(e) {
  const r = "status", t = _e(e) && we(e, r) && e[r] === "ok", n = "wcibmo";
  return { errors: _e(e) && we(e, n) && at(e[n]) ? [e[n]] : [], valid: t };
}
function rE(e, r, t) {
  const n = "surcharges_by_style";
  if (!_e(e) || !we(e, n))
    return {};
  const a = e[n], i = String(t);
  if (!_e(a) || !we(a, i))
    return {};
  const c = a[i];
  return Ru(c) ? c : {};
}
function tE(e) {
  return $u(
    e,
    (r, t) => (t.size && t.quantity && (r[t.size] = t.quantity), r),
    {}
  );
}
function qE(e) {
  return $u(
    e,
    (r, t, n) => (r.push({
      size: n,
      quantity: t
    }), r),
    []
  );
}
function kE({
  projectId: e,
  projectItemId: r
}) {
  return {
    projectId: e,
    projectItemId: r
  };
}
function UE({
  projectId: e,
  projectItem: r
}) {
  return {
    projectId: e,
    projectItem: r
  };
}
function LE({
  projectId: e,
  projectItemId: r,
  projectItem: t
}) {
  return {
    projectId: e,
    projectItemId: r,
    projectItem: t
  };
}
const va = Ut({
  designs: {},
  isLoaded: !1
}), nE = ({ children: e }) => {
  var d;
  const [r, t] = Ir({}), [n, a] = Ir(!1), [i, { data: c }] = Dv(), { data: o } = Wt(), u = !!((d = o == null ? void 0 : o.items) != null && d.length), s = Object.keys(fu((o == null ? void 0 : o.items) || []));
  Ae(() => {
    a(!1), i(s);
  }, [s.join()]), Ae(() => {
    if (u && c) {
      const f = BS(c);
      t(f), a(!0);
    }
  }, [c]);
  const l = be(
    () => ({ designs: r, isLoaded: n }),
    [r, n]
  );
  return /* @__PURE__ */ Ue.jsx(va.Provider, { value: l, children: e });
}, ju = () => Ze(va).designs, FE = (e) => {
  const t = ju()[e], n = ["left_sleeve", "right_sleeve"];
  return ((t == null ? void 0 : t.views) || []).reduce((a, i) => a || n.includes(i.name) && !!i.colorCount, !1);
}, aE = () => Ze(va).isLoaded;
class iE extends us {
  constructor() {
    super(...arguments);
    Pa(this, "state", {
      hasError: !1
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(t) {
    return { hasError: !0 };
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(t, n) {
  }
  render() {
    const { children: t } = this.props;
    return this.state.hasError ? /* @__PURE__ */ Ue.jsx(Ue.Fragment, { children: /* @__PURE__ */ Ue.jsx("h3", { "data-testid": "ErrorBoundary", children: "There was an error loading your cart items, please try again later." }) }) : t;
  }
}
function oE() {
  return je().useGetMultipleQuotesMutation();
}
const QE = () => {
  const e = je(), { projectId: r } = lr(), [t, n] = e.useAssociateProjectMutation();
  return [Le(
    ({
      foreignKey: i,
      foreignType: c,
      sync: o
    }) => t({ projectId: r, foreignKey: i, foreignType: c, sync: o }),
    [r, t]
  ), n];
}, VE = (e = !1) => {
  const r = je(), t = lr(), [n, a] = r.useConvertProjectMutation({
    fixedCacheKey: "singleton"
  });
  return [Le(
    () => n({ projectId: t.projectId, isMultiItemVoucherEnabled: e }),
    [n, t.projectId]
  ), a];
}, uE = () => {
  const { data: e } = Wt(), r = e == null ? void 0 : e.items;
  return r ? r.reduce((t, n) => (n.id && n.sizes && (t[n.id] = n.sizes), t), {}) : {};
}, zE = () => {
  const e = je(), r = lr(), [t, n] = e.useUpdateZipCodeMutation();
  return [Le(
    ({
      zipCode: i,
      syncStrategy: c
    }) => t({ projectId: r.projectId, zipCode: i, syncStrategy: c }),
    [r.projectId, t]
  ), n];
}, KE = () => {
  const e = je(), r = lr(), [t, n] = e.useUpdateVoucherCodeMutation();
  return [Le(
    ({
      voucherCode: i,
      syncStrategy: c
    }) => {
      t({ projectId: r.projectId, voucherCode: i, syncStrategy: c });
    },
    [r.projectId, t]
  ), n];
}, GE = () => {
  const e = je(), { projectId: r } = lr(), [t, n] = e.useUpdateProjectConfigTaxExemptionMutation();
  return [Le(
    (i, c) => t({ projectId: r, taxExemption: i, syncStrategy: c }),
    [r, t]
  ), n];
}, HE = () => {
  const e = je(), { projectId: r } = lr(), [t, n] = e.useUpdateProjectConfigMutation();
  return [Le(
    (i, c) => t({ projectId: r, configuration: i, syncStrategy: c }),
    [r, t]
  ), n];
}, qu = () => {
  const e = je(), r = lr();
  return e.useGetProjectQuery(r.projectId, {
    selectFromResult: ({ data: t, isError: n, isLoading: a, isUninitialized: i }) => {
      var c;
      return {
        isError: n,
        isLoading: a,
        isUninitialized: i,
        zipCode: (c = t == null ? void 0 : t.coreOrder) == null ? void 0 : c.shippingPostalCode
      };
    },
    skip: !r.isSuccess || !r.projectId
  });
}, sE = () => {
  const e = aE(), { zipCode: r } = qu(), { data: t } = Wt(), n = be(() => (t == null ? void 0 : t.items) || [], [t == null ? void 0 : t.items]);
  return NS({ zipCode: r, items: n, isDesignsLoaded: e });
}, qt = (e, r) => {
  if (!(e === null || typeof e != "object")) {
    if (e.hasOwnProperty(r))
      return e[r];
    if (Array.isArray(e))
      for (const t of e) {
        const n = qt(t, r);
        if (n !== void 0)
          return n;
      }
    else
      for (const t in e)
        if (e.hasOwnProperty(t)) {
          const n = qt(e[t], r);
          if (n !== void 0)
            return n;
        }
  }
};
var cE = /* @__PURE__ */ ((e) => (e.STANDARD = "STANDARD", e.QUICKER = "QUICKER", e.RUSH = "RUSH", e.SUPERRUSH = "SUPERRUSH", e))(cE || {});
const fE = "Voucher not found.", fo = "Not a valid voucher code for this order.", YE = {
  MIN_ADDRESS_COUNT: 2,
  SHIPPING_FEE: "9.95"
}, WE = 6;
var ku = /* @__PURE__ */ ((e) => (e.DISCOUNT_VOUCHER = "DISCOUNT_VOUCHER", e.GIFT_VOUCHER = "GIFT_VOUCHER", e))(ku || {}), kt = /* @__PURE__ */ ((e) => (e.AMOUNT = "AMOUNT", e.PERCENT = "PERCENT", e.UNIT = "UNIT", e))(kt || {});
const BE = (e, r) => {
  let t = e, n = $e(0);
  if (r && r.discount)
    switch (r == null ? void 0 : r.discount.type) {
      case kt.AMOUNT:
        n = Nn(
          r == null ? void 0 : r.discount.amountOff
        ), t = e.minus(n);
        break;
      case kt.PERCENT:
        n = t.times(
          Nn(r == null ? void 0 : r.discount.percentOff)
        ), r != null && r.discount.amountLimit && (r == null ? void 0 : r.discount.amountLimit) != 0 && (n = Nn(
          r == null ? void 0 : r.discount.amountLimit
        )), t = e.minus(n);
        break;
    }
  return {
    orderTotal: t.lt(0) ? $e(0).toFixed(2) : t.toFixed(2),
    voucherDiscount: n.toFixed(2)
  };
}, JE = (e, r) => {
  var t;
  if (r)
    return fE;
  if (e && (!dE(e == null ? void 0 : e.metadata.couponType) || !lE(e == null ? void 0 : e.type) || ((t = e == null ? void 0 : e.discount) == null ? void 0 : t.type) === kt.UNIT))
    return fo;
}, Nn = (e) => {
  if (typeof e == "number")
    return $e(e).div(100);
  throw Error;
}, lE = (e) => e === ku.DISCOUNT_VOUCHER, dE = (e) => e === "STORE", Uu = (e = []) => {
  if (!e || e.length === 0)
    return "0.00";
  try {
    const r = e.length > 1, t = e.some(
      (a) => (a == null ? void 0 : a.supports_multidesign) === !1
    );
    return r && t ? "0.00" : e.map((a) => a != null && a.discount ? $e(a.discount) : $e(0)).reduce((a, i) => a.plus(i), $e(0)).toFixed(2);
  } catch {
    return "0.00";
  }
}, pE = (e = []) => {
  var n;
  if (!e || e.length === 0 || e.some((a) => a == null ? void 0 : a.applicable))
    return null;
  const t = e[0];
  return ((n = t == null ? void 0 : t.unsatisfied_criteria) == null ? void 0 : n[0]) || null;
}, vE = (e = []) => {
  if (!e || e.length === 0)
    return null;
  const r = Uu(e), t = parseFloat(r) > 0, a = Lu(e).length > 0;
  return t && a ? "Voucher has been applied to qualifying designs." : null;
}, hE = (e = []) => {
  if (!e || e.length === 0)
    return !1;
  const r = e.some((n) => n == null ? void 0 : n.applicable);
  if (e.length > 1) {
    const n = e.every(
      (a) => (a == null ? void 0 : a.supports_multidesign) !== !1
    );
    return r && n;
  }
  return r;
}, Lu = (e = []) => {
  if (!e || e.length === 0)
    return [];
  const r = e.reduce((t, n) => n != null && n.unsatisfied_criteria && n.unsatisfied_criteria.length > 0 ? [...t, ...n.unsatisfied_criteria] : t, []);
  return [...new Set(r)];
}, yE = (e = []) => !e || e.length === 0 ? !1 : e.some((r) => (r == null ? void 0 : r.supports_multidesign) === !1), Fu = {
  data: {
    grouped: {},
    itemized: {}
  },
  isInvalid: !1,
  isLoading: !1,
  isFetching: !1
}, Qu = Ut(Fu), gE = ({ children: e }) => {
  var _, T, O;
  const [r, t] = Ir(Fu), [
    n,
    { data: a, status: i, error: c }
  ] = oE(), { data: o } = Wt(), u = uE(), s = ju(), l = sE(), d = !!((_ = o == null ? void 0 : o.items) != null && _.length), f = be(() => (o == null ? void 0 : o.items) || [], [o == null ? void 0 : o.items]), p = !c && i === "fulfilled", y = Object.values((a == null ? void 0 : a.grouped) || {}).some((w) => w.wcibmo), v = (T = o == null ? void 0 : o.coreOrder) == null ? void 0 : T.voucherCode, g = p && !y, E = f.some((w) => !(w != null && w.createdAt)), { zipCode: P } = qu(), m = (O = o == null ? void 0 : o.items) == null ? void 0 : O.map((w) => {
    var R;
    return (R = w.product) == null ? void 0 : R.colorId;
  }).join(",");
  Ae(() => {
    l && n({
      designs: s,
      items: f,
      postalCode: P.trim(),
      voucherCode: v
    });
  }, [
    JSON.stringify(u),
    Object.keys(s).join(),
    P,
    m,
    v,
    l
  ]);
  const b = d && g, h = !["fulfilled", "uninitialized"].includes(i) || E;
  return Ae(() => {
    t({
      data: a || r.data,
      isInvalid: !b,
      isLoading: h,
      isFetching: Object.keys(r.data.grouped).length > 0 && h
    });
  }, [a, b, i, E]), /* @__PURE__ */ Ue.jsx(Qu.Provider, { value: r, children: e });
}, tn = () => Ze(Qu), XE = (e) => {
  const { data: r } = tn();
  if (!r)
    throw Error("useItemizedPriceData must be used within a PricingContext");
  return r.itemized[e];
}, ZE = (e) => {
  const [r, t] = Ir(), { data: n } = tn();
  if (!n)
    throw Error("useGroupedPrice must be used within a PricingContext");
  return Ae(() => {
    e && t(e);
  }, [e]), r ? n.grouped[r] : void 0;
}, e0 = (e) => {
  const { data: r, isLoading: t } = tn(), n = r == null ? void 0 : r.grouped[e || ""], a = qt(n, "wcibmo"), i = qt(n, "message");
  return { wcibmo: a, message: i, isLoading: t };
}, r0 = () => {
  const { data: e } = tn(), r = Object.keys((e == null ? void 0 : e.grouped) || {}).map((t) => e.grouped[t].voucher).filter(Boolean);
  return {
    vouchers: r,
    totalDiscount: Uu(r),
    hasApplicableVoucher: hE(r),
    unsatisfiedCriteria: Lu(r),
    error: pE(r),
    doesNotSupportMultiDesign: yE(r),
    partiallyAppliedMessage: vE(r)
  };
}, Cr = (e) => ({
  "client-name": "project-service-cart",
  "client-version": e.appVersion
}), Me = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "staging" || process.env.NODE_ENV === "test";
function mE(e, r, t) {
  if (((a) => _e(e) && Ru(e) && st(e, [
    "postal_code",
    "city",
    "country",
    "state",
    "state_code"
  ]))())
    return {
      city: e.city,
      country: e.country,
      state: e.state,
      stateCode: e.state_code,
      zipCode: e.postal_code
    };
  throw Error(
    `Unexpected response from locations endpoint for zip code ${t == null ? void 0 : t.zipCode}`
  );
}
const bE = (e, r, t) => {
  var i, c;
  const n = t ? (i = r == null ? void 0 : r.tokens) == null ? void 0 : i.accessToken : (c = r == null ? void 0 : r.tokens) == null ? void 0 : c.idToken, a = gl({
    baseQuery: of({
      mode: "cors",
      prepareHeaders: (o) => {
        n && o.set("Authorization", `Bearer ${n}`);
      }
    }),
    tagTypes: ["Project"],
    endpoints: (o) => ({
      getProject: o.query({
        query: (u) => {
          if (!u)
            throw new Error("Missing project id.");
          return {
            credentials: "include",
            url: `${e.projectsUrl}/projects/${u}`
          };
        },
        providesTags: ["Project"],
        transformResponse: gt
      }),
      createProject: o.mutation({
        query: () => ({
          credentials: "include",
          method: "POST",
          url: `${e.projectsUrl}/projects`,
          body: {}
        }),
        transformResponse: gt,
        invalidatesTags: ["Project"]
      }),
      updateZipCode: o.mutation({
        query: ({ projectId: u, zipCode: s, syncStrategy: l }) => ({
          url: `${e.projectsUrl}/projects/${u}`,
          method: "PUT",
          body: {
            coreOrder: {
              shippingPostalCode: s
            }
          },
          params: { sync: l }
        }),
        async onQueryStarted({ projectId: u, zipCode: s }, { dispatch: l, queryFulfilled: d }) {
          l(
            a.util.updateQueryData(
              "getProject",
              u,
              (f) => (f && (f.coreOrder = {
                ...f.coreOrder,
                shippingPostalCode: s
              }), f)
            )
          );
          try {
            await d;
          } catch (f) {
            console.error(
              Me ? f : "Failed to update zip code, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      updateVoucherCode: o.mutation({
        query: ({ projectId: u, voucherCode: s, syncStrategy: l }) => ({
          credentials: "include",
          url: `${e.projectsUrl}/projects/${u}`,
          method: "PUT",
          body: {
            coreOrder: {
              voucherCode: s
            }
          },
          params: { sync: l }
        }),
        async onQueryStarted({ projectId: u, voucherCode: s }, { dispatch: l, queryFulfilled: d }) {
          l(
            a.util.updateQueryData(
              "getProject",
              u,
              (f) => (f && (f.coreOrder = {
                ...f.coreOrder,
                voucherCode: s
              }), f)
            )
          );
          try {
            await d;
          } catch (f) {
            console.error(
              Me ? f : "Failed to update voucher code, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      updateProjectDistributedOrder: o.mutation({
        query: ({ projectId: u, shippingType: s, numberOfAddresses: l }) => ({
          url: `${e.projectsUrl}/projects/${u}`,
          method: "PUT",
          body: {
            configuration: {
              shippingType: s
            },
            coreOrder: {},
            distributedOrder: {
              numberOfAddresses: l
            }
          }
        }),
        async onQueryStarted({ projectId: u, shippingType: s, numberOfAddresses: l }, { dispatch: d, queryFulfilled: f }) {
          d(
            a.util.updateQueryData(
              "getProject",
              u,
              (p) => (p && (p.configuration = {
                ...p.configuration,
                shippingType: s
              }, p.distributedOrder = {
                ...p.distributedOrder,
                numberOfAddresses: l
              }), p)
            )
          );
          try {
            await f;
          } catch (p) {
            console.error(
              Me ? p : "Failed to update shipping type, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      /**
       * @returns the result of updating the project to match the RFE cart
       *
       * It is possible for the response to be entirely different from the project as it was initially loaded,
       * so we cannot dispatch optimistic updates for this endpoint.
       */
      associateProject: o.mutation({
        query: ({ projectId: u, foreignKey: s, foreignType: l, sync: d = "false" }) => {
          if (!u)
            throw new Error("Missing project id.");
          if (!s)
            throw new Error("Missing core order token.");
          return {
            credentials: "include",
            method: "PATCH",
            url: `${e.projectsUrl}/projects/${u}/associate`,
            body: {
              foreignKey: s,
              foreignType: l,
              sync: d
            }
          };
        },
        async onQueryStarted({ projectId: u }, { dispatch: s, queryFulfilled: l }) {
          try {
            const { data: d } = await l;
            s(
              a.util.upsertQueryData(
                "getProject",
                "current",
                gt({ ...d })
              )
            ), s(
              a.util.upsertQueryData(
                "getProject",
                u,
                gt({ ...d })
              )
            );
          } catch (d) {
            console.error(
              Me ? d : "Failed to associate project, refetching..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      convertProject: o.mutation({
        query: ({ projectId: u, isMultiItemVoucherEnabled: s }) => {
          if (!u)
            throw new Error("Missing project id.");
          return {
            credentials: "include",
            method: "POST",
            url: `${e.projectsUrl}/projects/${u}/convert`,
            params: { multiItemVoucher: s }
          };
        },
        async onQueryStarted({ projectId: u }, { dispatch: s, queryFulfilled: l }) {
          try {
            const { data: d } = await l;
            s(
              a.util.updateQueryData(
                "getProject",
                u,
                (f) => {
                  var p, y;
                  return f && (f.coreOrder = {
                    ...f.coreOrder,
                    token: (p = d.coreOrder) == null ? void 0 : p.token,
                    checkoutUrl: (y = d.coreOrder) == null ? void 0 : y.checkoutUrl
                  }), f;
                }
              )
            );
          } catch (d) {
            console.error(
              Me ? d : "Failed to convert project, refetching..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      // TODO: modify api to return only the item that was created.
      // TODO: apply a transformation function to (at a minimum) validate the incoming data types
      createProjectItem: o.mutation({
        query: ({ projectId: u, projectItem: s, syncStrategy: l }) => ({
          credentials: "include",
          url: `${e.projectsUrl}/projects/${u}/items`,
          method: "POST",
          body: s,
          params: { sync: l }
        }),
        async onQueryStarted({ projectId: u, projectItem: s }, { dispatch: l, queryFulfilled: d }) {
          const f = Nv(), p = Nu({
            ...s,
            id: f
          });
          l(
            a.util.updateQueryData(
              "getProject",
              u,
              (y) => (y != null && y.items ? y.items = [...y.items, p] : y && (y.items = [p]), y)
            )
          );
          try {
            const { data: y } = await d;
            l(
              a.util.updateQueryData(
                "getProject",
                u,
                (v) => (v && (v.items = Gr([...y])), v)
              )
            );
          } catch (y) {
            console.error(
              Me ? y : "Failed to create item, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      updateProjectItem: o.mutation({
        query: ({ projectId: u, projectItemId: s, projectItem: l, syncStrategy: d }) => ({
          credentials: "include",
          url: `${e.projectsUrl}/projects/${u}/items/${s}`,
          method: "PUT",
          body: l,
          params: { sync: d }
        }),
        async onQueryStarted({ projectId: u, projectItemId: s, projectItem: l }, { dispatch: d, queryFulfilled: f }) {
          d(
            a.util.updateQueryData(
              "getProject",
              u,
              (p) => {
                const y = [...(p == null ? void 0 : p.items) || []];
                return p != null && p.items && (p.items = Gr(
                  y.map((v) => !v.id || v.id !== s ? v : {
                    ...v,
                    ...l,
                    id: s
                  })
                )), p;
              }
            )
          );
          try {
            await f;
          } catch (p) {
            console.error(
              Me ? p : "Failed to update item, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      updateProjectItems: o.mutation({
        query: ({ updatedProjectItems: u, projectId: s, syncStrategy: l }) => ({
          url: `${e.projectsUrl}/projects/${s}/items`,
          method: "PUT",
          body: u,
          params: { sync: l }
        }),
        async onQueryStarted({ projectId: u, updatedProjectItems: s }, { dispatch: l, queryFulfilled: d }) {
          l(
            a.util.updateQueryData(
              "getProject",
              u,
              (f) => {
                const p = [...(f == null ? void 0 : f.items) || []];
                return f && (f.items = Gr(
                  p.map((y) => {
                    const v = s.find(
                      (g) => y.id && g.id && y.id === g.id
                    );
                    return v ? {
                      ...y,
                      ...v
                    } : y;
                  })
                )), f;
              }
            )
          );
          try {
            await d;
          } catch (f) {
            console.error(
              Me ? f : "Failed to update items, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      deleteProjectItems: o.mutation({
        query: ({ projectId: u, projectItemIds: s, syncStrategy: l }) => ({
          credentials: "include",
          url: `${e.projectsUrl}/projects/${u}/items`,
          method: "DELETE",
          body: s,
          params: { sync: l }
        }),
        async onQueryStarted({ projectId: u, projectItemIds: s }, { dispatch: l, queryFulfilled: d }) {
          l(
            a.util.updateQueryData(
              "getProject",
              u,
              (f) => {
                const p = [...(f == null ? void 0 : f.items) || []];
                return f && (f.items = p.filter(
                  (y) => y.id && !s.includes(y.id)
                )), f;
              }
            )
          );
          try {
            const { data: f } = await d;
            l(
              a.util.updateQueryData(
                "getProject",
                u,
                (p) => (p && (p.items = Gr([...f])), p)
              )
            );
          } catch (f) {
            console.error(
              Me ? f : "Failed to delete item, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      updateProjectConfig: o.mutation({
        query: ({ configuration: u, projectId: s, syncStrategy: l }) => ({
          url: `${e.projectsUrl}/projects/${s}`,
          method: "PUT",
          body: { configuration: u },
          params: { sync: l }
        }),
        async onQueryStarted({ configuration: u, projectId: s }, { dispatch: l, queryFulfilled: d }) {
          l(
            a.util.updateQueryData(
              "getProject",
              s,
              (f) => (f && (f.configuration = {
                ...f.configuration,
                ...u
              }), f)
            )
          );
          try {
            await d;
          } catch (f) {
            console.error(
              Me ? f : "Failed to update project configuration, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      updateProjectConfigTaxExemption: o.mutation({
        query: ({ taxExemption: u, projectId: s, syncStrategy: l }) => ({
          url: `${e.projectsUrl}/projects/${s}`,
          method: "PUT",
          body: {
            configuration: {
              taxExemption: u
            }
          },
          params: { sync: l }
        }),
        async onQueryStarted({ taxExemption: u, projectId: s }, { dispatch: l, queryFulfilled: d }) {
          l(
            a.util.updateQueryData(
              "getProject",
              s,
              (f) => (f && (f.configuration = {
                ...f.configuration,
                taxExemption: u
              }), f)
            )
          );
          try {
            await d;
          } catch (f) {
            console.error(
              Me ? f : "Failed to update tax exemption status, refetching project..."
            ), a.util.invalidateTags(["Project"]);
          }
        }
      }),
      getProduct: o.query({
        query: ({ colorIds: u }) => ({
          url: `${e.productsUrl}/styles.json?color_ids=${u == null ? void 0 : u.join()}`
        }),
        transformResponse: XS
      }),
      getProductByStyleId: o.query({
        query: ({ styleId: u }) => ({
          url: `${e.productsUrl}/styles/${u}`
        }),
        transformResponse: ZS
      }),
      getProducts: o.query({
        query: ({ colorIds: u }) => ({
          url: `${e.productsUrl}/styles.json?color_ids=${u == null ? void 0 : u.join()}`
        }),
        transformResponse: Mu
      }),
      getComplements: o.query({
        query: ({ colorId: u, styleId: s }) => ({
          url: `${e.productsUrl}/styles/${s}/colors/${u}/complements`
        }),
        transformResponse: YS
      }),
      getDesign: o.query({
        query: (u) => ({
          credentials: "include",
          url: `${e.designsUrl}/${u}`,
          params: { api_version: Ca }
        })
      }),
      getMultipleDesigns: o.mutation({
        queryFn: async (u) => {
          const s = {}, l = u.map(
            (d) => fetch(
              `${e.designsUrl}/${d}?api_version=${Ca}`
            ).then((f) => f.json()).then((f) => {
              s[d] = f;
            })
          );
          return await Promise.all(l), { data: s };
        }
      }),
      getCoreOrderCart: o.query({
        query: () => ({
          url: `${e.coreOrderUrl}/api/checkout/cart`,
          params: { include_pricing: !1 }
        })
      }),
      postDistributedOrderUpdate: o.mutation({
        query(u) {
          return {
            body: { distributed_order: u },
            method: "POST",
            url: `${e.coreOrderUrl}/checkout/update_distributed_order`
          };
        }
      }),
      getQuote: o.mutation({
        query: (u) => ({
          body: u,
          credentials: "include",
          method: "POST",
          url: e.quotesUrl
        })
      }),
      // CAUTION: if one styleId is invalid, the entire request will return a 500
      // for this reason, we only ever request surcharges for one style at a time
      getSurcharges: o.query({
        query: (u) => ({
          params: { style_ids: u },
          url: `${e.pricesUrl}/size_surcharges`
        }),
        transformResponse: rE
      }),
      getFullQuote: o.mutation({
        query: (u) => ({
          body: u,
          credentials: "include",
          method: "POST",
          url: `${e.pricesUrl}/quote_widget`
        })
      }),
      // Returns voucher information on success.
      getVoucher: o.query({
        query: (u) => ({
          url: `${e.projectsUrl}/vouchers/${u}`
        })
      }),
      getMultipleQuotes: o.mutation({
        queryFn: async ({ items: u, designs: s, postalCode: l, voucherCode: d }) => {
          const f = {}, p = {}, y = fu(u), v = Object.keys(y).map(
            async (g) => {
              const E = s[g], P = E != null && E.colorCounts ? JS({ ...E == null ? void 0 : E.colorCounts }) : {}, m = y[g], b = m.reduce(
                (O, w) => (O || (O = w.sampleType), O),
                void 0
              ), h = m.reduce(
                (O, w) => {
                  var R;
                  return Iu(w) && O.items.push({
                    product_id: String((R = w.product) == null ? void 0 : R.colorId),
                    sizes: w.sizes || {},
                    name_count: E == null ? void 0 : E.nameCount,
                    number_count: E == null ? void 0 : E.numberCount
                  }), O;
                },
                {
                  items: [],
                  color_counts: P,
                  postal_code: l,
                  sponsorship: !1,
                  upload: !1
                }
              ), T = {
                quote: {
                  ...h,
                  color_counts: JSON.stringify(h.color_counts),
                  items: JSON.stringify(h.items),
                  order_type: b,
                  options: {
                    generate_volume_discount: !0
                  }
                }
              };
              return d && (T.voucher_code = d), fetch(`${e.pricesUrl}/quote_widget`, {
                body: JSON.stringify(T),
                headers: { "content-type": "application/json" },
                method: "POST"
              }).then((O) => O.json()).then((O) => {
                (O.items || []).forEach((w) => {
                  const R = u.find(
                    (C) => {
                      var A, I;
                      return ((A = C.product) == null ? void 0 : A.colorId) === w.product_id && ((I = C.design) == null ? void 0 : I.cid) === g;
                    }
                  );
                  if (R != null && R.id) {
                    f[R.id] = w;
                    const C = w.size_and_quantities_by_unit_price || [], A = Gv(C);
                    w.totalPrice = C.length ? Hv(A) : w.price;
                  }
                }), p[g] = O, zv(p);
              }).catch((O) => {
                console.error(
                  `An error occurred while quoting ${g}: ${O}`
                ), p[g] = {
                  errors: {
                    network: [
                      {
                        code: 1,
                        message: "A pricing error has occurred"
                      }
                    ]
                  },
                  wcibmo: "network_error"
                };
              });
            }
          );
          try {
            return await Promise.all(v), {
              data: {
                grouped: p,
                itemized: f
              }
            };
          } catch (g) {
            return console.error(Me ? g : "Failed to get quotes."), { data: { grouped: {}, itemized: {} } };
          }
        }
      }),
      validateQuote: o.mutation({
        query: (u) => ({
          // The WCIBMO check accepts a string, not a boolean
          body: { quote: u.quote, wcibmo_check: "true" },
          credentials: "include",
          method: "POST",
          url: `${e.pricesUrl}/quote_widget`
        }),
        transformResponse: eE
      }),
      // https://www.customink.com/locations?postal_code=12345
      // TODO: change name to `getZipCode`
      validateZipCode: o.query({
        // Cache zip code queries for 1 hour after component unmount
        // to prevent network errors from causing invalid zip code errors.
        // https://redux-toolkit.js.org/rtk-query/api/createApi#keepunuseddatafor
        keepUnusedDataFor: 3600,
        query: ({ zipCode: u }) => ({
          method: "GET",
          url: `${e.locationsUrl}?postal_code=${u}`
        }),
        transformResponse: mE
      }),
      getAccountTaxExemptionCertificates: o.query({
        query: ({ accountId: u }) => ({
          url: `${e.accountsServiceUrl}/accounts/${u}/tax-exemptions/certificates`,
          headers: Cr(e)
        })
      }),
      getAccountTaxExemptionCustomer: o.query({
        query: ({ accountId: u }) => ({
          url: `${e.accountsServiceUrl}/accounts/${u}/tax-exemptions/customer`,
          headers: Cr(e),
          validateStatus: (s) => s.status === 404 || s.status >= 200 && s.status < 300
        })
      }),
      createOrGetEcommerceToken: o.query({
        query: ({ accountId: u }) => ({
          url: `${e.accountsServiceUrl}/accounts/${u}/tax-exemptions/ecommerce-token`,
          method: "put",
          headers: Cr(e)
        })
      }),
      createAccountTaxExemptionCustomer: o.mutation({
        query: ({ accountId: u, customer: s }) => ({
          url: `${e.accountsServiceUrl}/accounts/${u}/tax-exemptions/customer`,
          headers: Cr(e),
          method: "POST",
          body: s
        })
      }),
      updateAccountTaxExemptionCustomer: o.mutation({
        query: ({ customerId: u, customer: s }) => ({
          url: `${e.accountsServiceUrl}/tax-exemptions/customer/${u}`,
          headers: Cr(e),
          method: "PUT",
          body: s
        })
      }),
      // This REST method is idempotent
      getOrCreateAccountTaxExemptionPortalLink: o.mutation({
        query: ({ accountId: u }) => ({
          url: `${e.accountsServiceUrl}/accounts/${u}/tax-exemptions/cert-express-invites`,
          headers: Cr(e),
          method: "PUT"
        })
      }),
      getPaymentToken: o.query({
        query: () => ({
          credentials: "include",
          url: `${e.coreOrderUrl}/api/checkout/payment_token`
        })
      }),
      getOrderSetTotal: o.query({
        query: () => ({
          credentials: "include",
          url: `${e.coreOrderUrl}/api/checkout/order_set_total`
        })
      }),
      getOrderSetPricingDetails: o.query({
        query: () => ({
          credentials: "include",
          url: `${e.coreOrderUrl}/api/checkout/order_set_pricing_details`
        })
      }),
      verifyShippingAddress: o.mutation({
        query: (u) => ({
          url: `${e.coreOrderUrl}/api/checkout/verify_shipping_address`,
          method: "POST",
          body: u
        })
      }),
      submitApplePayNonce: o.mutation({
        query: ({ payload: u, shipping: s }) => ({
          url: `${e.coreOrderUrl}/api/checkout/update_applepay`,
          method: "POST",
          body: { payload: u, shipping: s }
        })
      })
    })
  });
  return a;
}, _E = {}, SE = new Proxy(_E, {
  get(e, r) {
    const t = { isUninitialized: !0 };
    if (Di(String(r), "Query"))
      return () => t;
    if (Di(String(r), "Mutation"))
      return () => [() => t, {}];
    throw new Error("invalid api hook");
  }
}), EE = new Proxy(
  {},
  {
    get() {
      return "";
    }
  }
), nn = Ut({
  api: SE,
  config: EE
}), je = () => Ze(nn).api, t0 = () => Ze(nn).config, n0 = () => Ze(nn).error;
function a0({
  children: e,
  config: r,
  fallback: t,
  auth: n,
  error: a,
  featureFlags: i
}) {
  const c = be(
    () => bE(r, n, i == null ? void 0 : i.isAuth0Enabled),
    [r, n, i == null ? void 0 : i.isAuth0Enabled]
  ), o = be(
    () => ({
      api: c,
      config: r,
      error: a
    }),
    [c, r, a]
  );
  return /* @__PURE__ */ Ue.jsx(iE, { fallback: t, children: /* @__PURE__ */ Ue.jsx(yl, { api: c, children: /* @__PURE__ */ Ue.jsx(nn.Provider, { value: o, children: /* @__PURE__ */ Ue.jsx(nE, { children: /* @__PURE__ */ Ue.jsx(gE, { children: e }) }) }) }) });
}
export {
  xu as $,
  a0 as A,
  $e as B,
  oE as C,
  nE as D,
  Wt as E,
  AE as F,
  QE as G,
  VE as H,
  uE as I,
  zE as J,
  KE as K,
  GE as L,
  HE as M,
  qu as N,
  sE as O,
  nn as P,
  kt as Q,
  fu as R,
  ji as S,
  cE as T,
  zv as U,
  ku as V,
  Kv as W,
  Gv as X,
  Hv as Y,
  so as Z,
  Ms as _,
  ju as a,
  co as a0,
  $E as a1,
  DS as a2,
  mE as a3,
  $u as a4,
  GS as a5,
  NE as a6,
  DE as a7,
  HS as a8,
  ME as a9,
  AS as aA,
  IE as aB,
  Ru as aC,
  Cu as aD,
  IS as aE,
  we as aF,
  st as aG,
  xS as aH,
  Au as aI,
  Iu as aJ,
  $S as aK,
  xE as aL,
  NS as aM,
  BE as aN,
  JE as aO,
  Nn as aP,
  Uu as aQ,
  pE as aR,
  vE as aS,
  hE as aT,
  Lu as aU,
  yE as aV,
  jE as aa,
  Nu as ab,
  Gr as ac,
  gt as ad,
  YS as ae,
  WS as af,
  BS as ag,
  JS as ah,
  Mu as ai,
  XS as aj,
  ZS as ak,
  eE as al,
  rE as am,
  tE as an,
  qE as ao,
  kE as ap,
  UE as aq,
  LE as ar,
  uu as as,
  CE as at,
  rr as au,
  _e as av,
  TS as aw,
  wS as ax,
  RS as ay,
  CS as az,
  lr as b,
  wE as c,
  gr as d,
  RE as e,
  YE as f,
  _E as g,
  t0 as h,
  at as i,
  n0 as j,
  va as k,
  Me as l,
  FE as m,
  aE as n,
  gE as o,
  Qu as p,
  tn as q,
  XE as r,
  ZE as s,
  e0 as t,
  je as u,
  r0 as v,
  fE as w,
  fo as x,
  WE as y,
  Dv as z
};
//# sourceMappingURL=chunk-6d58b50d.js.map
